/**
 * app.js — גרסת הלקוח של מעצב הכריות.
 * ⚠️ קוד פיתוח בלבד. לא נוגע ב-Shopify ולא באתר החי.
 *
 * ההבדל מהמעבדה (/dev/proto/): כאן אין סליידרים של מגנט, הידוק, נפח
 * או smoothPct. הפרמטרים האלה נעולים על הערכים של האתר החי. הלקוח
 * רואה רק את מה שרלוונטי לו.
 */
(function () {
  'use strict';

  const $ = (id) => document.getElementById(id);
  const S = 1000;   // רזולוציית קנבס התצוגה

  // רזולוציית ה-composite שנשלח למנוע. נמדד: העלות כמעט לינארית
  // בשטח — 1000px עולה ~7.5 שניות חסימה, 700px ~3.8. ראו
  // architecture/perf-generation-cost.md.
  const GEN = 700;

  const MAX_SRC = 1600;         // תקרת רזולוציה לתמונת המקור
  // (12.9, אלעד) 4.5% → 3.5%: הרחבת האזור החוקי לכיתוב. נמדד ("תחלום עליי", רשת 19×19):
  // אוהד ירוק 3→4 מקומות, סבא 2→8, רוכב תרנגול 23→25. עדיין ~1.4 ס"מ בכרית 40.
  let SEAM = 0.035;             // מרווח תפר, כשבר מרוחב הכרית (ניתן לדריסה בבדיקות דרך __pzSeam)
  const G = window.PZSafeArea.G;

  // ═══ איזה backend מסיר את הרקע ═══
  // ברירת המחדל היא ה-mock המקומי — כמו בעמוד המוצר (/). כל קריאה
  // ל-Lambda האמיתי עולה קרדיט Replicate, ולכן המעבר אליו הוא
  // בחירה מפורשת: ?backend=real.
  //
  // ה-mock *מתעלם* מהקובץ שנשלח ומחזיר תמיד את אותה תמונת דוגמה.
  // הוא שימושי לבדיקות אוטומטיות ולעבודה בלי רשת, אבל חסר ערך
  // לבדיקת תמונות אמיתיות — לזה יש את ?backend=real.
  const LAMBDA_REAL = 'https://gsxutyare2eblggdsiemsmnwnq0dwzui.lambda-url.eu-north-1.on.aws/generatemodel';
  const LAMBDA_MOCK = '/__dev/generatemodel';
  // ═══ Lambda הראש (מוצרים 2/3) ═══
  // ?backend=head → ה-Lambda המקומי הנפרד (lambda-head/run_local.py דרך server.js).
  // הוא מחזיר גם heads[] + head_status. בשופיפיי הכתובת תהיה ה-Lambda החדש בענן.
  const LAMBDA_HEAD = '/__dev/generatemodel-head';
  // ═══ הגשר לשופיפיי ═══
  // בשופיפיי הסקשן מזריק window.PZ_CFG: כתובות הנכסים (שהן CDN עם חתימה
  // ולכן לא ניתנות לבנייה מנתיב), כתובת ה-Lambda, ותמונת הדמו.
  // כשהאובייקט חסר — כלומר בסביבה המקומית — הכל נופל לנתיבי /dev/...
  // הקיימים, ולכן זהו אותו קובץ בדיוק בשני המקומות.
  const CFG = window.PZ_CFG || null;
  const ART_URL = (name) => {
    if (!CFG || !CFG.art) return '/dev/proto/templates/' + name;
    const m = name.match(/^(.*)-(art|thumb|print)\.webp$/);
    const e = m && CFG.art[m[1]];
    return (e && e[m[2]]) || '/dev/proto/templates/' + name;
  };
  const BACKEND = CFG ? (CFG.wantHead ? 'head' : 'real')
                      : (new URLSearchParams(location.search).get('backend') || 'mock');   // mock | real | head
  const USE_MOCK = BACKEND === 'mock';
  // פרטים טכניים (אחוזי שקיפות, שם השרת, הנחיות קונסול) מוצגים רק עם ?debug —
  // הלקוח מקבל הודעות בשפה שלו.
  const DEBUG = new URLSearchParams(location.search).has('debug');
  const LAMBDA = (CFG && CFG.lambdaUrl) ? CFG.lambdaUrl
               : BACKEND === 'real' ? LAMBDA_REAL
               : BACKEND === 'head' ? LAMBDA_HEAD : LAMBDA_MOCK;
  // ═══ האם מותר להסתפק בגזרה מלאה במקום ראש חתוך? (אלעד, 11.9) ═══
  // באתר (יש PZ_CFG) — לא. תבנית צוואר בלי ראש חתוך מדביקה גוף שלם על הצוואר,
  // וזה בדיוק מה שנראה כמו "לא חותך את הראש" (קרה כשכתובת ה-Lambda הצביעה על
  // השרת של מוצר 1, שלא יודע לחתוך). בפיתוח מקומי המסלול הזה נשאר פתוח:
  // ?backend=mock מדמה בכוונה את השרת של מוצר 1, וכל סוויטות הבדיקה בנויות עליו.
  // ═══ מתג בדיקות: "לאפשר המשך בלי חיתוך ראש" ═══
  // כבוי כברירת מחדל. כשהוא דולק (הגדרה בעורך התבנית, או ?allow-no-head בפיתוח)
  // כשל בשירות לא חוסם את הזרימה — ממשיכים עם הגזרה המלאה, כמו מוצר 1. זה נועד
  // *לבדיקות* בלבד: לקוח אמיתי לא צריך לראות ראש עם רקע על צוואר.
  const ALLOW_NO_HEAD = CFG ? !!CFG.allowNoHead
                            : new URLSearchParams(location.search).has('allow-no-head');
  const REQUIRE_HEAD = !ALLOW_NO_HEAD && (CFG ? true : BACKEND === 'head');

  // ═══ טקסטים שהחנות תוכל לערוך ═══
  // בשופיפיי הסקשן ימלא window.PZ_COPY מהגדרות ה-schema (עורך התבנית);
  // כאן ברירות המחדל.
  const COPY = Object.assign({
    noFace: 'לא זיהינו פנים בתמונה 🙁 נסו תמונה שבה הפנים ברורות ומופנות למצלמה.',
    noFaceBtn: 'בחירת תמונה אחרת',
    bgFailed: 'לא הצלחנו לעבד את התמונה הזו 🙁 אפשר לנסות שוב, או לבחור תמונה אחרת.',
    serviceDown: 'השירות לא זמין כרגע 🙁 נסו שוב בעוד רגע — התמונה שלכם בסדר.',
    pickTitle: 'מי עולה על הכרית?',
    pickHint: 'לחצו על הפנים שרוצים על הכרית',
    pickFound: 'מצאנו {n} אנשים בתמונה.',
    pickChange: 'החלפת פנים',
    slotsHint: 'לחצו על מספר כדי לבחור את מי מסדרים, והעלו לו תמונה.',
    slotEmpty: 'ריק',
    needAll: 'חסרה תמונה ל־{n} מתוך {total} האנשים בתבנית.',
    autoFilled: 'זיהינו {n} אנשים בתמונה וסידרנו אותם על התבנית. אפשר להחליף כל אחד בנפרד.',
    // ═══ שלב 1 (אלעד, 13.9) ═══ "הצורה" לא אמר ללקוח מה הוא בוחר ומה בא אחריו.
    step1Title: 'בחירת צורה',
    step1Sub: 'בחרו את הדמות שעליה יופיעו הפנים שלכם. בשלב הבא תעלו תמונה.',
    demoBadge: 'דוגמה — כאן יופיעו הפנים שלכם',
  }, window.PZ_COPY || {});

  // ─────────────────────────────────────────────
  //  מצב
  // ─────────────────────────────────────────────
  const state = {
    shape: 'photo',
    userImg: null,
    // trot — הטיית הראש במעלות (אלעד, 10.9). 0 = כמו קודם.
    tx: 0, ty: 0, tscale: 1, trot: 0,
    // sizeRatio = הגודל שמצויר בפועל; sizeWanted = מה שהלקוח ביקש בסליידר.
    // במקום צר הכיתוב מוקטן אוטומטית (sizeRatio < sizeWanted) ומתאושש כשחוזרים לרוחב.
    text: { text: '', font: 'Heebo', color: '#FFFFFF', sizeRatio: .078, sizeWanted: .078, wrapW: .86, x: .5, y: .78, rotation: 0 },
    textAsk: null,   // שאלת הכיתוב (שלב 3): null = עוד לא ענו, 'yes' = העורך פתוח (אלעד, 13.9)
    // שתי הגרסאות של אותה תמונה, כדי שהמעבר ביניהן יהיה מיידי
    // ולא ידרוש העלאה נוספת (ולא קרדיט Replicate נוסף).
    imgNoBg: null, imgWithBg: null, useBg: false,
    pillowColor: '#FFFFFF',
    size: '40 ס״מ - Medium',
    // ═══ מצב דוגמה ═══
    // כשבוחרים צורה לפני שהעלו תמונה, מציגים את הכרית עם תמונת דמו
    // כדי שהלקוח יראה מיד איך זה נראה. isDemo נשאר true עד להעלאה
    // אמיתית, וכל עוד הוא דולק — העגלה נעולה.
    sampleImg: null, sampleEst: null, isDemo: false,
    // ═══ ראש מה-Lambda ═══
    // headResp — התשובה האחרונה שכללה heads (כדי לאפשר "החלפת פנים" בלי העלאה חוזרת).
    headResp: null, headIdx: 0,
    // ═══ הקישור לתמונה ב-S3 (אלעד, 14.9) ═══
    // ה-Lambda מחזיר original_url, ומדווח את אותה כתובת ב-webhook "שימוש במודל".
    // שמירה שלה כאן מאפשרת לשלוח אותה גם ב-webhooks של העגלה, וכך אותה תמונה
    // מקשרת בין "מי עיצב" לבין "מי הוסיף לעגלה / קנה" באותה שורה בגיליון.
    imageUrl: '',
    // ═══ סלוטים ═══
    // לתבנית זוג יש שני צווארים, ולכן שני "אנשים". state.slots הוא מקור האמת
    // לכל הסלוטים; הסלוט הפעיל משתקף גם ב-userImg/tx/ty/tscale כדי שכל קוד
    // הגרירה, הסליידר וההיסטוריה יעבוד בלי שינוי. syncActiveSlot() מסנכרן.
    slots: [{}], activeSlot: 0,
  };

  let templates = [];
  let safeGrid = null;
  let lastValidText = { x: .5, y: .78 };

  const design = $('design');
  const dctx = design.getContext('2d', { willReadFrequently: true });

  const say = (m) => { $('live').textContent = m; };

  // ─────────────────────────────────────────────
  //  סלוטים (אנשים על התבנית)
  // ─────────────────────────────────────────────
  /** כמה אנשים התבנית הנוכחית מקבלת. תבנית רגילה = 1. */
  function slotCount(tpl) {
    const t = tpl || templates.find((x) => x.id === state.shape);
    return (t && t.mode === 'neck' && t.necks && t.necks.length) ? t.necks.length : 1;
  }
  // בדמו הסלוטים מלאים בתמונת הדוגמה — אבל מבחינת "כמה אנשים אמיתיים יש" הם ריקים.
  const slotFilled = (sl) => !state.isDemo && !!(sl && sl.userImg);
  const filledCount = () => state.slots.slice(0, slotCount()).filter(slotFilled).length;
  const allSlotsFilled = () => filledCount() === slotCount();

  /** כותב את המצב הפעיל אל תוך הסלוט שלו. נקרא לפני כל ציור ולפני מעבר סלוט. */
  function syncActiveSlot() {
    const sl = state.slots[state.activeSlot];
    if (!sl) return;
    sl.userImg = state.userImg; sl.imgNoBg = state.imgNoBg; sl.imgWithBg = state.imgWithBg;
    sl.useBg = state.useBg; sl.headEst = state.headEst;
    sl.tx = state.tx; sl.ty = state.ty; sl.tscale = state.tscale; sl.trot = state.trot;
    sl.ax = state.ax; sl.ay = state.ay;
    sl.origFile = state.origFile || null;
    sl.hdy = state.hdy || 0;
  }

  /** טוען סלוט אל המצב הפעיל (ההפך מ-syncActiveSlot). */
  function loadSlot(i) {
    const sl = state.slots[i] || (state.slots[i] = {});
    state.activeSlot = i;
    state.userImg = sl.userImg || null; state.imgNoBg = sl.imgNoBg || null;
    state.imgWithBg = sl.imgWithBg || null; state.useBg = !!sl.useBg;
    state.headEst = sl.headEst || null;
    state.tx = sl.tx || 0; state.ty = sl.ty || 0; state.tscale = sl.tscale || 1; state.trot = sl.trot || 0;
    state.ax = sl.ax; state.ay = sl.ay;
    state.origFile = sl.origFile || null;
    state.hdy = sl.hdy || 0;
  }

  /** מתאים את מספר הסלוטים לתבנית הנוכחית, בלי לאבד תמונות שכבר הועלו. */
  function resizeSlots() {
    const n = slotCount();
    syncActiveSlot();
    while (state.slots.length < n) state.slots.push({});
    if (state.slots.length > n) state.slots.length = n;
    if (state.activeSlot >= n) state.activeSlot = 0;
    // הסלוט הפעיל הראשון הריק — כדי שההעלאה הבאה תלך למקום ההגיוני
    const empty = state.slots.findIndex((sl) => !slotFilled(sl));
    if (!slotFilled(state.slots[state.activeSlot]) && empty >= 0) state.activeSlot = empty;
    loadSlot(state.activeSlot);
  }

  // ─────────────────────────────────────────────
  //  עזרי תמונה
  // ─────────────────────────────────────────────
  const loadImg = (src) => new Promise((res, rej) => {
    const i = new Image();
    i.crossOrigin = 'anonymous';
    i.onload = () => res(i);
    i.onerror = () => rej(new Error('התמונה לא נטענה'));
    i.src = src;
  });

  // תמונת טלפון היא 12 מגה-פיקסל. ציור שלה בכל pointermove הוא עשרות
  // מיליוני פיקסלים בשנייה וה-UI נראה תקוע. מקטינים פעם אחת מראש.
  async function downscale(img) {
    const big = Math.max(img.naturalWidth, img.naturalHeight);
    if (big <= MAX_SRC) return img;
    const k = MAX_SRC / big;
    const c = document.createElement('canvas');
    c.width = Math.round(img.naturalWidth * k);
    c.height = Math.round(img.naturalHeight * k);
    c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
    return loadImg(c.toDataURL('image/png'));
  }

  // ─────────────────────────────────────────────
  //  ההרכבה
  // ─────────────────────────────────────────────
  /** מצייר את התמונה והתבנית בלבד — בלי הכיתוב. זה מה שקובע את הסילואט. */
  // ═══ נרמול תבניות ═══
  // FIT הוא החלק מהקנבס שהצורה תופסת. פחות מ-1 מבטיח שוליים —
  // בלעדיהם הקונטור נחתך בקצה הקנבס והמנוע בונה צורה קטומה.
  const FIT = 0.84;
  // ═══ מצב "צוואר" (neck) ═══
  // האיור נגמר בצוואר חתוך ישר; הראש האמיתי של הלקוח יושב *מעליו* (ולא בתוך חור).
  // גודל הראש נגזר אוטומטית מרוחב הצוואר; הסנטר יושב מעט מתחת לקצה הצוואר כדי לכסות את החיתוך.
  // ═══ גודל הראש: 40%–95%, ברירת מחדל 70% (אלעד, 12.9) ═══
  // הראש מקובע על הצוואר ואי אפשר להזיז אותו — רק להגדיל/להקטין בטווח הזה.
  const HEAD_MIN = 0.40, HEAD_MAX = 0.95, HEAD_DEFAULT = 0.70;
  const clampHead = (v) => Math.min(HEAD_MAX, Math.max(HEAD_MIN, v));
  const NECK_HEAD_RATIO = 2.8;     // רוחב ראש (כולל שיער) ≈ 2.8 × רוחב צוואר — ראש דומיננטי, הדמות קטנה יחסית
  const NECK_OVERLAP = 0.25;       // הסנטר יורד 25% מרוחב הצוואר מתחת לקצה — חפיפה שמסתירה את קו החיתוך
  const NECK_HEAD_H = 1.35;        // גובה תיבת הראש הצפויה (לנרמול/FIT) ביחס לרוחבה — מקום לשיער

  // ═══ ראש שחורג מגבולות הכרית ═══
  // הלקוח יכול להגדיל את הראש מעבר למסגרת. בלי טיפול הראש פשוט נחתך בקצה
  // הקנבס, והמנוע בונה סילואט קטום. הפתרון: מודדים את תיבת הגבול של
  // *כל* ההרכבה (איור + כל ראש מלא) ומקטינים אותה כמקשה אחת עד שהיא
  // נכנסת ל-FIT. כך צורת הכרית עוקבת אחרי הראש במקום לחתוך אותו.
  // COMP_MIN_K הוא הרצפה: האיור לא יקטן מתחת ל-30% מגודלו (איבוד 70%).
  const COMP_MIN_K = 0.30;
  // מעל הסטייה הזו בתיבת ההרכבה (ביחידות קנבס) שווה לבנות את הגיאומטריה
  // מחדש. מתחתיה — רק הטקסטורה מתעדכנת, וזה כמעט חינם.
  const COMP_REBUILD_EPS = 0.015;

  /** תיבת הגבול המאוחדת של האלפא, ביחידות 0..1. */
  function alphaBox(a, b, hole, necks) {
    const N = 200;
    const c = document.createElement('canvas');
    c.width = c.height = N;
    const x = c.getContext('2d', { willReadFrequently: true });
    x.clearRect(0, 0, N, N);
    if (a) x.drawImage(a, 0, 0, N, N);
    if (b && b !== a) x.drawImage(b, 0, 0, N, N);
    const d = x.getImageData(0, 0, N, N).data;
    let x0 = N, y0 = N, x1 = -1, y1 = -1;
    for (let yy = 0; yy < N; yy++) {
      for (let xx = 0; xx < N; xx++) {
        if (d[(yy * N + xx) * 4 + 3] > 12) {
          if (xx < x0) x0 = xx; if (xx > x1) x1 = xx;
          if (yy < y0) y0 = yy; if (yy > y1) y1 = yy;
        }
      }
    }
    if (x1 < 0) return { x0: 0, y0: 0, x1: 1, y1: 1, s: 1, dx: 0, dy: 0 };
    const f = { x0: x0 / N, y0: y0 / N, x1: (x1 + 1) / N, y1: (y1 + 1) / N };
    // תיבת האלפא של האיור *לבדה*, לפני שמרחיבים אותה בשביל הראש הצפוי.
    // compFit צריך את זה: הראש האמיתי מגיע ממנו, לא מהתיבה המורחבת.
    f.ax0 = f.x0; f.ay0 = f.y0; f.ax1 = f.x1; f.ay1 = f.y1;

    // ═══ חור הפנים הוא חלק מההרכבה ═══
    // בגיבור הראש *אינו* באמנות — האמנות מתחילה בצוואר, והתמונה של
    // הלקוח היא שמשלימה את הראש. לכן החור יושב מעל תיבת האמנות.
    // בלי לכלול אותו כאן, הנרמול ממרכז רק את הגוף והראש נדחק אל מחוץ
    // למסגרת — בדיוק מה שגרם ל"החור לא עגול ולא במקום".
    if (hole) {
      const hr = holeRadii(hole);
      f.x0 = Math.min(f.x0, hole.cx - hr.rx);
      f.x1 = Math.max(f.x1, hole.cx + hr.rx);
      f.y0 = Math.min(f.y0, hole.cy - hr.ry);
      f.y1 = Math.max(f.y1, hole.cy + hr.ry);
    }
    // ═══ צוואר: הראש הצפוי יושב מעל האיור ═══
    // בלי לכלול את תיבת הראש כאן, הנרמול ממרכז את הגוף לבד והראש נחתך בקצה הקנבס.
    for (const neck of (necks || [])) {
      const hw = NECK_HEAD_RATIO * neck.nw, hh = hw * NECK_HEAD_H;
      f.x0 = Math.min(f.x0, neck.nx - hw / 2);
      f.x1 = Math.max(f.x1, neck.nx + hw / 2);
      f.y0 = Math.min(f.y0, neck.ny + NECK_OVERLAP * neck.nw - hh);
    }
    const bw = f.x1 - f.x0, bh = f.y1 - f.y0;
    f.s = FIT / Math.max(bw, bh);                    // מקדם הגדלה
    f.dx = 0.5 - ((f.x0 + f.x1) / 2) * f.s;          // הזזה למרכז
    f.dy = 0.5 - ((f.y0 + f.y1) / 2) * f.s;
    return f;
  }

  /** מצייר תמונת תבנית דרך הנרמול. */
  function drawFitted(ctx, img, Z, f) {
    if (!img) return;
    ctx.drawImage(img, f.dx * Z, f.dy * Z, Z * f.s, Z * f.s);
  }

  // ═══ חור הפנים: עיגול או אליפסה ═══
  // התבניות הראשונות הוגדרו עם r (עיגול). הדמויות המצוירות מגיעות עם חור
  // אליפטי — גבוה מרוחב (ראש). עיגול בתוך אליפסה משאיר פסים שקופים מעל
  // ומתחת לפנים (והצורה נקרעת שם); עיגול סביבה גולש מחוץ לאוזניים.
  // לכן: rx/ry אם קיימים, אחרת r לשניהם. r ממשיך להתקיים כ"הרדיוס הגדול".
  function holeRadii(h) {
    const rx = h.rx != null ? h.rx : h.r;
    const ry = h.ry != null ? h.ry : h.r;
    return { rx: rx, ry: ry, r: Math.max(rx, ry) };
  }

  /** נקודת העיגון של הצוואר אחרי הנרמול: מרכז קצה הצוואר (nx, ny) ורוחבו (nw). */
  function fittedNeck(tpl, i) {
    const f = tpl.fit, n = tpl.necks[Math.min(i || 0, tpl.necks.length - 1)];
    return { nx: n.nx * f.s + f.dx, ny: n.ny * f.s + f.dy, nw: n.nw * f.s };
  }

  // ═══ התאמת ההרכבה כשהראש חורג ═══
  // מחזיר {k, ox, oy}: הטרנספורם שצריך להחיל על *כל* ההרכבה (איור + ראשים)
  // כדי שהיא תיכנס ל-FIT. k=1 כשהכל נכנס — כלומר אפס שינוי בהתנהגות הקיימת.
  // חשבון מלבנים בלבד: אין קריאת פיקסלים ואין הקצאות, ולכן זה זניח בכל פריים.
  function compFit(tpl) {
    const NONE = { k: 1, ox: 0, oy: 0, box: null };
    if (!tpl || tpl.mode !== 'neck' || !tpl.fit) return NONE;
    syncActiveSlot();          // הסלוט הפעיל הוא המראה של state.tx/ty/tscale
    const f = tpl.fit;
    const parts = [[f.ax0 * f.s + f.dx, f.ay0 * f.s + f.dy, f.ax1 * f.s + f.dx, f.ay1 * f.s + f.dy]];
    let X0 = parts[0][0], Y0 = parts[0][1], X1 = parts[0][2], Y1 = parts[0][3];
    let any = false;
    for (let i = 0; i < slotCount(tpl); i++) {
      const sl = state.slots[i];
      if (!sl || !sl.userImg) continue;
      const img = sl.userImg, m = Math.max(img.width, img.height);
      const ts = sl.tscale || 1;
      let w = img.width / m * ts, h = img.height / m * ts;
      // ═══ ראש מוטה ═══
      // הראש הוא גזרה (פינות שקופות), כלומר בקירוב אליפסה חסומה במלבן
      // התמונה — לא המלבן עצמו. לכן התיבה שלו אחרי סיבוב היא התיבה של
      // *אליפסה מסובבת*: עיגול לא גדל בכלל, ראש מוארך גדל מעט. התיבה של
      // המלבן המסובב הייתה גדלה עד 41% ומכווצת את כל הכרית (ובונה מחדש)
      // על כל הטיה קטנה — בלי סיבה אמיתית.
      if (sl.trot) {
        const a = sl.trot * Math.PI / 180, c = Math.cos(a), sn = Math.sin(a);
        const hw = w / 2, hh = h / 2;
        w = 2 * Math.sqrt(hw * hw * c * c + hh * hh * sn * sn);
        h = 2 * Math.sqrt(hw * hw * sn * sn + hh * hh * c * c);
      }
      // מיקום העיגון, לא מיקום הגרירה: גרירה לא משנה את ההרכבה (ראו recenterPhoto).
      const ax = sl.ax != null ? sl.ax : (sl.tx || 0), ay = sl.ay != null ? sl.ay : (sl.ty || 0);
      const cx = 0.5 + ax / S, cy = 0.5 + ay / S;
      parts.push([cx - w / 2, cy - h / 2, cx + w / 2, cy + h / 2]);
      X0 = Math.min(X0, cx - w / 2); X1 = Math.max(X1, cx + w / 2);
      Y0 = Math.min(Y0, cy - h / 2); Y1 = Math.max(Y1, cy + h / 2);
      any = true;
    }
    if (!any) return NONE;
    const span = Math.max(X1 - X0, Y1 - Y0);
    NONE.span = span;
    let k = 1, ox = 0, oy = 0;
    if (span > FIT) {                                   // חורג — מקטינים כמקשה אחת וממרכזים
      k = Math.max(COMP_MIN_K, FIT / span);
      ox = 0.5 - ((X0 + X1) / 2) * k;
      oy = 0.5 - ((Y0 + Y1) / 2) * k;
    }
    // המלבנים כפי שהם *מצוירים* בפועל — האיור וכל ראש. הם שקובעים את הסילואט.
    // חשוב שזה יהיה לפי חלקים ולא רק תיבה חיצונית: כשההרכבה כבר מוקטנת,
    // התיבה החיצונית תמיד שווה ל-FIT, אבל היחס בין הראש לאיור ממשיך להשתנות.
    return { k: k, ox: ox, oy: oy, span: span,
             box: [X0 * k + ox, Y0 * k + oy, X1 * k + ox, Y1 * k + oy],
             parts: parts.map((r) => [r[0] * k + ox, r[1] * k + oy, r[2] * k + ox, r[3] * k + oy]) };
  }

  /** מקדם ההקטנה הנוכחי — לפיצוי הגרירה. */
  function dragCompK() {
    const tpl = templates.find((t) => t.id === state.shape);
    return compFit(tpl).k || 1;
  }

  // ═══ הגבול העליון האמיתי של הגדלת הראש ═══
  // מעבר לרצפת ההקטנה (COMP_MIN_K) אין יותר מה לעשות: ההרכבה כבר לא
  // נכנסת למסגרת והראש פשוט ייחתך בקצה הקנבס — כלומר הדפסה פגומה.
  // לכן מגבילים את ההגדלה בדיוק לנקודה הזו, במקום לתת ללקוח לחתוך את עצמו.
  const COMP_MAX_SPAN = () => FIT / COMP_MIN_K;
  function clampScaleToComp() {
    const tpl = templates.find((t) => t.id === state.shape);
    if (!tpl || tpl.mode !== 'neck') return false;
    const lim = COMP_MAX_SPAN();
    if ((compFit(tpl).span || 0) <= lim) return false;
    let lo = 0.2, hi = state.tscale;
    for (let i = 0; i < 16; i++) {
      const mid = (lo + hi) / 2;
      state.tscale = mid;
      if ((compFit(tpl).span || 0) <= lim) lo = mid; else hi = mid;
    }
    state.tscale = lo;
    syncActiveSlot();
    return true;
  }

  /** האם תיבת ההרכבה זזה מספיק מאז הבנייה האחרונה כדי להצדיק בנייה מחדש. */
  let builtCompK = null;
  let buildCount = 0;
  // ═══ מתי *באמת* שווה לבנות גיאומטריה מחדש ═══
  // גרירה של הראש בתוך המסגרת לא משנה את מעטפת ההרכבה — היא רק מזיזה
  // ציור על אותה כרית, וזה נשאר עדכון טקסטורה חי (≈1ms) כמו שהיה תמיד.
  // מה שכן משנה את הצורה הוא שינוי *המעטפת*: הראש גדל וההרכבה נאלצת
  // להתכווץ (k יורד) או להפך. רק שם משלמים בנייה מלאה (≈2.2 שניות).
  function compBoxMoved(tpl) {
    const c = compFit(tpl);
    if (!c.parts) return false;
    if (builtCompK == null) return true;
    return Math.abs(c.k - builtCompK) > COMP_REBUILD_EPS;
  }

  /** מיקום חור הפנים אחרי הנרמול. */
  function fittedHole(tpl) {
    const f = tpl.fit, h = tpl.faceHole, hr = holeRadii(h);
    return { cx: h.cx * f.s + f.dx, cy: h.cy * f.s + f.dy, r: hr.r * f.s, rx: hr.rx * f.s, ry: hr.ry * f.s };
  }

  // ═══ בסיס הבד ═══
  // המנוע גוזר את הצורה מערוץ האלפא. אם באזור כלשהו בתוך הצורה יש
  // שקיפות — הצורה נקרעת שם, והקונטור יוצא גוש חסר משמעות.
  //
  // זה בדיוק מה שקרה ללב: ההרכבה נראתה לב מושלם, אבל *האלפא* שלה
  // הייתה קו מתאר לבן ועוד כמה כתמים, עם חורים גדולים ביניהם.
  //
  // הפתרון הוא גם הנכון מבחינת המוצר: מה שהתמונה לא מכסה הוא פשוט
  // בד. ממלאים את הצורה בצבע הכרית לפני שמציירים עליה.
  let baseCache = null;
  function fillMask(maskImg, Z, color, f) {
    const key = Z + '|' + color;
    if (!baseCache || baseCache.key !== key || baseCache.mask !== maskImg) {
      const c = document.createElement('canvas');
      c.width = c.height = Z;
      const x = c.getContext('2d');
      drawFitted(x, maskImg, Z, f);
      x.globalCompositeOperation = 'source-in';
      x.fillStyle = color;
      x.fillRect(0, 0, Z, Z);
      baseCache = { key: key, mask: maskImg, canvas: c };
    }
    return baseCache.canvas;
  }

  /** מצייר את התמונה והתבנית בלבד — בלי הכיתוב. זה מה שקובע את הסילואט. */
  function drawArt(ctx, Z) {
    const k = Z / S;
    ctx.clearRect(0, 0, Z, Z);
    syncActiveSlot();
    const tpl = templates.find((t) => t.id === state.shape);
    if (!state.userImg && !state.slots.some(slotFilled)) return;
    if (tpl && !tpl.fit) return;   // טעינה עצלה — עוד אין מה לצייר

    // rot — הטיית הראש במעלות, סביב מרכזו. 0 (ברירת המחדל) = הציור הישן בדיוק.
    const drawOne = (img, tx, ty, tscale, rot) => {
      if (!img) return;
      const base = Z / Math.max(img.width, img.height);
      const w = img.width * base * tscale, h = img.height * base * tscale;
      ctx.save();
      ctx.translate(Z / 2 + tx * k, Z / 2 + ty * k);
      if (rot) ctx.rotate(rot * Math.PI / 180);
      ctx.drawImage(img, -w / 2, -h / 2, w, h);
      ctx.restore();
    };
    const drawUser = () => drawOne(state.userImg, state.tx, state.ty, state.tscale, state.trot);

    if (!tpl || tpl.mode === 'photo') {
      // ═══ הצורה *היא* התמונה ═══
      // ולכן אין לתוכה מה למקם. גרירה כאן רק דוחפת חלקים מהתמונה
      // אל מחוץ לריבוע ההרכבה, שם הם נחתכים — והתוצאה היא צורה
      // קטומה ולא סימטרית, שהמנוע ממרכז לפי מה שנשאר ממנה.
      // זה בדיוק מה שנראה כמו "הכרית יצאה הצידה".
      //
      // לכן: מתאימים את התמונה למסגרת, במרכז, עם שוליים שמבטיחים
      // שהקונטור לא ייגע בקצה.
      const img = state.userImg;
      const k2 = Math.min(Z * FIT / img.width, Z * FIT / img.height) * state.tscale;
      const w = img.width * k2, h = img.height * k2;
      ctx.drawImage(img, (Z - w) / 2, (Z - h) / 2, w, h);
      return;
    }

    if (tpl.mode === 'fill') {
      ctx.drawImage(fillMask(tpl.maskImg, Z, state.pillowColor, tpl.fit), 0, 0);
      drawUser();
      ctx.save();
      ctx.globalCompositeOperation = 'destination-in';
      drawFitted(ctx, tpl.maskImg, Z, tpl.fit);
      ctx.restore();
      if (tpl.artOnTop && tpl.artImg) drawFitted(ctx, tpl.artImg, Z, tpl.fit);
      return;
    }

    if (tpl.mode === 'neck') {
      // ═══ צוואר: האיור מתחת, הראשים מעל ═══
      // אין חור ואין מילוי — הסילואט הוא איחוד האיור והראשים (כולל השיער האמיתי).
      // מציירים כל סלוט מלא, כך שתבנית זוג מקבלת שני ראשים שונים.
      //
      // ═══ ראש שחורג ═══
      // compFit מחזיר k=1 כשההרכבה נכנסת למסגרת — ואז זה בדיוק הציור הישן.
      // כשהראש גדול מדי, מקטינים את האיור *ואת* הראשים באותו יחס, כך
      // שהיחס ביניהם נשמר והסילואט של הכרית עוקב אחרי הראש.
      const cf = compFit(tpl);
      ctx.save();
      if (cf.k !== 1) { ctx.translate(cf.ox * Z, cf.oy * Z); ctx.scale(cf.k, cf.k); }
      drawFitted(ctx, tpl.artImg, Z, tpl.fit);
      for (let i = 0; i < slotCount(tpl); i++) {
        const sl = state.slots[i];
        if (sl && sl.userImg) drawOne(sl.userImg, sl.tx || 0, sl.ty || 0, sl.tscale || 1, sl.trot || 0);
      }
      ctx.restore();
      return;
    }

    // mode === 'face' — גם כאן: תמונה שלא ממלאת את החור משאירה חלל
    // שקוף בראש, והצורה משתנה. ממלאים קודם.
    if (!tpl.artOnTop) drawFitted(ctx, tpl.artImg, Z, tpl.fit);
    const fh = fittedHole(tpl);
    ctx.save();
    ctx.beginPath();
    ctx.ellipse(fh.cx * Z, fh.cy * Z, fh.rx * Z, fh.ry * Z, 0, 0, Math.PI * 2);
    ctx.clip();
    ctx.fillStyle = state.pillowColor;
    ctx.fillRect(0, 0, Z, Z);
    drawUser();
    ctx.restore();
    if (tpl.artOnTop) drawFitted(ctx, tpl.artImg, Z, tpl.fit);
  }

  /** ההרכבה המלאה: אמנות + כיתוב. זה מה שמודפס. */
  function composite(ctx, Z) {
    drawArt(ctx, Z);
    window.PZText.draw(ctx, Z, state.text);
  }

  // ═══ האזור הבטוח ═══
  // נבנה מחדש רק כשהאמנות משתנה (תמונה, תבנית, מיקום התמונה) — לא
  // בכל תו שמקלידים. זו הפעולה היקרה כאן.
  function rebuildSafeGrid() {
    if (!state.userImg) { safeGrid = null; return; }
    const c = document.createElement('canvas');
    c.width = c.height = G;
    drawArt(c.getContext('2d', { willReadFrequently: true }), G);
    safeGrid = window.PZSafeArea.makeGrid(c, SEAM);
  }

  /** כמה פיקסלים של הכיתוב חורגים מהאזור הבטוח. 0 = תקין. */
  function textViolations(candidate) {
    if (!safeGrid || !state.text.text.trim()) return 0;
    const probe = Object.assign({}, state.text, candidate || {});
    return window.PZSafeArea.violations(safeGrid, window.PZText.maskCanvas(G, probe));
  }

  /**
   * מיקום ההתחלה של הכיתוב.
   * סורק מלמטה למעלה ובוחר את המקום הנמוך ביותר שבו הכיתוב נכנס
   * במלואו — בדיוק כמו ברפרנס, שם ההקדשה יושבת מתחת לתמונה.
   */
  function bestTextSpot() {
    const xs = [.5, .45, .55, .40, .60];
    for (let y = .90; y >= .10; y -= .02) {
      for (const x of xs) {
        if (textViolations({ x: x, y: y }) === 0) return { x: x, y: y };
      }
    }
    return null;
  }

  // ═══ מיקום הכיתוב: הגודל עוקב אחרי המקום (אלעד, 12.9) ═══
  // הבעיה שנמדדה: בדמות עומדת, האזור הבטוח (הסילואט פחות מרווח התפר) הוא עמוד צר,
  // והגודל נבחר כגדול ביותר שנכנס — ולכן נשאר *מיקום חוקי אחד* בכל הכרית, והכיתוב
  // הרגיש "דבוק". הפתרון: במקום לדחות מיקום, מקטינים את הכיתוב עד שהוא נכנס שם
  // (עד TEXT_MIN_RATIO), ואם גם זה לא — מחליקים לפי ציר במקום לא לזוז בכלל.
  // הכלל הקשה נשמר: הכיתוב לעולם לא יוצא מהסילואט (מגן על ההדפסה).
  const TEXT_MIN_RATIO = 0.030;          // כמו מינימום הסליידר
  const wantedRatio = () => state.text.sizeWanted != null ? state.text.sizeWanted : state.text.sizeRatio;

  // ═══ למה גם *רוחב גלישה* ולא רק גודל ═══
  // מדידה (12.9, אוהד ירוק): הכרית היא 18% מהקנבס, והכיתוב "תחלום עליי" בשורה
  // אחת רחב 0.36 מהקנבס — רחב מכל הגוף. הקטנת הגודל לבד מגיעה ל-0.14 וזה עדיין
  // רחב מהמסדרון הבטוח. לכן מחפשים גם *פריסה* צרה יותר: אותו גודל בשתיים-שלוש
  // שורות צר בהרבה, ונראה מכוון — בעוד כיתוב זעיר בשורה אחת נראה כמו תקלה.
  // סדר העדפה: הגודל שהלקוח ביקש קודם, ובתוכו הפריסה הרחבה (מעט שורות) קודם.
  const WRAPS = [0.86, 0.52, 0.36, 0.26, 0.20];
  const SIZE_STEPS = [1, 0.88, 0.76, 0.64, 0.52, 0.42];

  /** מחזיר {sizeRatio, wrapW} הטוב ביותר שנכנס במיקום, או null אם אין. */
  function bestFitAt(pos) {
    if (!safeGrid || !state.text.text.trim()) return { sizeRatio: wantedRatio(), wrapW: state.text.wrapW };
    const want = wantedRatio();
    for (const sf of SIZE_STEPS) {
      const r = Math.max(TEXT_MIN_RATIO, want * sf);
      for (const w of WRAPS) {
        const probe = { x: pos.x, y: pos.y, sizeRatio: r, wrapW: w };
        // פריסה שחותכת מילים (MAX_LINES) אסורה — הלקוח היה מקבל כיתוב קטוע
        const m = window.PZText.measureLayout(window.PZSafeArea.G,
          Object.assign({}, state.text, probe));
        if (!m.complete) continue;
        if (textViolations(probe) === 0) return { sizeRatio: r, wrapW: w };
      }
      if (r <= TEXT_MIN_RATIO) break;
    }
    return null;
  }
  /** תאימות לאחור לקוד/בדיקות שמבקשים רק גודל. */
  function bestRatioAt(pos) { const f = bestFitAt(pos); return f ? f.sizeRatio : null; }

  function applyTextPlacement(pos, fit) {
    const ratio = typeof fit === 'number' ? fit : fit.sizeRatio;
    state.text.x = pos.x; state.text.y = pos.y; state.text.sizeRatio = ratio;
    if (fit && typeof fit === 'object' && fit.wrapW != null) state.text.wrapW = fit.wrapW;
    lastValidText = { x: pos.x, y: pos.y };
    syncSizeSlider();
    // הסבר ללקוח *למה* הכיתוב קטן כאן — אחרת זה נראה כמו באג
    const shrunk = ratio < wantedRatio() - 1e-6;
    const hint = $('boundsHint');
    if (hint) {
      hint.classList.toggle('hidden', !shrunk);
      if (shrunk) hint.querySelector('span:last-child').textContent =
        'הכיתוב הוקטן כדי להיכנס במקום הזה. במקום רחב יותר הוא יחזור לגודל שבחרתם.';
    }
  }

  /**
   * מנסה למקם את הכיתוב ב-pos. מחזיר true אם זז.
   * סדר הניסיונות: המיקום המבוקש → תזוזה בציר X בלבד → בציר Y בלבד ("החלקה" לאורך הגוף).
   */
  function placeText(pos) {
    const f = bestFitAt(pos);
    if (f) { applyTextPlacement(pos, f); return true; }
    const onlyX = { x: pos.x, y: state.text.y };
    const fx = bestFitAt(onlyX);
    if (fx) { applyTextPlacement(onlyX, fx); return true; }
    const onlyY = { x: state.text.x, y: pos.y };
    const fy = bestFitAt(onlyY);
    if (fy) { applyTextPlacement(onlyY, fy); return true; }
    return false;
  }

  // ═══ מובייל: האצבע היא היעד (אלעד, 12.9) ═══
  // נמדד: במובייל הגרירה היחסית "לא עבדה" — המגע הגיע (pointermove ×15), אבל
  // הכיתוב כבר ישב בנקודה הנמוכה ביותר שנכנסת, וכל צעד קטן שלא נכנס נדחה בשקט.
  // במקום "כמה האצבע זזה" — "איפה האצבע": הכיתוב עובר לנקודה החוקית הקרובה
  // ביותר לאצבע, בגודל הגדול ביותר שנכנס שם. כך כל נגיעה על הבמה מזיזה אותו.
  //
  // איך זה מהיר: לכל צירוף (גודל × גלישה) בונים פעם אחת "מפת מרכזים חוקיים" —
  // מרכז חוקי = תיבת הכיתוב כולה בתוך האזור הבטוח. זה erosion של הרשת בתיבה,
  // ב-O(G²) עם סכומים מצטברים. המפה נשמרת עד שהכיתוב/הגופן/הגודל/האמנות משתנים.
  // התיבה מקורבת (מלבן מסביב לגליפים, כולל סיבוב), ולכן שמרנית: כל מרכז שהמפה
  // מאשרת נבדק גם ב-textViolations המדויק לפני שמיישמים — הכלל הקשה נשמר.
  const FIT_BOX_PAD = 0.06;             // ריפוד התיבה ביחס לגודל האות (צדדים/תגים)
  let fitMapCache = { key: null, grid: null, maps: new Map() };
  function fitMapKey() {
    return [state.text.text, state.text.font, state.text.rotation || 0, wantedRatio().toFixed(4)].join('|');
  }
  /** מפת מרכזים חוקיים לצירוף גודל/גלישה. Uint8Array G×G, 1 = חוקי. null = הפריסה חותכת מילים. */
  function fitMapFor(sizeRatio, wrapW) {
    const key = fitMapKey();
    if (fitMapCache.key !== key || fitMapCache.grid !== safeGrid) {
      fitMapCache = { key, grid: safeGrid, maps: new Map() };
    }
    const mk = sizeRatio.toFixed(4) + '|' + wrapW;
    if (fitMapCache.maps.has(mk)) return fitMapCache.maps.get(mk);
    const m = window.PZText.measureLayout(G, Object.assign({}, state.text, { sizeRatio, wrapW }));
    let map = null;
    if (m.complete && m.lines > 0) {
      const px = sizeRatio;                              // גודל אות כשבר מהקנבס
      let w = m.width + 2 * FIT_BOX_PAD * px, h = m.height + 2 * FIT_BOX_PAD * px;
      const rot = (state.text.rotation || 0) * Math.PI / 180;
      if (rot) {                                         // AABB של התיבה המסובבת
        const c = Math.abs(Math.cos(rot)), s = Math.abs(Math.sin(rot));
        const w2 = w * c + h * s, h2 = w * s + h * c; w = w2; h = h2;
      }
      const hw = Math.ceil(w * G / 2), hh = Math.ceil(h * G / 2);
      // סכומים מצטברים של "לא בטוח" — כדי לשאול בכל תיבה: כמה תאים לא בטוחים?
      const S2 = new Int32Array((G + 1) * (G + 1));
      const safe = safeGrid.safe;
      for (let y = 0; y < G; y++) {
        let row = 0;
        for (let x = 0; x < G; x++) {
          row += safe[y * G + x] ? 0 : 1;
          S2[(y + 1) * (G + 1) + (x + 1)] = S2[y * (G + 1) + (x + 1)] + row;
        }
      }
      map = new Uint8Array(G * G);
      for (let y = hh; y < G - hh; y++) {
        for (let x = hw; x < G - hw; x++) {
          const x0 = x - hw, x1 = x + hw + 1, y0 = y - hh, y1 = y + hh + 1;
          const bad = S2[y1 * (G + 1) + x1] - S2[y0 * (G + 1) + x1] - S2[y1 * (G + 1) + x0] + S2[y0 * (G + 1) + x0];
          if (bad === 0) map[y * G + x] = 1;
        }
      }
    }
    fitMapCache.maps.set(mk, map);
    return map;
  }
  // טבעות מרחק (כשבר מהקנבס): קודם קרוב לאצבע, ובתוך כל טבעת — הגודל הגדול קודם.
  const NEAR_RINGS = [0.03, 0.06, 0.10, 0.16, 0.25, 0.40, 0.75];
  /** הנקודה החוקית הקרובה ביותר ל-target. מחזיר {x,y,sizeRatio,wrapW} או null. */
  function nearestFit(target) {
    if (!safeGrid || !state.text.text.trim()) return null;
    const want = wantedRatio();
    const tx = target.x * G, ty = target.y * G;
    let rPrev = 0;
    for (const ring of NEAR_RINGS) {
      const R = ring * G;
      for (const sf of SIZE_STEPS) {
        const r = Math.max(TEXT_MIN_RATIO, want * sf);
        for (const w of WRAPS) {
          const map = fitMapFor(r, w);
          if (!map) continue;
          // סריקת החלון של הטבעת; המועמדים ממוינים לפי מרחק ונבדקים במדויק
          const cands = [];
          const x0 = Math.max(0, Math.floor(tx - R)), x1 = Math.min(G - 1, Math.ceil(tx + R));
          const y0 = Math.max(0, Math.floor(ty - R)), y1 = Math.min(G - 1, Math.ceil(ty + R));
          for (let y = y0; y <= y1; y++) for (let x = x0; x <= x1; x++) {
            if (!map[y * G + x]) continue;
            const d = Math.hypot(x - tx, y - ty);
            if (d <= R && d > rPrev) cands.push({ d, x, y });
          }
          if (!cands.length) continue;
          cands.sort((a, b) => a.d - b.d);
          for (let i = 0; i < Math.min(cands.length, 6); i++) {
            const probe = { x: (cands[i].x + 0.5) / G, y: (cands[i].y + 0.5) / G, sizeRatio: r, wrapW: w };
            if (textViolations(probe) === 0) return probe;
          }
        }
        if (r <= TEXT_MIN_RATIO) break;
      }
      rPrev = R;
    }
    return null;
  }
  /** מובייל: מעביר את הכיתוב לנקודה החוקית הקרובה לאצבע. מחזיר true אם מוקם. */
  function placeTextNear(target) {
    const f = nearestFit(target);
    if (!f) return false;
    applyTextPlacement({ x: f.x, y: f.y }, { sizeRatio: f.sizeRatio, wrapW: f.wrapW });
    return true;
  }

  /**
   * מוודא שהכיתוב במיקום חוקי. אם לא — קודם מנסה למקם מחדש, ורק אז
   * מקטין. ההקטנה אחרונה כי היא משנה משהו שהלקוח בחר במפורש.
   * מחזיר false רק אם הכיתוב לא נכנס בשום גודל ובשום מיקום.
   */
  function ensureTextValid() {
    if (!state.text.text.trim() || !safeGrid) return true;
    if (textViolations() === 0) {
      lastValidText = { x: state.text.x, y: state.text.y };
      // התאוששות: אם הכיתוב הוקטן קודם ועכשיו יש מקום (תבנית רחבה יותר, ראש קטן
      // יותר) — חוזרים לכל היותר לגודל שהלקוח ביקש.
      const f = bestFitAt({ x: state.text.x, y: state.text.y });
      if (f && f.sizeRatio > state.text.sizeRatio + 1e-6) {
        state.text.sizeRatio = f.sizeRatio;
        if (f.wrapW != null) state.text.wrapW = f.wrapW;
        syncSizeSlider();
      }
      return true;
    }
    let spot = bestTextSpot();
    if (spot) {
      state.text.x = spot.x; state.text.y = spot.y;
      lastValidText = spot;
      return true;
    }
    const orig = state.text.sizeRatio;
    for (let i = 0; i < 16; i++) {
      state.text.sizeRatio *= 0.90;
      if (state.text.sizeRatio < 0.026) break;
      spot = bestTextSpot();
      if (spot) {
        state.text.x = spot.x; state.text.y = spot.y;
        lastValidText = spot;
        syncSizeSlider();
        return true;
      }
    }
    state.text.sizeRatio = orig;
    return false;
  }

  // ─────────────────────────────────────────────
  //  ציור מחדש — מאוחד ל-rAF אחד
  // ─────────────────────────────────────────────
  let pending = false;
  function redraw() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => {
      pending = false;
      composite(dctx, S);
      paintSafeHint();
      if (flatMode()) paintFlat();
    });
  }

  // ═══ מצב שטוח — מובייל, שלבים 1–3 ═══
  // בזרימה של אלעד (10.9): במובייל הלקוח בוחר דמות, ממקם את הראש ומוסיף
  // כיתוב על *תמונה שטוחה*; התלת-ממד נבנה רק בלחיצה על "יצירת הכרית".
  // יתרונות: החלפת דמות מיידית (אין בנייה של 2 שניות), אין "דמות על דמות",
  // והמיפוי של הגרירה מדויק (הקנבס השטוח = ההרכבה, 1:1).
  // בדסקטופ — לפי בקשתו — התצוגה החיה נשארת כמו שהיא.
  function flatMode() {
    return isMobileLayout() && curStep <= CREATE_STEP;
  }
  function paintFlat() {
    const f = $('flat');
    if (!f) return;
    const Z = 1000;
    if (f.width !== Z) { f.width = f.height = Z; }
    const x = f.getContext('2d');
    x.clearRect(0, 0, Z, Z);
    x.drawImage(design, 0, 0, Z, Z);   // 1:1 — הגרירה ממופה בדיוק
    f.hidden = false;
  }
  /** מסנכרן את הבמה למצב: שטוח (מובייל 1–3) או תלת-ממד. נקרא בכל מעבר שלב. */
  function syncStageMode() {
    const st = $('stage');
    if (!st) return;
    const flat = flatMode();
    st.classList.toggle('flatmode', flat);
    document.body.classList.toggle('flat-mode', flat);
    if (flat) { redraw(); }
    else if (!building) { const f = $('flat'); if (f) f.hidden = true; }
  }

  // רמז ויזואלי לגבול ההדפסה. מוצג *רק* בזמן שמזיזים את הכיתוב —
  // מדריך כשהוא רלוונטי, ונעלם כדי שהלקוח יראה את המוצר ולא את הסרגל.
  let showSafe = false;
  function paintSafeHint() {
    if (!showSafe || !safeGrid) return;
    dctx.save();
    dctx.globalAlpha = .28;
    dctx.fillStyle = '#8E5AAE';
    dctx.fill(window.PZSafeArea.outlinePath(safeGrid, S / G));
    dctx.restore();
  }
  function setGuide(on) {
    if (showSafe === on) return;
    showSafe = on;
    redraw();
  }

  // ═════════════════════════════════════════════
  //  עדכון הכרית — הלב של הזרימה
  // ═════════════════════════════════════════════
  // שני מסלולים, והבחירה ביניהם היא שאלה אחת: האם הסילואט השתנה.
  //
  //   הסילואט קבוע  → החלפת טקסטורה   ~11ms   חי לגמרי
  //   הסילואט השתנה → generate3D      ~2200ms חסימה מלאה
  //
  // בתבנית (לב, גיבור) הסילואט נקבע ע"י התבנית, לא ע"י התמונה. לכן
  // גרירה, הגדלה, הסרת רקע וכיתוב — כולם חיים.
  // במצב "לפי התמונה" הסילואט *הוא* התמונה, ואין מנוס מבנייה מחדש.

  let pillowBuilt = false;
  let rebuildTimer = null;
  let genCanvas = null;

  function shapeChangesWithPhoto() {
    const tpl = templates.find((t) => t.id === state.shape);
    return !tpl || tpl.mode === 'photo';
  }

  /** ה-composite ברזולוציית המנוע, לשימוש חוזר בלי הקצאה בכל פריים. */
  function genComposite() {
    if (!genCanvas) {
      genCanvas = document.createElement('canvas');
      genCanvas.width = genCanvas.height = GEN;
    }
    composite(genCanvas.getContext('2d', { willReadFrequently: true }), GEN);
    return genCanvas;
  }

  // ═══ הגב של הכרית (אלעד, 12.9) ═══
  // במציאות היריעה מודפסת פעם אחת ומקופלת: הגב הוא התמונה במראה. כך גם
  // המנוע (הגב = עותק של החזית, והגאומטריה מציגה אותו במראה). הבעיה הייתה
  // הכיתוב — בעותק הוא יוצא הפוך מאחור. לכן הגב שאנחנו דוחפים הוא:
  //   אותה אמנות בדיוק (עותק — לא מראה, אחרת הראש נחתך בקו המתאר) +
  //   הכיתוב באותו מקום עם האותיות משוקפות (PZText.draw mirrorGlyphs).
  // מאחור: התמונה במראה, הכיתוב קריא, בלי חיתוך. זהה בדסקטופ ובמובייל,
  // וזהה למה שיודפס על הגב במפעל (כמו קובץ הגב של מוצר 1).
  // האמנות מצוירת פעם אחת ומועתקת — לא שני מעברים של drawArt בכל הקלדה.
  let genBackCanvas = null;
  function genPair() {
    if (!genCanvas) {
      genCanvas = document.createElement('canvas');
      genCanvas.width = genCanvas.height = GEN;
    }
    if (!genBackCanvas) {
      genBackCanvas = document.createElement('canvas');
      genBackCanvas.width = genBackCanvas.height = GEN;
    }
    const fctx = genCanvas.getContext('2d', { willReadFrequently: true });
    const bctx = genBackCanvas.getContext('2d', { willReadFrequently: true });
    drawArt(fctx, GEN);
    bctx.clearRect(0, 0, GEN, GEN);
    bctx.drawImage(genCanvas, 0, 0);
    window.PZText.draw(fctx, GEN, state.text);
    window.PZText.draw(bctx, GEN, state.text, { mirrorGlyphs: true });
    return { front: genCanvas, back: genBackCanvas };
  }

  /** דוחף את המצב הנוכחי אל פני הכרית — חזית וגב. זול. */
  function pushToPillow() {
    if (!pillowBuilt) return false;
    const pair = genPair();
    return window.PZLiveTexture.update(pair.front, pair.back);
  }

  /** נקרא בכל שינוי באמנות (תמונה, מיקום, גודל, תבנית). */
  // ═══ הראש לא יוצא מהכרית (אלעד, 11.9) ═══
  // מה שמחוץ לקנבס לא מודפס. מאז שתיבת ההרכבה לא עוקבת אחרי הגרירה, הגרירה
  // עצמה נעצרת בקצה — בקואורדינטות ההרכבה (אחרי k/היסוט), עם שוליים זעירים.
  const HEAD_EDGE_MARGIN = 0.01;
  function clampHeadToCanvas() {
    const tpl = templates.find((t) => t.id === state.shape);
    if (!tpl || tpl.mode !== 'neck' || !tpl.fit || !state.userImg) return false;
    const img = state.userImg, m = Math.max(img.width, img.height);
    let w = img.width / m * state.tscale, h = img.height / m * state.tscale;
    if (state.trot) {   // אותו קירוב כמו ב-compFit: הראש הוא גזרה ≈ אליפסה, לא מלבן
      const a = state.trot * Math.PI / 180, c = Math.cos(a), sn = Math.sin(a);
      const hw = w / 2, hh = h / 2;
      w = 2 * Math.sqrt(hw * hw * c * c + hh * hh * sn * sn);
      h = 2 * Math.sqrt(hw * hw * sn * sn + hh * hh * c * c);
    }
    const cf = compFit(tpl);
    const lo = HEAD_EDGE_MARGIN, hi = 1 - HEAD_EDGE_MARGIN;
    const fix = (t, half, o) => {
      if (half * 2 > hi - lo) return t;                       // גדול מהקנבס — אין למה לצמוד
      const c = (0.5 + t / S) * cf.k + o;                     // מרכז הראש כפי שמצויר
      const cc = Math.min(hi - half, Math.max(lo + half, c));
      return cc === c ? t : ((cc - o) / cf.k - 0.5) * S;
    };
    const nx = fix(state.tx, w / 2 * cf.k, cf.ox), ny = fix(state.ty, h / 2 * cf.k, cf.oy);
    const changed = nx !== state.tx || ny !== state.ty;
    state.tx = nx; state.ty = ny;
    if (changed) syncActiveSlot();
    return changed;
  }

  // מיקום הראשים בבנייה האחרונה — כדי לדעת אם גרירה משמעותית שינתה את הסילואט.
  let builtHeadPos = null;
  const HEAD_MOVE_REBUILD = 0.03;    // 3% מהקנבס
  function headMovedSinceBuild() {
    if (!builtHeadPos) return false;
    syncActiveSlot();
    return state.slots.some((sl, i) => {
      const b = builtHeadPos[i]; if (!b || !sl || !sl.userImg) return false;
      return Math.abs((sl.tx || 0) - b[0]) / S > HEAD_MOVE_REBUILD || Math.abs((sl.ty || 0) - b[1]) / S > HEAD_MOVE_REBUILD;
    });
  }

  function onArtChanged() {
    clampHeadToCanvas();
    rebuildSafeGrid();
    ensureTextValid();
    redraw();
    updateSummary();
    pushToPillow();
  }

  /** בנייה מחדש מושהית — למצב שבו הצורה תלויה בתמונה. */
  /**
   * בונה את הגיאומטריה מחדש רק כשהצורה באמת השתנתה.
   * במצב "צורה חופשית" (photo) — תמיד, כמו קודם.
   * במצב צוואר — רק כשתיבת ההרכבה זזה מעל הסף. תזוזה קטנה של הראש
   * מתעדכנת דרך הטקסטורה החיה (≈1ms) במקום בנייה מלאה (≈2 שניות).
   */
  function maybeRebuildShape() {
    if (shapeChangesWithPhoto()) { scheduleRebuild(); return; }
    const tpl = templates.find((t) => t.id === state.shape);
    // ═══ בסיום גרירה (11.9) ═══ בתבנית צוואר הסילואט הוא איחוד האיור והראש, ולכן
    // הזזה גדולה של הראש משנה אותו. תוך כדי גרירה נשארים חיים (טקסטורה בלבד);
    // בסיום — אם הראש זז מעל 3% מהקנבס מאז הבנייה — בנייה שקטה אחת.
    if (tpl && tpl.mode === 'neck' && (compBoxMoved(tpl) || headMovedSinceBuild())) scheduleRebuild();
  }

  function scheduleRebuild() {
    clearTimeout(rebuildTimer);
    $('stageStatus').textContent = 'מעדכן את הצורה…';
    rebuildTimer = setTimeout(() => buildPillow({ quiet: true }), 400);
  }

  // ─────────────────────────────────────────────
  //  תבניות
  // ─────────────────────────────────────────────
  /** טוען את קובצי התבנית (אם עוד לא) ומחשב את הנרמול שלה. בטוח לקרוא שוב ושוב. */
  function ensureTemplateLoaded(t) {
    if (!t) return Promise.resolve();
    if (t._ready) return t._ready;
    t._ready = (async () => {
      const [mask, art] = await Promise.all([
        t.mask ? loadImg(ART_URL(t.mask)) : null,
        t.art ? loadImg(ART_URL(t.art)) : null,
      ]);
      if (mask) t.maskImg = mask;
      if (art) t.artImg = art;
      // ═══ נרמול התבנית ═══
      // קובצי התבניות לא ממורכזים ולא באותו קנה מידה. מודדים פעם אחת
      // את תיבת הגבול של האלפא, ומכאן מציירים דרכה.
      // תאימות: גרסה מוקדמת כתבה neck יחיד. מנרמלים למערך — מסלול קוד אחד.
      if (t.neck && !t.necks) t.necks = [t.neck];
      t.fit = alphaBox(t.artImg || t.maskImg, t.maskImg, t.faceHole, t.mode === 'neck' ? t.necks : null);
    })();
    return t._ready;
  }

  async function loadTemplates() {
    // ═══ מוצר תבניות בלבד ═══
    // "לפי התמונה" הוסר: זה המוצר האחר — "כרית בעיצוב אישי" — שכבר
    // חי באתר. כאן הצורה תמיד מגיעה מתבנית, ולכן הסילואט קבוע וכל
    // שינוי (מיקום, גודל, צבע, כיתוב) הוא עדכון טקסטורה חי.
    const base = [];
    let extra = [];
    try {
      extra = await (await fetch((CFG && CFG.templatesUrl) || '/dev/proto/templates/templates.json')).json();
      // ═══ טעינה עצלה ═══
      // 33 דמויות × ~120KB = 4MB. לטעון את כולן בפתיחת הדף (ועוד בזו אחר
      // זו) עלה 4–8 שניות במובייל. עכשיו הקטלוג מציג תמונות ממוזערות
      // (thumb, ~10KB), והדמות המלאה נטענת רק כשבוחרים אותה —
      // ראו ensureTemplateLoaded. תבנית בלי thumb (לב/גיבור הישנים)
      // נטענת מיד כדי שיהיה ממה לצייר צ'יפ.
      for (const t of extra) {
        t.desc = t.mode === 'fill' ? 'התמונה ממלאת את הצורה' : 'הפנים בתוך הדמות';
      }
      await Promise.all(extra.filter((t) => !t.thumb).map(ensureTemplateLoaded));
    } catch (e) { console.warn('תבניות נוספות לא נטענו', e); }
    templates = base.concat(extra);
    if (templates.length && !templates.some((t) => t.id === state.shape)) {
      state.shape = templates[0].id;
    }

    const box = $('shapes');
    box.innerHTML = '';
    buildCategoryTabs();
    for (const t of templates) {
      const b = document.createElement('button');
      b.type = 'button'; b.className = 'chip';
      b.dataset.shape = t.id;
      b.setAttribute('aria-pressed', String(t.id === state.shape));
      // רק תמונה + שם, בלי תיאור — התיאור הכביד את הצ'יפ ולא הוסיף מידע.
      b.innerHTML = '<img alt="" width="46" height="46"><span class="txt"><b></b></span>';
      // בלי loading=lazy: כרום לא טוען תמונות lazy בטאב לא-נראה, והקטלוג נשאר ריק אחרי מעבר טאב.
      // 33 תמונות × ~10KB = 330KB — זול מספיק כדי לטעון מיד.
      b.querySelector('img').src = t.thumb ? ART_URL(t.thumb) : makeThumb(t, 92);
      b.querySelector('b').textContent = t.name;
      b.onclick = async () => {
        state.shape = t.id;
        [...box.children].forEach((c) => c.setAttribute('aria-pressed', String(c === b)));
        if (!t._ready) { b.setAttribute('aria-busy', 'true'); await ensureTemplateLoaded(t); b.removeAttribute('aria-busy'); }
        else await t._ready;
        if (state.shape !== t.id) return;   // הלקוח כבר בחר משהו אחר בזמן הטעינה
        // אם אין עדיין תמונה אמיתית — נכנסים למצב דוגמה עם התבנית שנבחרה,
        // כדי שהלקוח יראה מיד איך הצורה נראית.
        if (!state.slots.some(slotFilled) || state.isDemo) { resizeSlots(); enterDemo(); say('נבחרה הצורה ' + t.name); pushHistory(); advanceAfterShape(); return; }
        resizeSlots();
        syncBgToggleVisibility();
        recenterAllSlots();
        renderSlots();
        updateCartGate();
        rebuildSafeGrid();
        ensureTextValid();
        redraw();
        syncModeAvailability();
        say('נבחרה הצורה ' + t.name);
        pushHistory();
        // התבנית קובעת את הסילואט — זה שינוי צורה, ולכן בנייה מלאה.
        buildPillow();
        advanceAfterShape();
      };
      box.appendChild(b);
    }
    applyCatalogFilter();
    preloadArt(templates);
  }

  // ═══ טעינה מראש של האמנות ═══
  // כל קובץ אמנות הוא 70–200KB ונטען עצל בלחיצה הראשונה — וזה הדיליי
  // שאלעד הרגיש בהחלפת דמות. טוענים ברקע, אחד-אחד (לא להציף את הרשת
  // במובייל), ורק כשהדפדפן פנוי. הלחיצה הראשונה על דמות שכבר נטענה — מיידית.
  function preloadArt(list) {
    const queue = list.filter((t) => t.art && !t._ready);
    const idle = window.requestIdleCallback || ((fn) => setTimeout(fn, 200));
    const next = () => {
      const t = queue.shift();
      if (!t) return;
      idle(() => ensureTemplateLoaded(t).catch(() => {}).then(next));
    };
    next();
  }

  // ═══ קטלוג: קטגוריות + "הצג עוד" ═══
  // 33 דמויות ברשימה אחת דחפו את שלב 2 מתחת לקפל. עכשיו: אריחים
  // גדולים ברשת, לשוניות קטגוריה, ומספר מוגבל של אריחים עד שלוחצים
  // "הצג עוד". כל הצ'יפים נשארים ב-DOM (רק hidden) — כדי שבחירה,
  // היסטוריה ובדיקות ימשיכו לעבוד על אותם אלמנטים.
  const CAT_NAMES = { food: 'אוכל', animals: 'חיות', fans: 'אוהדים', riders: 'רוכבים', people: 'דמויות' };
  let catFilter = 'all', catalogExpanded = false;
  function catalogLimit() { return isMobileLayout() ? 9 : 12; }

  function buildCategoryTabs() {
    const bar = $('shapeCats');
    if (!bar) return;
    bar.innerHTML = '';
    const cats = ['all', ...new Set(templates.map((t) => t.category).filter(Boolean))];
    if (cats.length < 3) { bar.hidden = true; return; }
    bar.hidden = false;
    for (const c of cats) {
      const b = document.createElement('button');
      b.type = 'button'; b.className = 'cat'; b.dataset.cat = c;
      b.textContent = c === 'all' ? 'הכל' : (CAT_NAMES[c] || c);
      b.setAttribute('aria-pressed', String(c === catFilter));
      b.onclick = () => {
        catFilter = c; catalogExpanded = false;
        [...bar.children].forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
        applyCatalogFilter();
        say(b.textContent);
      };
      bar.appendChild(b);
    }
  }

  function applyCatalogFilter() {
    const box = $('shapes'), more = $('shapesMore');
    const chips = [...box.querySelectorAll('.chip[data-shape]')];
    const byId = new Map(templates.map((t) => [t.id, t]));
    const match = chips.filter((c) => catFilter === 'all' || (byId.get(c.dataset.shape) || {}).category === catFilter);
    const limit = catalogLimit();
    // אם החיתוך משאיר רק עוד 3 — אין טעם בכפתור, מציגים הכל
    const showAll = catalogExpanded || match.length <= limit + 3;
    let shown = 0;
    for (const c of chips) {
      const inCat = match.includes(c);
      const visible = inCat && (showAll || shown < limit || c.getAttribute('aria-pressed') === 'true');
      if (inCat && visible) shown++;
      c.hidden = !visible;
    }
    if (more) {
      const rest = match.length - shown;
      more.hidden = showAll || rest <= 0;
      more.textContent = 'הצג עוד ' + rest + ' דמויות';
      more.onclick = () => { catalogExpanded = true; applyCatalogFilter(); say('כל הדמויות מוצגות'); };
    }
  }

  /**
   * תמונה ממוזערת של התבנית, נוצרת מהקבצים שלה.
   * ═══ למה נוצרת ולא מצוירת בנפרד ═══
   * כל תבנית שנוסיף בעתיד תקבל תמונה אוטומטית, בלי קובץ נוסף לתחזק
   * ובלי סיכון שהתמונה תצא לא מסונכרנת עם הצורה בפועל.
   *
   * הרכב: קודם הסילואט מלא בגוון רך — כדי שגם תבנית שהאמנות שלה היא
   * קו מתאר בלבד (הלב) תיראה; אחר כך האמנות; ולבסוף סימון אפור של
   * המקום שבו התמונה של הלקוח תשב.
   */
  function makeThumb(tpl, N) {
    const c = document.createElement('canvas');
    c.width = c.height = N;
    const x = c.getContext('2d');
    const f = tpl.fit;

    const silhouette = tpl.maskImg || tpl.artImg;
    if (silhouette) {
      const t = document.createElement('canvas');
      t.width = t.height = N;
      const tx2 = t.getContext('2d');
      drawFitted(tx2, silhouette, N, f);
      tx2.globalCompositeOperation = 'source-in';
      tx2.fillStyle = '#E3D3EF';
      tx2.fillRect(0, 0, N, N);
      x.drawImage(t, 0, 0);
    }

    if (tpl.mode === 'face' && tpl.faceHole) {
      const h = fittedHole(tpl);
      x.save();
      x.beginPath();
      x.ellipse(h.cx * N, h.cy * N, h.rx * N, h.ry * N, 0, 0, Math.PI * 2);
      x.fillStyle = '#B9AFC4';
      x.fill();
      x.restore();
    }

    if (tpl.artImg) drawFitted(x, tpl.artImg, N, f);

    if (tpl.mode === 'fill') {
      // במילוי, התמונה תופסת את כל הצורה — מסמנים את זה בפס אלכסוני עדין
      x.save();
      x.globalAlpha = .5;
      x.strokeStyle = '#B9AFC4';
      x.lineWidth = Math.max(1, N / 46);
      for (let i = -N; i < N * 2; i += N / 7) {
        x.beginPath(); x.moveTo(i, 0); x.lineTo(i + N, N); x.stroke();
      }
      x.restore();
      // חותכים חזרה לצורה
      const m = document.createElement('canvas');
      m.width = m.height = N;
      drawFitted(m.getContext('2d'), silhouette, N, f);
      x.globalCompositeOperation = 'destination-in';
      x.drawImage(m, 0, 0);
      x.globalCompositeOperation = 'source-over';
    }
    return c.toDataURL('image/png');
  }

  // ═══ עם רקע / בלי רקע ═══
  // שתי הגרסאות כבר בזיכרון, ולכן המעבר הוא החלפת טקסטורה בלבד —
  // בלי העלאה חוזרת, בלי עלות, ובלי בנייה מחדש של הכרית: הסילואט
  // נקבע ע"י התבנית ולא ע"י התמונה.
  function setBackground(useBg) {
    if (!state.imgNoBg) return;
    state.useBg = useBg;
    state.userImg = useBg ? state.imgWithBg : state.imgNoBg;
    syncBgButtons();
    onArtChanged();
    pushHistory();
    say(useBg ? 'עם הרקע המקורי' : 'בלי רקע');
  }

  // ═══ העגלה נפתחת רק כשכל האנשים בתבנית קיבלו תמונה ═══
  function updateCartGate() {
    const ok = !state.isDemo && allSlotsFilled();
    $('addCart').disabled = !ok;
    $('buyNow').disabled = !ok;
    const miss = slotCount() - filledCount();
    const el = $('slotsMsg');
    if (el) {
      el.hidden = !(miss > 0 && slotCount() > 1 && filledCount() > 0);
      if (!el.hidden) el.textContent = COPY.needAll.replace('{n}', miss).replace('{total}', slotCount());
    }
    return ok;
  }

  /** כפתורי הסלוטים ("מי על הכרית"). מוצגים רק כשהתבנית מקבלת יותר מאדם אחד. */
  function renderSlots() {
    const box = $('slots'); if (!box) return;
    const n = slotCount();
    const wrap = $('slotsBox');
    if (wrap) wrap.hidden = n <= 1;
    if (n <= 1) { box.innerHTML = ''; return; }
    syncActiveSlot();
    box.innerHTML = '';
    for (let i = 0; i < n; i++) {
      const sl = state.slots[i] || {};
      const b = document.createElement('button');
      b.type = 'button'; b.className = 'slot' + (slotFilled(sl) ? ' full' : '');
      b.setAttribute('aria-pressed', String(i === state.activeSlot));
      b.setAttribute('aria-label', 'אדם ' + (i + 1) + (slotFilled(sl) ? '' : ' — ' + COPY.slotEmpty));
      const th = document.createElement('span'); th.className = 'slot__th';
      if (slotFilled(sl)) {
        const c = document.createElement('canvas'); c.width = c.height = 64;
        const x = c.getContext('2d');
        const im = sl.userImg, k = Math.min(64 / im.width, 64 / im.height);
        x.drawImage(im, (64 - im.width * k) / 2, (64 - im.height * k) / 2, im.width * k, im.height * k);
        const img = new Image(); img.src = c.toDataURL('image/png'); img.alt = '';
        th.appendChild(img);
      } else th.textContent = '+';
      b.appendChild(th);
      const lb = document.createElement('span'); lb.className = 'slot__n'; lb.textContent = String(i + 1);
      b.appendChild(lb);
      b.onclick = () => selectSlot(i);
      box.appendChild(b);
    }
  }

  /** מעבר בין אנשים: שומר את הנוכחי, טוען את הנבחר. סלוט ריק פותח את בורר הקובץ. */
  function selectSlot(i) {
    if (i === state.activeSlot && slotFilled(state.slots[i])) return;
    syncActiveSlot();
    loadSlot(i);
    syncBgButtons(); syncPhotoSlider(); syncBgToggleVisibility();
    renderSlots(); redraw();
    say('אדם ' + (i + 1));
    if (!slotFilled(state.slots[i])) $('file').click();
  }

  /** "עם הרקע" לא הגיוני כשהראש יושב מעל איור (מצב צוואר) — מסתירים את המתג שם. */
  function syncBgToggleVisibility() {
    const tpl = templates.find((t) => t.id === state.shape);
    const neck = !!(tpl && tpl.mode === 'neck');
    $('bgToggle').hidden = !state.imgNoBg || state.isDemo || neck;
    if (neck && state.useBg) { state.useBg = false; state.userImg = state.imgNoBg; syncBgButtons(); }
  }

  function syncBgButtons() {
    for (const b of $('bgToggle').querySelectorAll('[data-bg]')) {
      b.setAttribute('aria-pressed', String((b.dataset.bg === 'with') === state.useBg));
    }
  }

  $('bgToggle').addEventListener('click', (e) => {
    const b = e.target.closest('[data-bg]');
    if (b) setBackground(b.dataset.bg === 'with');
  });

  // ═══ איפה הראש בתמונה ═══
  // אחרי הסרת הרקע נשארת גזרה של אדם. הראש הוא החלק העליון שלה:
  // מודדים את רוחב הגזרה בשליש העליון של תיבת האלפא — זה רוחב הראש
  // (כולל שיער), והמרכז האופקי שלו. בלי זיהוי פנים, בלי רשת — עובד
  // על רוב תמונות "ראש וכתפיים". מחזיר שברים 0..1 ביחס לתמונה, או
  // null כשאין שקיפות (תמונה עם רקע) ואין מה למדוד.
  function estimateHead(img) {
    if (!img || !img.width) return null;
    const N = 160;
    const c = document.createElement('canvas'); c.width = c.height = N;
    const x = c.getContext('2d', { willReadFrequently: true });
    x.clearRect(0, 0, N, N);
    x.drawImage(img, 0, 0, N, N);
    const d = x.getImageData(0, 0, N, N).data;
    const rows = [];
    let top = -1, bot = -1, opaque = 0;
    for (let yy = 0; yy < N; yy++) {
      let l = -1, r = -1;
      for (let xx = 0; xx < N; xx++) {
        if (d[(yy * N + xx) * 4 + 3] > 40) { if (l < 0) l = xx; r = xx; opaque++; }
      }
      rows.push([l, r]);
      if (l >= 0) { if (top < 0) top = yy; bot = yy; }
    }
    if (top < 0 || opaque > N * N * 0.93) return null;    // ריק, או בלי רקע שקוף
    const H = bot - top;
    if (H < 12) return null;
    const ws = [], cs = [];
    for (let yy = top + Math.round(H * .06); yy <= top + Math.round(H * .30); yy++) {
      const [l, r] = rows[yy]; if (l < 0) continue;
      ws.push(r - l + 1); cs.push((l + r) / 2);
    }
    if (!ws.length) return null;
    ws.sort((a, b) => a - b);
    const hwPx = ws[Math.floor(ws.length / 2)];               // חציון — עמיד לשיער פרוע ולאוזניים
    const hxPx = cs.reduce((a, b) => a + b, 0) / cs.length;
    // הקנבס N×N מותח את התמונה; גובה הראש ≈ 1.25×רוחבו בפיקסלים אמיתיים,
    // ובציר y המתוח זה ×(w/h). מרכז הפנים ≈ 55% מגובה הראש מלמעלה.
    const hyPx = top + 0.7 * hwPx * (img.width / img.height);
    const hbPx = top + 1.25 * hwPx * (img.width / img.height);   // הסנטר ≈ תחתית הראש
    return { hx: hxPx / N, hy: hyPx / N, hw: hwPx / N, hb: Math.min(1, hbPx / N) };
  }

  /**
   * מיקום מרכז הראש כך שהסנטר (est.hb) יושב על נקודת העיגון של הצוואר, לגודל ts.
   * הפונקציה הזו היא הסיבה שהראש נשאר על הצוואר גם כשמקטינים ומגדילים.
   */
  function neckHeadPos(n, img, est, ts) {
    const maxDim = Math.max(img.width, img.height);
    const W = img.width / maxDim * ts * S, Hh = img.height / maxDim * ts * S;
    const hb = est.hb != null ? est.hb : Math.min(1, est.hy + 0.55 * est.hw * (img.width / img.height));
    // (13.9) hdy — "מיקום על הצוואר": הורדת הראש במורד הצוואר, שבר מגובה הקנבס, ≥0.
    // ציר הצוואר אנכי בכל התבניות (nx,ny,nw בלי זווית), ולכן זה פשוט ty.
    return { tx: (n.nx - .5) * S - (est.hx - .5) * W,
             ty: (n.ny + NECK_OVERLAP * n.nw - .5) * S - (hb - .5) * Hh + (state.hdy || 0) * S };
  }
  const HEAD_DROP_MAX = 0.10;      // עד 10% מגובה הכרית (במידה 40 ≈ 4 ס״מ)
  const clampDrop = (v) => Math.min(HEAD_DROP_MAX, Math.max(0, Number(v) || 0));
  function sizeCm() { const m = String(state.size).match(/(\d+(?:\.\d+)?)/); return m ? parseFloat(m[1]) : 40; }
  function dropLabel(v) { const cm = v * sizeCm(); return (cm ? '‑' + (Math.round(cm * 10) / 10) : '0') + ' ס״מ'; }
  function syncDropSlider() {
    const el = $('photoDrop'); if (!el) return;
    el.value = String(Math.round((state.hdy || 0) * 400) / 4);   // 0..10 בצעדי 0.25
    const t = dropLabel(state.hdy || 0);
    $('photoDropOut').textContent = t; el.setAttribute('aria-valuetext', t);
    const tpl = templates.find((t2) => t2.id === state.shape);
    const row = $('photoDropRow'); if (row) row.hidden = !(tpl && tpl.mode === 'neck');
  }
  /** קובע את ההורדה (שבר מהקנבס), ממקם מחדש, מעדכן — משמש לסליידר ולגרירה. */
  function setHeadDrop(v, o) {
    state.hdy = clampDrop(v);
    if (!reanchorHead()) return false;
    syncActiveSlot();
    if (clampScaleToComp()) syncPhotoSlider();
    syncDropSlider();
    onArtChanged();
    maybeRebuildShape();
    if (o && o.history) pushHistory();
    return true;
  }

  // ═══ הראש נשאר על הצוואר בכל גודל (אלעד, 12.9) ═══
  // הבאג מהאייפון: הקטנה ל-40% השאירה את הראש "מרחף" מעל הגוף. הסיבה: המרכז
  // (tx,ty) חושב פעם אחת ל-70%, ושינוי גודל סביב המרכז מרים את הסנטר מהצוואר
  // (ובהגדלה — משקיע אותו בגוף). עכשיו בכל שינוי גודל המיקום מחושב מחדש
  // מהעיגון, כך שהסנטר תמיד על הצוואר. תבניות "חור פנים" — לא נוגעים (המרכז על החור).
  function reanchorHead() {
    const tpl = templates.find((t) => t.id === state.shape);
    const img = state.userImg;
    if (!tpl || tpl.mode !== 'neck' || !tpl.fit || !tpl.necks || !img) return false;
    const n = fittedNeck(tpl, state.activeSlot);
    const est = state.headEst || { hx: .5, hb: .92, hw: .85 };
    const pos = neckHeadPos(n, img, est, state.tscale);
    state.tx = pos.tx; state.ty = pos.ty;
    state.ax = state.tx; state.ay = state.ty;
    return true;
  }

  function recenterPhoto() {
    const tpl = templates.find((t) => t.id === state.shape);
    state.tx = state.ty = 0; state.tscale = 1; state.trot = 0; state.hdy = 0;
    // tpl.fit נוצר בטעינה העצלה של התבנית; אם התמונה הגיעה לפני שהתבנית נטענה
    // (שרת מהיר מאוד / בדיקה אוטומטית) — נמקם כשהתבנית תיטען (ensureTemplateLoaded קורא recenterPhoto).
    if (tpl && tpl.mode === 'neck' && tpl.fit && tpl.necks) {
      // ═══ הראש יושב על הצוואר ═══
      // רוחב הראש = NECK_HEAD_RATIO × רוחב הצוואר; הסנטר (est.hb) על נקודת העיגון + חפיפה.
      const n = fittedNeck(tpl, state.activeSlot);
      const img = state.userImg;
      const est = (img && state.headEst) || { hx: .5, hb: .92, hw: .85 };   // בלי זיהוי: הראש הוא כל התמונה
      if (img) {
        // הגודל נקבע מברירת המחדל (70%) ולא מרוחב הצוואר; המיקום מחושב מהעיגון
        // לפי הגודל הנוכחי (ראו neckHeadPos) — ומחושב מחדש בכל שינוי גודל.
        state.tscale = HEAD_DEFAULT;
        const pos = neckHeadPos(n, img, est, state.tscale);
        state.tx = pos.tx; state.ty = pos.ty;
      }
    } else if (tpl && tpl.mode === 'face' && tpl.fit) {
      const h = fittedHole(tpl);
      const img = state.userImg, est = state.headEst;
      if (img && est) {
        // ═══ הראש נכנס לחור לבד ═══
        // רוחב הראש בקנבס = רוחב החור × 1.35 (קצת יותר, כדי שהפנים ימלאו
        // אותו והשיער ייכנס מתחת לאיור), ומרכז הראש על מרכז החור.
        const maxDim = Math.max(img.width, img.height);
        let ts = (2 * h.rx * 1.35) * maxDim / (est.hw * img.width);
        ts = Math.min(4, Math.max(.2, ts));
        const W = img.width / maxDim * ts * S, Hh = img.height / maxDim * ts * S;  // מידות התמונה ביחידות S
        state.tscale = ts;
        state.tx = (h.cx - .5) * S - (est.hx - .5) * W;
        state.ty = (h.cy - .5) * S - (est.hy - .5) * Hh;
      } else {
        state.tx = (h.cx - .5) * S;
        state.ty = (h.cy - .5) * S;
        state.tscale = h.r * 2.6;   // r = הרדיוס הגדול של האליפסה — התמונה מכסה את כל החור
      }
    }
    // ═══ נקודת העיגון (אלעד, 11.9) ═══ המקום "הטבעי" של הראש על הצוואר. תיבת ההרכבה
    // (compFit) מחושבת לפי המקום הזה ולא לפי המקום שאליו גררו — כך גרירה מזיזה
    // רק את הראש, והגוף נשאר בפיקסלים שלו.
    state.ax = state.tx; state.ay = state.ty;
    syncPhotoSlider();
  }

  /** ממקם מחדש כל סלוט מלא על נקודת העיגון שלו — אחרי החלפת תבנית. */
  function recenterAllSlots() {
    const cur = state.activeSlot;
    for (let i = 0; i < slotCount(); i++) {
      if (!slotFilled(state.slots[i])) continue;
      syncActiveSlot(); loadSlot(i); recenterPhoto(); syncActiveSlot();
    }
    loadSlot(cur); syncPhotoSlider();
  }

  // ═══ מצב דוגמה ═══
  // מציג את הכרית עם תמונת הדמו, לפני שהלקוח העלה משהו. משתמש בדיוק
  // באותו מסלול של תמונה אמיתית (כולל בניית הכרית והעדכון החי), אבל
  // מסמן isDemo כדי שהעגלה תישאר נעולה עד שתעלה תמונה אמיתית.
  function enterDemo() {
    if (!state.sampleImg) return;              // אין דמו — נשארים במסך הריק
    state.isDemo = true;
    state.headEst = state.sampleEst || null;
    state.userImg = state.sampleImg;
    state.imgNoBg = state.sampleImg;
    state.imgWithBg = state.sampleImg;
    state.useBg = false;
    // דמו ממלא את *כל* הסלוטים, כדי שתבנית זוג תיראה שלמה לפני העלאה.
    for (let i = 0; i < slotCount(); i++) {
      state.slots[i] = state.slots[i] || {};
      const cur = state.activeSlot;
      loadSlot(i); state.userImg = state.imgNoBg = state.imgWithBg = state.sampleImg;
      state.useBg = false; state.headEst = state.sampleEst || null; recenterPhoto(); syncActiveSlot();
      loadSlot(cur);
    }
    recenterPhoto();
    rebuildSafeGrid();
    ensureTextValid();
    renderSlots();
    document.body.classList.add('has-image', 'is-demo');
    // has-image הוא מה שמציג את סרגל השלבים וכפתורי "המשך/חזרה". עד עכשיו
    // הם התרעננו דרך המעבר האוטומטי לשלב 2; מאז שבחירת דמות לא מקדמת שלב,
    // חייבים לרענן כאן — אחרת אין ללקוח כפתור "המשך" בשלב 1.
    if (typeof showStep === 'function') showStep(curStep);
    $('emptyState').style.display = 'none';
    $('photoTools').hidden = false;
    syncModesVisibility();                          // בורר גרירה רק אם יש כיתוב והשלב לא נועל
    syncModeAvailability();
    // רמז ברור שזו דוגמה, בשלב ההעלאה.
    $('uploadStatus').innerHTML =
      '<b>זו תמונת דוגמה.</b> העלו תמונה כדי להחליף אותה ולראות את הכרית שלכם.';
    updateSummary();
    redraw();
    buildPillow();          // בונה את הכרית מהדמו — הסילואט של התבנית
  }

  /** מחפש את המיקום החוקי הקרוב ביותר, בספירלה החוצה מהמרכז. */
  function nudgeTextInside() {
    if (!state.text.text.trim() || !safeGrid) return true;
    if (textViolations() === 0) { lastValidText = { x: state.text.x, y: state.text.y }; return true; }
    const steps = [0, .04, .08, .12, .16, .2, .26, .32];
    for (const r of steps) {
      for (let a = 0; a < 12; a++) {
        const th = a * Math.PI / 6;
        const cand = { x: .5 + Math.cos(th) * r, y: .5 + Math.sin(th) * r };
        if (textViolations(cand) === 0) {
          state.text.x = cand.x; state.text.y = cand.y;
          lastValidText = cand;
          return true;
        }
      }
    }
    return false;
  }

  // ─────────────────────────────────────────────
  //  גופנים
  // ─────────────────────────────────────────────
  // ═══ בורר הגופנים — כמו במודל החי ═══
  // שורה אחת שנגללת לצדדים, בלי תוויות קבוצות. כל צ'יפ מציג את שם
  // הגופן *בגופן עצמו* כדי שאפשר יהיה להבדיל ביניהם במבט.
  function buildFonts() {
    const box = $('fonts');
    box.innerHTML = '';
    for (const f of window.PZText.FONTS) {
      const b = document.createElement('button');
      b.type = 'button'; b.className = 'fontbtn';
      b.dataset.font = f.id;
      b.setAttribute('aria-pressed', String(f.id === state.text.font));
      b.setAttribute('aria-label', 'גופן ' + f.label);
      b.textContent = f.label;
      // important — אחרת כלל גלובלי היה עלול לכפות גופן אחיד על הצ'יפים.
      b.style.setProperty('font-family', '"' + f.id + '",' + window.PZText.FALLBACK, 'important');
      b.style.setProperty('font-weight', String(f.weight), 'important');
      b.onclick = () => {
        state.text.font = f.id;
        [...box.querySelectorAll('.fontbtn')].forEach((c) => c.setAttribute('aria-pressed', String(c === b)));
        afterTextChange();
        say('נבחר גופן ' + f.label);
      };
      box.appendChild(b);
    }
  }

  // ─────────────────────────────────────────────
  //  דוגמיות צבע
  // ─────────────────────────────────────────────
  /** מציג את הצבע הנוכחי בשורה המותאמת ומסמן את הריבוע המהיר התואם (אם יש). */
  function syncColorUI() {
    const hex = normHex(state.pillowColor) || state.pillowColor;
    const box = $('colorPreviewBox'), out = $('colorHexDisplay');
    if (box) box.style.background = hex;
    if (out) out.textContent = hex;
    for (const b of $('pillowColors').querySelectorAll('button')) {
      b.setAttribute('aria-pressed', String(b.dataset.hex.toUpperCase() === hex.toUpperCase()));
    }
  }

  // ═══ שינוי צבע לא דורש בנייה מחדש ═══
  // updatePillowColor מעדכן טקסטורה 1×1 ומצייר מחדש. נמדד: 1ms, לעומת ~2200ms
  // ליצירה מלאה. ה-mesh לא נגע בכלל. הפונקציה חשופה ב-custom-script.js.
  // בסיס הבד צבוע בצבע הכרית, ולכן הוא חייב להיצבע מחדש (baseCache).
  // בזמן גרירה בתוך Pickr מגיעים עשרות שינויים בשנייה — הציור מאוחד ל-rAF אחד,
  // וההיסטוריה נשמרת רק ב-"Select" / בלחיצה על צבע מהיר.
  let colorRaf = false;
  function setPillowColor(hex, o) {
    const h = normHex(hex); if (!h) return false;
    o = o || {};
    state.pillowColor = h;
    if (typeof window.updatePillowColor === 'function') window.updatePillowColor(h);
    baseCache = null;
    syncColorUI();
    updateSummary();
    if (!colorRaf) {
      colorRaf = true;
      requestAnimationFrame(() => { colorRaf = false; redraw(); pushToPillow(); });
    }
    if (o.history) pushHistory();
    if (o.announce) say('צבע הכרית: ' + colorName(h));
    return true;
  }

  // ═══ צבע הכיתוב — אותו בורר בדיוק כמו צבע הכרית (אלעד, 12.9) ═══
  // שורה מותאמת + 10 צבעים מהירים (אותם צבעים — PILLOW_COLORS) + Pickr משלו.
  // afterTextChange בודק גבולות, מצייר ודוחף — בזמן גרירה ב-Pickr זה מאוחד ל-rAF.
  function syncTextColorUI() {
    const hex = normHex(state.text.color) || state.text.color;
    const box = $('textColorPreviewBox'), out = $('textColorHexDisplay');
    if (box) box.style.background = hex;
    if (out) out.textContent = hex;
    for (const b of $('textColors').querySelectorAll('button')) {
      b.setAttribute('aria-pressed', String(b.dataset.hex.toUpperCase() === hex.toUpperCase()));
    }
  }
  let textColorRaf = false;
  function setTextColor(hex, o) {
    const h = normHex(hex); if (!h) return false;
    o = o || {};
    state.text.color = h;
    syncTextColorUI();
    if (!textColorRaf) {
      textColorRaf = true;
      requestAnimationFrame(() => { textColorRaf = false; afterTextChange(); });
    }
    if (o.history) pushHistory();
    if (o.announce) say('צבע הכיתוב: ' + colorName(h));
    return true;
  }

  // ═══ Pickr — בורר הצבע המותאם אישית, אותה תצורה כמו במוצר 1 ═══
  // הספרייה נטענת מה-CDN עם defer; מחכים לה עד ~6 שניות. בלעדיה השורה נשארת
  // תצוגה בלבד והצבעים המהירים עובדים — כמו במוצר 1 כשה-CDN לא זמין.
  // (12.9) אותו מפעל לשני הבוררים — צבע הכרית וצבע הכיתוב.
  function createPickr(cfg) {
    const p = window.Pickr.create({
      el: cfg.el, theme: 'nano', default: cfg.getColor(),
      position: 'bottom-start', swatches: null,
      components: { preview: true, opacity: false, hue: true, interaction: { hex: true, input: true, save: true } },
      i18n: { 'btn:save': '✓ Select' },
    });
    p.on('change', (c) => { if (c) cfg.onChange(c.toHEXA().toString().slice(0, 7)); });
    p.on('save', () => { pushHistory(); p.hide(); cfg.onSave(); });
    $(cfg.trigger).addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); p.show(); });
    return p;
  }
  let pickr = null, textPickr = null;
  function initPickr(attempt) {
    if (pickr || !$('colorPickr')) return;
    if (typeof window.Pickr === 'undefined') {
      if (attempt < 60) setTimeout(() => initPickr(attempt + 1), 100);
      else console.warn('Pickr לא נטען מה-CDN — בורר הצבע המותאם לא זמין (הצבעים המהירים עובדים).');
      return;
    }
    try {
      pickr = createPickr({ el: '#colorPickr', trigger: 'pickrTrigger', getColor: () => state.pillowColor,
        onChange: (h) => setPillowColor(h), onSave: () => say('צבע הכרית: ' + colorName(state.pillowColor)) });
      window.__pzPickr = pickr;   // לבדיקות
      if ($('textColorPickr')) {
        textPickr = createPickr({ el: '#textColorPickr', trigger: 'textPickrTrigger', getColor: () => state.text.color,
          onChange: (h) => setTextColor(h), onSave: () => say('צבע הכיתוב: ' + colorName(state.text.color)) });
        window.__pzTextPickr = textPickr;   // לבדיקות
      }
    } catch (err) {
      console.warn('בורר הצבע לא אותחל:', err);
    }
  }

  function buildSwatches(el, colors, current, onPick, cls) {
    el.innerHTML = '';
    for (const c of colors) {
      const b = document.createElement('button');
      b.type = 'button'; b.className = cls || 'sw';
      b.dataset.hex = c.hex;
      b.style.background = c.hex;
      // צבע בהיר: ה-✓ של הבחירה יהיה כהה (כמו במוצר 1)
      if (/^#F[0-9A-F]F[0-9A-F]F[0-9A-F]$/i.test(c.hex) || c.hex.toUpperCase() === '#FFFFFF') b.classList.add('light');
      b.setAttribute('aria-label', c.name);
      b.setAttribute('aria-pressed', String(c.hex === current));
      b.onclick = () => {
        [...el.children].forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
        onPick(c);
      };
      el.appendChild(b);
    }
  }

  // ─────────────────────────────────────────────
  //  הכיתוב — קלט ובקרות
  // ─────────────────────────────────────────────
  const SIZE_WORDS = [[58, 'קטן'], [78, 'בינוני'], [104, 'גדול'], [999, 'ענק']];
  function sizeWord(v) { return (SIZE_WORDS.find((s) => v <= s[0]) || SIZE_WORDS[3])[1]; }
  function syncSizeSlider() {
    // הסליידר מציג את הבחירה של הלקוח (sizeWanted) ולא את ההקטנה האוטומטית —
    // אחרת הידית "בורחת" בכל גרירה. ההסבר על ההקטנה מופיע ב-boundsHint.
    const v = Math.round((state.text.sizeWanted != null ? state.text.sizeWanted : state.text.sizeRatio) * 1000);
    $('tsize').value = v; $('tsizeOut').textContent = sizeWord(v);
  }

  function afterTextChange() {
    const has = !!state.text.text.trim();
    $('textTools').hidden = !has;
    const tb = $('modes').querySelector('.mode[data-mode=text]');
    if (tb) tb.hidden = !has;
    // בורר "גרירת התמונה / הכיתוב" רלוונטי רק כשיש כיתוב לגרור. בלי
    // כיתוב זה כפתור בודד וחסר טעם — מסתירים אותו כדי לא לעמס את המסך.
    syncModesVisibility();
    if (!has) { showSafe = false; if (dragMode === 'text') setMode('photo'); }   // בשלב 3 setMode משאיר 'text' — הראש נשאר נעול
    if (has) {
      const fits = ensureTextValid();
      $('boundsHint').classList.toggle('hidden', fits);
      if (!fits) {
        $('boundsHint').querySelector('span:last-child').textContent =
          'הכיתוב ארוך מדי לצורה הזו. קצרו אותו, או בחרו צורה גדולה יותר.';
      } else {
        $('boundsHint').querySelector('span:last-child').textContent =
          'הכיתוב הגיע לקצה. מחוץ לגבול הוא היה משנה את צורת הכרית עצמה, ולכן הוא נעצר כאן.';
      }
    } else {
      $('boundsHint').classList.add('hidden');
    }
    updateSummary();
    redraw();
    // הכיתוב הוא חלק מהמשטח, לא מהצורה — תמיד 1ms.
    pushToPillow();
  }

  $('msg').addEventListener('input', (e) => {
    const v = e.target.value.slice(0, window.PZText.MAX_CHARS);
    state.text.text = v;
    const n = v.length;
    $('msgCount').textContent = n + ' / ' + window.PZText.MAX_CHARS + ' תווים';
    $('msgCount').classList.toggle('over', n >= window.PZText.MAX_CHARS);
    afterTextChange();
  });

  // ═══ שאלת הכיתוב — כמו במוצר 1 (אלעד, 13.9) ═══
  // "כן, להוסיף כיתוב · +15 ₪" פותח את העורך; "המשך ללא כיתוב" מנקה ועובר לשלב הבא;
  // "שינוי" חוזר לשאלה. המחיר = ההפרש האמיתי בין הווריאנט "עם כיתוב" ל"ללא כיתוב"
  // באותה מידה (מ-PZ_CFG.product); מקומית / בלי מוצר — 15 ₪ כמו במוצר 1.
  // הווריאנט שנשלח לעגלה ממשיך להיקבע לפי "יש טקסט / אין" — הלוגיקה הזו לא השתנתה;
  // השאלה רק מוודאת שלא נשלח טקסט (=חיוב) בלי שהלקוח בחר בזה במפורש.
  const TEXT_PRICE_FALLBACK = 15;
  function textPriceDelta() {
    try {
      const cm = parseInt(String(state.size), 10);
      const vs = (PRODUCT && PRODUCT.variants || []).filter((v) => v.price != null && parseInt(String(v.size), 10) === cm);
      const w = vs.find((v) => /עם/.test(String(v.text))), wo = vs.find((v) => /ללא/.test(String(v.text)));
      if (w && wo && w.price - wo.price > 0) return w.price - wo.price;
    } catch (e) { /* נופלים לברירת המחדל */ }
    return TEXT_PRICE_FALLBACK;
  }
  function textPriceLabel() { const d = textPriceDelta(); return '+' + (Number.isInteger(d) ? d : d.toFixed(2)) + ' ₪'; }
  function syncTextAsk() {
    const yes = state.textAsk === 'yes';
    $('textAsk').hidden = yes;
    $('textChosen').hidden = !yes;
    $('textEditor').hidden = !yes;
    const lbl = textPriceLabel();
    $('textPriceTag').textContent = lbl;
    $('textPriceTag2').textContent = lbl;
  }
  function setTextAsk(v, o) {
    o = o || {};
    if (v === 'yes') {
      state.textAsk = 'yes';
      syncTextAsk();
      if (!o.silent) { try { $('msg').focus({ preventScroll: true }); } catch (e) {} say('אפשר להקליד את הכיתוב'); }
      return;
    }
    // 'no' / איפוס: אין כיתוב → אין חיוב
    state.textAsk = null;
    if (state.text.text) { state.text.text = ''; $('msg').value = ''; afterTextChange(); pushHistory(); }
    syncTextAsk();
    if (v === 'no') { say('ממשיכים בלי כיתוב'); showStep(curStep + 1); }
  }
  $('textYes').addEventListener('click', () => setTextAsk('yes'));
  $('textNo').addEventListener('click', () => setTextAsk('no'));
  $('textUndo').addEventListener('click', () => setTextAsk(null));
  window.__pzTextAsk = () => state.textAsk;            // לבדיקות
  window.__pzTextPrice = () => textPriceDelta();

  $('photoScale').addEventListener('input', (e) => {
    state.tscale = clampHead(Number(e.target.value) / 100);
    // מעבר לגבול אין יותר הקטנה שתציל את ההרכבה — הראש היה נחתך. עוצרים שם.
    if (clampScaleToComp()) syncPhotoSlider();
    else $('photoScaleOut').textContent = e.target.value + '%';
    reanchorHead();
    onArtChanged();
    maybeRebuildShape();
  });

  function syncPhotoSlider() {
    const sl = $('photoScale');
    if (!sl) return;
    sl.value = Math.round(clampHead(state.tscale) * 100);
    $('photoScaleOut').textContent = sl.value + '%';
    syncDropSlider();   // (13.9) אותם מקומות בדיוק — תבנית/תמונה/מידה חדשות
  }

  // ═══ הטיית הראש (אלעד, 10.9) ═══
  // מי שהצטלם בזווית יכול ליישר את הראש על הצוואר. אותו דפוס בדיוק כמו
  // סליידר "הטיה" של הכיתוב: מעלות, חיובי = עם כיוון השעון.
  // הטיה היא עדכון טקסטורה חי (~1ms). רק אם התיבה המסובבת חורגת
  // מהמסגרת, compFit משנה את k ואז — כמו בהגדלה — נבנית גיאומטריה מחדש.
  const TILT_MAX = 45;
  { const tl = $('photoTilt'); if (tl) tl.addEventListener('input', (e) => {
    state.trot = Math.max(-TILT_MAX, Math.min(TILT_MAX, Number(e.target.value) || 0));
    $('photoTiltOut').textContent = state.trot + '°';
    syncActiveSlot();
    // הטיה יכולה להגדיל את התיבה — אותה עצירה לפני חיתוך כמו בהגדלה
    if (clampScaleToComp()) syncPhotoSlider();
    onArtChanged();
    maybeRebuildShape();
  }); }
  { const tl = $('photoTilt'); if (tl) tl.addEventListener('change', () => pushHistory()); }   // Cmd+Z מחזיר הטיה
  // ═══ מיקום על הצוואר (אלעד, 13.9) ═══ סליידר 0..10 (% מגובה הכרית), רק כלפי מטה.
  { const d = $('photoDrop'); if (d) {
    d.addEventListener('input', (e) => setHeadDrop(Number(e.target.value) / 100));
    d.addEventListener('change', () => pushHistory());
  } }
  function syncTiltSlider() {
    const tl = $('photoTilt');
    if (!tl) return;
    tl.value = state.trot || 0;
    $('photoTiltOut').textContent = (state.trot || 0) + '°';
  }

  $('photoReset').addEventListener('click', () => {
    recenterPhoto();
    syncPhotoSlider();
    syncTiltSlider();
    syncDropSlider();
    onArtChanged();
    maybeRebuildShape();
    pushHistory();
    say('מיקום התמונה אופס');
  });

  $('tsize').addEventListener('input', (e) => {
    // הסליידר קובע את הגודל *המבוקש*; מה שמצויר הוא הגדול ביותר שנכנס במיקום הנוכחי.
    state.text.sizeWanted = Number(e.target.value) / 1000;
    $('tsizeOut').textContent = sizeWord(Number(e.target.value));
    const f = bestFitAt({ x: state.text.x, y: state.text.y });
    applyTextPlacement({ x: state.text.x, y: state.text.y },
                       f || { sizeRatio: TEXT_MIN_RATIO, wrapW: WRAPS[WRAPS.length - 1] });
    afterTextChange();
  });

  $('trot').addEventListener('input', (e) => {
    state.text.rotation = Number(e.target.value);
    $('trotOut').textContent = e.target.value + '°';
    afterTextChange();
  });

  // ═════════════════════════════════════════════
  //  שליטה בסיבוב הכרית
  // ═════════════════════════════════════════════
  // ═══ למה הכרית "לא ממורכזת" ═══
  // היא לא. היא *מסתובבת בלי הפסקה*. custom-script.js קובע
  // rotationSpeed = 0.25 בסוף אנימציית הכניסה (שורה 4083), ומאז
  // animate() ממשיך להזיז את rotY בכל פריים לנצח. צורה לא-סימטרית
  // שמסתובבת נראית כל רגע במקום אחר — וזה נקרא "יצאה הצידה".
  //
  // באתר תצוגה זה נחמד. בעורך שבו ממקמים תמונה על משטח, זה אומר
  // שהמטרה זזה בזמן שמכוונים אליה.
  //
  // rotY ו-rotationEnabled מוצהרים כ-let ברמת הסקריפט, ולכן הם לא
  // על window — אבל הם כן ב-binding הגלובלי המשותף לכל הסקריפטים
  // הקלאסיים בעמוד. new Function רץ ב-scope הגלובלי ובמצב לא-קפדני,
  // ולכן ההשמה מגיעה אליהם. נבדק בפועל.
  // המנוע קובע rotationSpeed = 0.25 בסוף אנימציית הכניסה. זה מהיר
  // מדי לצפייה במוצר. SPIN הוא סיבוב מלא בכ-45 שניות — מספיק כדי
  // לראות את שני הצדדים, לא מספיק כדי להפריע.
  // מהירות הסיבוב, רדיאן לשנייה. ~0.5 = סיבוב מלא בכ-12 שניות —
  // מהיר מספיק כדי להיראות בבירור, איטי מספיק כדי לא לסחרר.
  const SPIN = 0.5;

  // ═══ גישה לזווית הכרית ═══
  // rotY הוא let ברמת הסקריפט של המנוע — נגיש דרך ה-binding הגלובלי
  // המשותף לכל הסקריפטים הקלאסיים, ב-new Function שרץ ב-scope הגלובלי.
  const engineGetRotY = (() => {
    try { return new Function('return (typeof rotY !== "undefined") ? rotY : 0;'); }
    catch (e) { return null; }
  })();
  const engineSetRotY = (() => {
    try {
      return new Function('rad',
        'if (typeof rotationEnabled !== "undefined") rotationEnabled = false;' +
        'if (typeof rotY !== "undefined") rotY = rad;' +
        'if (typeof drawScene === "function") drawScene();');
    } catch (e) {
      console.warn('אין גישה לזווית הכרית:', e);
      return null;
    }
  })();
  // מכבה את הסיבוב האוטומטי *הפנימי* של המנוע. בלי זה הכרית מסתובבת
  // לבד (rotationEnabled=true הוא ברירת המחדל של המנוע) — אנחנו רוצים
  // שהיא תעמוד, ושרק הלולאה שלנו תסובב אותה בלחיצה.
  const engineStopAutoRotate = (() => {
    try {
      return new Function(
        'if (typeof rotationEnabled !== "undefined") rotationEnabled = false;');
    } catch (e) { return null; }
  })();

  // ═══ סיבוב הכרית — לולאה עצמאית ═══
  // לא נשענים על לולאת האנימציה הפנימית של המנוע (שיכולה להיעצר, למשל
  // כשהטאב ברקע או בסוף אנימציית הכניסה). מריצים rAF משלנו שמקדם את
  // rotY בכל פריים ומצייר. דטרמיניסטי, ועובד בכל מצב.
  let spinning = false;
  let spinRAF = null;
  let spinLast = 0;
  function spinFrame(now) {
    if (!spinning) { spinRAF = null; return; }
    const dt = Math.min(0.05, (now - spinLast) / 1000);   // רצפה נגד קפיצות אחרי השהיה
    spinLast = now;
    if (engineGetRotY && engineSetRotY) engineSetRotY(engineGetRotY() + dt * SPIN);
    syncRotorFromEngine();
    spinRAF = requestAnimationFrame(spinFrame);
  }
  function setSpin(on) {
    spinning = on;
    // תמיד מכבים את הסיבוב הפנימי של המנוע — את הסיבוב אנחנו מנהלים
    // בלולאה שלנו. כך "עצירה" באמת עוצרת, ו"סיבוב" מתחיל מאיתנו.
    if (engineStopAutoRotate) engineStopAutoRotate();
    const b = $('spinBtn');
    if (b) {
      b.setAttribute('aria-pressed', String(on));
      b.textContent = on ? '⏸  עצירה' : '▶  סיבוב';
    }
    if (on) {
      if (!spinRAF) { spinLast = performance.now(); spinRAF = requestAnimationFrame(spinFrame); }
    } else if (spinRAF) {
      cancelAnimationFrame(spinRAF); spinRAF = null;
    }
    say(on ? 'הכרית מסתובבת' : 'הכרית עומדת');
    return true;
  }
  const spinBtnEl = $('spinBtn');
  if (spinBtnEl) spinBtnEl.addEventListener('click', () => setSpin(!spinning));

  // ═══ סרגל הסיבוב הידני (דסקטופ) ═══
  // שליטה בזווית מדויקת. גרירה מכבה סיבוב אוטומטי וקובעת את הזווית.
  function syncRotorFromEngine() {
    const r = $('rotor');
    if (!r || !engineGetRotY) return;
    let deg = engineGetRotY() * 180 / Math.PI;
    // מנרמל ל-[-180,180] כדי שהסרגל לא "יברח" מהטווח בסיבוב מתמשך.
    deg = ((deg % 360) + 540) % 360 - 180;
    r.value = Math.round(deg);
  }
  const rotorEl = $('rotor');
  if (rotorEl) {
    rotorEl.addEventListener('input', (e) => {
      if (spinning) setSpin(false);           // גרירה ידנית מכבה סיבוב אוטומטי
      const deg = Number(e.target.value);
      if (engineSetRotY) engineSetRotY(deg * Math.PI / 180);
    });
  }
  const rotorFrontEl = $('rotorFront');
  if (rotorFrontEl) {
    rotorFrontEl.addEventListener('click', () => {
      if (spinning) setSpin(false);
      if (rotorEl) rotorEl.value = 0;
      if (engineSetRotY) engineSetRotY(0);
      say('הכרית חזרה לחזית');
    });
  }

  // ═════════════════════════════════════════════
  //  היסטוריה — ביטול וחזרה
  // ═════════════════════════════════════════════
  // אותו עיקרון שאנחנו עובדים לפיו בקוד: שום פעולה לא צריכה להיות
  // בלתי הפיכה. הלקוח מזיז, מגדיל, מחליף תבנית וצבע — וצריך שיוכל
  // לחזור צעד אחורה בלי להתחיל מהתחלה.
  //
  // נשמר רק המצב הניתן לשחזור, לא התמונה עצמה: היא כבדה ולא משתנה.
  let textHistTimer = null;
  const history = [];
  let histIdx = -1;
  let restoring = false;

  function snapshot() {
    return JSON.stringify({
      shape: state.shape, tx: state.tx, ty: state.ty, tscale: state.tscale, trot: state.trot || 0, hdy: state.hdy || 0,
      text: state.text, pillowColor: state.pillowColor, size: state.size, useBg: state.useBg,
    });
  }

  function pushHistory() {
    if (restoring || !state.userImg) return;
    const snap = snapshot();
    if (history[histIdx] === snap) return;      // שום דבר לא השתנה
    history.length = histIdx + 1;               // ענף חדש מוחק את ה"קדימה"
    history.push(snap);
    if (history.length > 40) history.shift();
    histIdx = history.length - 1;
    syncHistoryButtons();
  }

  function syncHistoryButtons() {
    const u = $('undoBtn'), r = $('redoBtn');
    if (!u) return;
    u.disabled = histIdx <= 0;
    r.disabled = histIdx >= history.length - 1;
  }

  async function applySnapshot(json) {
    const d = JSON.parse(json);
    const shapeChanged = d.shape !== state.shape;
    if (shapeChanged) await ensureTemplateLoaded(templates.find((t) => t.id === d.shape));
    const colorChanged = d.pillowColor !== state.pillowColor;
    Object.assign(state, {
      shape: d.shape, tx: d.tx, ty: d.ty, tscale: d.tscale, trot: d.trot || 0, hdy: d.hdy || 0,
      pillowColor: d.pillowColor, size: d.size,
    });
    if (d.useBg !== undefined && state.imgNoBg) {
      state.useBg = d.useBg;
      state.userImg = d.useBg ? state.imgWithBg : state.imgNoBg;
      syncBgButtons();
    }
    state.text = Object.assign({}, d.text);

    restoring = true;
    syncPhotoSlider();
    syncTiltSlider();
    syncDropSlider();
    syncSizeSlider();
    $('msg').value = state.text.text;
    $('msgCount').textContent = state.text.text.length + ' / ' + window.PZText.MAX_CHARS + ' תווים';
    $('textTools').hidden = !state.text.text.trim();
    $('trot').value = state.text.rotation;
    $('trotOut').textContent = state.text.rotation + '°';
    for (const b of $('shapes').querySelectorAll('.chip')) {
      b.setAttribute('aria-pressed', String(b.dataset.shape === state.shape));
    }
    syncColorUI();
    syncTextColorUI();   // (12.9) גם שורת צבע הכיתוב חוזרת עם Cmd+Z
    for (const b of $('sizes').querySelectorAll('.chip')) {
      b.setAttribute('aria-pressed', String(b.dataset.value === state.size));
    }
    applySizeToEngine();
    for (const b of $('fonts').querySelectorAll('.fontbtn')) {
      b.setAttribute('aria-pressed', String(b.dataset.font === state.text.font));
    }
    baseCache = null;
    rebuildSafeGrid();
    redraw();
    updateSummary();

    // שינוי צורה מחייב בנייה מחדש; כל השאר הוא החלפת משטח.
    if (shapeChanged || shapeChangesWithPhoto()) buildPillow({ quiet: true });
    else {
      if (colorChanged && typeof window.updatePillowColor === 'function') {
        window.updatePillowColor(state.pillowColor);
      }
      pushToPillow();
    }
    restoring = false;
    syncHistoryButtons();
  }

  function undo() {
    if (histIdx <= 0) return;
    histIdx--; applySnapshot(history[histIdx]);
    say('בוטל');
  }
  function redo() {
    if (histIdx >= history.length - 1) return;
    histIdx++; applySnapshot(history[histIdx]);
    say('שוחזר');
  }

  document.addEventListener('keydown', (e) => {
    if (!(e.metaKey || e.ctrlKey) || e.key.toLowerCase() !== 'z') return;
    if (/^(INPUT|TEXTAREA)$/.test(document.activeElement.tagName)) return;
    e.preventDefault();
    e.shiftKey ? redo() : undo();
  });

  // ═════════════════════════════════════════════
  //  אינטראקציה — הכרית עצמה היא משטח העריכה
  // ═════════════════════════════════════════════
  // ═══ למה צריך להשתלט על האירועים ═══
  // custom-script.js כבר רושם על הקנבס mousedown/touchstart לסיבוב
  // ו-wheel לזום (שורות 3371-3377). בלי השתלטות, גרירה הייתה מסובבת
  // את הכרית במקום להזיז את התמונה.
  //
  // מאזין ב-*שלב הלכידה* על ההורה רץ לפני המאזינים של המנוע ועוצר
  // אותם עם stopPropagation. במצב "סיבוב" פשוט לא עוצרים, והמנוע
  // עושה את שלו — בלי שנגענו בו.
  const stage = $('stage');
  let dragMode = 'photo';
  let dragging = false;
  let lastPt = null;

  function syncModeAvailability() {
    const free = shapeChangesWithPhoto();
    const pb = $('modes').querySelector('.mode[data-mode=photo]');
    if (pb) {
      pb.disabled = free;
      pb.title = free ? 'בצורה חופשית התמונה היא הצורה — אין מה למקם' : '';
    }
    const hint = $('photoHint');
    if (hint) {
      hint.innerHTML = free
        ? '<span aria-hidden="true">💡</span><span>בצורה חופשית <b>התמונה היא הצורה</b> של הכרית, ולכן אין לתוכה מה למקם — היא תמיד ממורכזת. בחרו תבנית (לב, גיבור) כדי למקם ולהגדיל את התמונה בתוכה.</span>'
        : '<span aria-hidden="true">🔍</span><span>הראש ממוקם אוטומטית על הצוואר. אפשר להגדיל ולהקטין אותו — בסליידר, בגלגלת, או בצביטה בשתי אצבעות.</span>';
    }
    // (12.9) הראש מקובע ולכן אין "מצב גרירת תמונה" שצריך להחליף — השלב קובע.
  }

  // ═══ מצב הגרירה נקבע לפי השלב (אלעד, 10.9) ═══
  // שלב 2 (התמונה): גוררים תמונה בלבד. שלב 3 (כיתוב): גוררים כיתוב בלבד —
  // הראש נעול לגרירה, לגלגלת ולמקשי החיצים, כדי שמיקום שכבר סודר לא
  // ייהרס בטעות. בשאר השלבים (4–5) הבורר "מה גוררים" חוזר, כמו שהיה.
  // null = אין נעילה, הבחירה של המשתמש קובעת.
  // שלב 2 = גודל הראש (סליידר/גלגלת/צביטה), שלב 3 = גרירת כיתוב,
  // שלב 4 ואילך = 'none': הכרית מוכנה, בוחרים רק צבע ומידה ושום דבר לא זז.
  function stepDragMode() {
    if (curStep === 2) return 'photo';
    if (curStep === 3) return 'text';
    return 'none';
  }
  /** הבורר "מה גוררים" מיותר: הראש מקובע תמיד, והכיתוב נגרר רק בשלב שלו. */
  function syncModesVisibility() { $('modes').hidden = true; }

  function setMode(m) {
    // כשהשלב נועל את המצב — בקשה למצב אחר נבלעת (גם מכפתור מוסתר, גם מקוד).
    const forced = stepDragMode();
    if (forced && m !== forced) m = forced;
    dragMode = m;
    for (const b of $('modes').querySelectorAll('.mode')) {
      if (b.dataset.mode) b.setAttribute('aria-pressed', String(b.dataset.mode === m));
    }
    const names = { photo: 'גרירת התמונה', text: 'גרירת הכיתוב' };
    say(names[m] || m);
  }

  // כפתורי ביטול/שחזור הוסרו מה-UI; קיצור המקלדת (Cmd/Ctrl+Z) עדיין
  // עובד. השארנו את הלוגיקה כדי לא לשבור את ההיסטוריה.
  { const ub = $('undoBtn'); if (ub) ub.addEventListener('click', undo); }
  { const rb = $('redoBtn'); if (rb) rb.addEventListener('click', redo); }

  // הבורר מוסתר תמיד (הראש מקובע, הכיתוב נגרר רק בשלב שלו) — המאזין נשאר
  // כדי שאם נחזיר אותו אי-פעם, הוא פשוט יעבוד.
  $('modes').addEventListener('click', (e) => {
    const b = e.target.closest('.mode');
    if (b) setMode(b.dataset.mode);
  });

  const swallow = (e) => {
    if (!state.userImg) return;
    // ═══ משלב 4 הכרית מוכנה — האירוע ממשיך למנוע, והוא מסובב אותה (אלעד, 12.9) ═══
    // בשלבים 1–3 הבמה היא משטח עריכה (ראש/כיתוב) ולכן שם בולעים.
    if (curStep >= SPIN_STEP) return;
    e.stopPropagation();
  };
  // רק mousedown ו-touchstart — אלה המאזינים שהמנוע באמת רושם.
  // אין לכלול pointerdown: stopPropagation בשלב הלכידה על ההורה מונע
  // מהאירוע להגיע ליעד *ולחזור בבעבוע*, כלומר היה חוסם את מאזין
  // הגרירה שלנו עצמו.
  for (const type of ['mousedown', 'touchstart']) {
    stage.addEventListener(type, swallow, true);
  }

  const toUnit = (e) => {
    const r = stage.getBoundingClientRect();
    return { x: (e.clientX - r.left) / r.width, y: (e.clientY - r.top) / r.height };
  };

  // ═══ צביטה בשתי אצבעות (אלעד, 11.9) ═══
  // עד עכשיו הבמה הכירה אצבע אחת: lastPt יחיד, וכששתי אצבעות נגעו — שתיהן
  // הזינו אותו, וכל תזוזה של אצבע 2 נראתה כ"קפיצה" של אצבע 1 (הראש התפרע).
  // עכשיו: מעקב אחרי כל האצבעות (pointers). אצבע אחת = גרירה כמו קודם.
  // שתי אצבעות (רק במצב תמונה) = צביטה: יחס המרחק → tscale, תזוזת האמצע → tx/ty.
  // בדסקטופ אין שתי אצבעות, ולכן אפס שינוי שם.
  const pointers = new Map();          // pointerId → נקודה ביחידות במה
  let pinch = null;                    // { dist, mid, scale0 } בזמן צביטה
  let headDrop = null;                 // { y0, hdy0 } בזמן גרירת הראש על הצוואר (שלב 2)
  const twoPts = () => [...pointers.values()].slice(0, 2);
  const ptsDist = (a, b) => Math.hypot(a.x - b.x, a.y - b.y);
  const ptsMid = (a, b) => ({ x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 });

  // מאחדים תזוזות אצבע לפריים אחד: החיפוש הראשון בונה את מפות ההתאמה (עשרות ms),
  // ואחריו כל שאילתה זולה — אבל אין טעם לחשב יותר מפעם אחת בין שני ציורים.
  let textNearPending = null, textNearRaf = false;
  function queueTextNear(pt) {
    textNearPending = pt;
    if (textNearRaf) return;
    textNearRaf = true;
    requestAnimationFrame(() => {
      textNearRaf = false;
      const pt2 = textNearPending; textNearPending = null;
      if (!pt2 || dragMode !== 'text' || !state.text.text.trim()) return;
      const hint = $('boundsHint');
      if (placeTextNear(pt2)) {
        redraw(); pushToPillow();
      } else if (hint) {
        hint.classList.remove('hidden');
        hint.querySelector('span:last-child').textContent =
          'כאן אין מקום לכיתוב גם בגודל הקטן ביותר. נסו מקום אחר על הכרית.';
      }
    });
  }

  stage.addEventListener('pointerdown', (e) => {
    if (!state.userImg) return;
    // ═══ הראש מקובע (אלעד, 12.9) ═══ אי אפשר לגרור אותו בשום שלב ובשום מכשיר.
    // שלב 2: שתי אצבעות = זום בלבד. שלב 3: גוררים כיתוב. שלב 4+: כלום.
    const canPinch = dragMode === 'photo' && !shapeChangesWithPhoto();
    const canDragText = dragMode === 'text' && !!state.text.text.trim();
    // ═══ מיקום על הצוואר בגרירה (אלעד, 13.9) ═══ אצבע/עכבר אחד בשלב התמונה (2) בלבד,
    // ורק בתבנית צוואר: מזיז את הראש למעלה/למטה על ציר הצוואר, בטווח הסליידר. אחרי
    // שלב 2 — נעול (כמו הגודל). אופקית — לא זז.
    const canDropHead = canPinch && curStep === 2 && (templates.find((t) => t.id === state.shape) || {}).mode === 'neck';
    // משלב 4: נגיעה/לחיצה עוצרת את הסיבוב האוטומטי — מכאן המנוע מסובב לפי האצבע.
    if (curStep >= SPIN_STEP && spinning) setSpin(false);
    if (!canPinch && !canDragText) return;
    const p = toUnit(e);
    pointers.set(e.pointerId, p);
    try { stage.setPointerCapture(e.pointerId); } catch (_) {}   // אירועים סינתטיים (בדיקות) — בלי מצביע אמיתי
    e.preventDefault();
    if (pointers.size === 1) {
      dragging = canDragText || canDropHead;   // אצבע אחת: כיתוב (שלב 3) או מיקום הראש על הצוואר (שלב 2)
      headDrop = canDropHead ? { y0: p.y, hdy0: state.hdy || 0 } : null;
      lastPt = p;
      if (canDragText) {
        setGuide(true);
        // מובייל: כבר בנגיעה הראשונה הכיתוב עובר אל האצבע (ראו placeTextNear)
        if (isMobileLayout()) queueTextNear(p);
      }
      return;
    }
    if (pointers.size === 2 && canPinch) {
      const [a, b] = twoPts();
      pinch = { kind: 'head', dist: Math.max(1e-4, ptsDist(a, b)), scale0: state.tscale };
      headDrop = null;                 // שתי אצבעות = זום, לא הזזה
      dragging = true;                 // כדי ש-pointermove/endDrag יטופלו
    } else if (pointers.size === 2 && canDragText) {
      // ═══ צביטה בשלב הכיתוב = גודל הכיתוב (אלעד, 12.9) ═══ אותו טווח כמו הסליידר.
      const [a, b] = twoPts();
      pinch = { kind: 'text', dist: Math.max(1e-4, ptsDist(a, b)), size0: wantedRatio() };
      textNearPending = null;          // אצבע אחת כבר לא גוררת — שתיים משנות גודל
      dragging = true;
    }
    // אצבע שלישית ומעלה — מתעלמים (נשארים עם שתי הראשונות)
  });

  stage.addEventListener('pointermove', (e) => {
    if (!dragging || !pointers.has(e.pointerId)) return;
    const p = toUnit(e);
    pointers.set(e.pointerId, p);

    if (pinch && pointers.size >= 2) {
      const [a, b] = twoPts();
      if (pinch.kind === 'text') {
        // גודל הכיתוב המבוקש עוקב אחרי יחס המרחקים; מה שמצויר הוא הגדול ביותר
        // שנכנס במקום הנוכחי (כמו הסליידר) — הכלל הקשה נשמר.
        const el = $('tsize');
        const lo = Number(el.min) / 1000, hi = Number(el.max) / 1000;
        state.text.sizeWanted = Math.min(hi, Math.max(lo, pinch.size0 * ptsDist(a, b) / pinch.dist));
        const f = bestFitAt({ x: state.text.x, y: state.text.y });
        applyTextPlacement({ x: state.text.x, y: state.text.y },
                           f || { sizeRatio: TEXT_MIN_RATIO, wrapW: WRAPS[WRAPS.length - 1] });
        redraw(); pushToPillow();
        return;
      }
      // ═══ צביטה = זום בלבד ═══ הגודל לפי יחס המרחקים ביחס לתחילת הצביטה
      // (בלי הצטברות שגיאות). הראש לא זז — הוא מקובע על הצוואר.
      state.tscale = clampHead(pinch.scale0 * ptsDist(a, b) / pinch.dist);
      clampScaleToComp();
      reanchorHead();
      syncPhotoSlider();
      onArtChanged();
      return;
    }
    if (pointers.size >= 2) return;     // אצבע שנייה במצב כיתוב — לא מזיזה כלום
    const dx = p.x - lastPt.x, dy = p.y - lastPt.y;
    lastPt = p;

    // ═══ גרירת הראש במורד הצוואר (13.9) ═══ יחידות הבמה ≈ שבר מהקנבס (הבמה מציגה את
    // ההרכבה). רק הציר האנכי; מוגבל לטווח הסליידר (0 = על הצוואר).
    if (headDrop) {
      state.hdy = clampDrop(headDrop.hdy0 + (p.y - headDrop.y0));
      if (reanchorHead()) { syncActiveSlot(); if (clampScaleToComp()) syncPhotoSlider(); syncDropSlider(); onArtChanged(); }
      return;
    }

    // ═══ הראש מקובע (12.9) ═══ אין כאן יותר סניף של גרירת התמונה: הראש יושב על
    // הצוואר ואפשר רק לשנות את גודלו. מכאן והלאה — כיתוב בלבד.
    if (dragMode !== 'text') return;

    // מובייל: האצבע היא היעד — לא "כמה זזה" אלא "איפה היא". דסקטופ: כמו שהיה.
    if (isMobileLayout()) { queueTextNear(p); return; }

    // כיתוב — placeText מקטין/מחליק במקום לדחות (ראו TEXT_MIN_RATIO)
    const cand = { x: Math.min(1, Math.max(0, state.text.x + dx)),
                   y: Math.min(1, Math.max(0, state.text.y + dy)) };
    if (!placeText(cand)) {
      const hint = $('boundsHint');
      if (hint) {
        hint.classList.remove('hidden');
        hint.querySelector('span:last-child').textContent =
          'כאן אין מקום לכיתוב גם בגודל הקטן ביותר. נסו מקום אחר על הכרית.';
      }
    }
    redraw();
    pushToPillow();
  });

  const endDrag = (e) => {
    // ═══ הבאג מהאייפון (12.9): "מגדיל, ואז לא נותן להקטין" ═══
    // האצבע השנייה של הצביטה הורמה כש-dragging כבר היה false (האצבע הראשונה
    // כיבתה אותו), ולכן החזרה המוקדמת השאירה אותה במפה לתמיד. הצביטה הבאה
    // חישבה מרחק מול נקודה "רפאים" — והגודל נתקע. לכן קודם מנקים, ורק אז יוצאים.
    pointers.delete(e.pointerId);
    try { stage.releasePointerCapture(e.pointerId); } catch (_) {}
    if (!dragging) { if (!pointers.size) pinch = null; return; }
    if (pointers.size > 0) {
      // אצבע אחת הורמה מתוך צביטה. הראש מקובע, ולכן האצבע שנשארה לא תזיז אותו.
      // בשלב הכיתוב: אחרי צביטת-גודל האצבע שנשארה *לא* גוררת (אחרת הכיתוב היה
      // קופץ אליה ברגע ההרמה); רק גרירה שהתחילה באצבע אחת ממשיכה.
      const wasTextPinch = pinch && pinch.kind === 'text';
      pinch = null;
      lastPt = pointers.values().next().value;
      dragging = !wasTextPinch && dragMode === 'text' && !!state.text.text.trim();
      if (wasTextPinch) pushHistory();
      return;
    }
    dragging = false;
    pinch = null;
    headDrop = null;
    setGuide(false);
    $('boundsHint').classList.add('hidden');

    if (dragMode === 'text') {
      // בזמן גרירה מותר להיכנס למצב חורג כדי שהתנועה תרגיש רציפה,
      // אבל *לסיים* שם זה מלכודת: משם כל תזוזה קטנה נדחית והכיתוב
      // נתקע בלי דרך חזרה, כולל למקלדת.
      if (textViolations() > 0) {
        state.text.x = lastValidText.x;
        state.text.y = lastValidText.y;
        if (textViolations() > 0) ensureTextValid();
        redraw(); pushToPillow();
        say('הכיתוב הוחזר למיקום האחרון שנכנס בגבולות');
      }
    } else {
      maybeRebuildShape();
    }
    pushHistory();
  };
  stage.addEventListener('pointerup', endDrag);
  stage.addEventListener('pointercancel', endDrag);

  stage.addEventListener('wheel', (e) => {
    if (!state.userImg) return;
    e.preventDefault();
    e.stopPropagation();
    // הגודל משתנה רק בשלב התמונה (שלב 2). אחריו הראש מקובע לגמרי.
    if (stepDragMode() !== 'photo') return;
    const k = e.deltaY < 0 ? 1.06 : 1 / 1.06;
    state.tscale = clampHead(state.tscale * k);
    clampScaleToComp();
    reanchorHead();
    syncPhotoSlider();
    onArtChanged();
    maybeRebuildShape();
  }, { capture: true, passive: false });

  // ═══ מקלדת ═══
  // גרירה בעכבר היא לא הדרך היחידה. WCAG 2.1.1 דורש שכל פעולה תהיה
  // זמינה גם מהמקלדת.
  stage.setAttribute('tabindex', '0');
  let keyRebuild = null;
  stage.addEventListener('keydown', (e) => {
    if (!state.userImg) return;
    const step = e.shiftKey ? .04 : .008;
    const d = { ArrowUp: [0, -step], ArrowDown: [0, step], ArrowLeft: [-step, 0], ArrowRight: [step, 0] }[e.key];
    if (!d) return;
    e.preventDefault();
    // הראש מקובע — מקשי החיצים מזיזים רק כיתוב (שלב 3).
    if (dragMode !== 'text' || !state.text.text.trim()) return;
    const cand = { x: Math.min(1, Math.max(0, state.text.x + d[0])),
                   y: Math.min(1, Math.max(0, state.text.y + d[1])) };
    if (placeText(cand)) { redraw(); pushToPillow(); }
    else say('כאן אין מקום לכיתוב גם בגודל הקטן ביותר');
  });

  // ─────────────────────────────────────────────
  //  העלאת תמונה
  // ─────────────────────────────────────────────
  const readFile = (f) => new Promise((res, rej) => {
    const r = new FileReader();
    r.onload = () => res(r.result);
    r.onerror = () => rej(new Error('קריאת הקובץ נכשלה'));
    r.readAsDataURL(f);
  });

  // ═══ חיווי טעינה בזמן ההעלאה ═══
  // הקריאה ל-Lambda לוקחת 4–9 שניות. בלי חיווי נראה שכלום לא קורה.
  // מציגים במקביל: שכבה על הכרית, וספינר על אזור ההעלאה עצמו.
  function uploading(on, label) {
    window.__pzUploading = !!on;
    document.body.classList.toggle('is-uploading', !!on);
    const ov = $('stageLoad');
    if (ov) { ov.hidden = !on; const t = ov.querySelector('.load__txt'); if (t && label) t.textContent = label; }
    const dl = $('dropLoad');
    if (dl) { dl.hidden = !on; const t = dl.querySelector('.load__txt'); if (t && label) t.textContent = label; }
    for (const id of ['file', 'fileCam']) { const el = $(id); if (el) el.disabled = !!on; }
  }

  async function handleFile(f) {
    if (!f) return;
    // HEIC מגיע לעיתים בלי MIME (Chrome/Windows) — מזהים גם לפי הסיומת; upload-prep מטפל בהמשך.
    if (!/^image\//.test(f.type) && !/\.hei[cf]$/i.test(f.name || '')) { $('uploadStatus').innerHTML = '<b>הקובץ אינו תמונה.</b>'; return; }
    $('uploadStatus').textContent = 'מסיר רקע…';
    uploading(true, 'מסיר רקע ומאתר את הפנים…');
    say('מעבד את התמונה');
    try {
      let src, bgFailed = false, prepped = null;
      try {
        // ═══ חובה להקטין לפני השליחה ═══
        // Lambda Function URL מוגבל ל-6MB, והגוף מנופח ב-33% ב-base64.
        // בלי זה תמונת טלפון מקבלת 413 עוד לפני שהקוד בענן רץ.
        prepped = await window.PZUpload.prepare(f);
        if (prepped.report.changed) {
          $('uploadStatus').textContent = 'מסיר רקע… ' + window.PZUpload.describe(prepped.report);
        }
        const fd = new FormData();
        fd.append('image', prepped.file);
        fd.append('want_head', 'true');   // ה-mock וה-Lambda של מוצר 1 מתעלמים; Lambda הראש מחזיר heads[]
        // ה-Lambda מעביר את זה ל-webhook "שימוש במודל" ב-Make, כדי שיהיה ברור מאיזה מוצר הגיעה הקריאה (אלעד, 13.9)
        fd.append('pz_model', WEBHOOK_MODEL);
        // מובייל/דסקטופ גם בדיווח "שימוש במודל" — אותם ערכים בדיוק כמו בשני ה-webhooks של העגלה
        const devInfo = deviceInfo();
        fd.append('pz_device', devInfo.device);
        fd.append('pz_screen', devInfo.screen);
        fd.append('pz_touch', devInfo.touch);
        // ═══ סיווג הכשל (אלעד, 12.9) ═══ err.service=true פירושו "הבעיה אצלנו,
        // לא בתמונה" — רשת, 5xx, תשובה לא תקינה. אז ההודעה ללקוח שונה.
        const svc = (m) => { const e = new Error(m); e.service = true; return e; };
        let r;
        try { r = await fetch(LAMBDA, { method: 'POST', body: fd }); }
        catch (e) { throw svc('הבקשה נכשלה: ' + e.message); }
        if (!r.ok) throw svc('שרת: ' + r.status);
        let j;
        try { j = await r.json(); }
        catch (e) { throw svc('תשובה לא תקינה מהשרת'); }
        // הכתובת נשמרת לפני כל הסתעפות, כך שהיא קיימת בכל מצב (ראש / בלי ראש / mock).
        if (j && typeof j.original_url === 'string') state.imageUrl = j.original_url;
        // ═══ אין פנים → עוצרים כאן ═══
        // לא ממשיכים לתבנית עם תמונה בלי פנים; הלקוח מקבל הודעה וכפתור לתמונה אחרת.
        // המצב הקודם (אם הייתה תמונה) נשאר כפי שהוא.
        if (j.head_status === 'no_face') { uploading(false); showNoFace(); return; }
        if (Array.isArray(j.heads) && j.heads.length) {
          // ═══ יש ראש(ים) מה-Lambda ═══
          state.headResp = { j, origUrl: await readFile(f), origFile: prepped.file };   // origFile → העגלה (Upload Image)
          // ═══ תמונה אחת עם כמה אנשים, ותבנית שמקבלת בדיוק כמה ═══
          // (זוג שמעלה תמונה משותפת) — ממלאים את כל הסלוטים לפי סדר שמאל-לימין,
          // והלקוח יכול להחליף כל אחד בנפרד. אחרת: בוחרים ראש לסלוט הפעיל.
          const n = slotCount();
          if (n > 1 && j.heads.length >= n && (state.isDemo || !state.slots.slice(0, n).some(slotFilled))) {
            uploading(false);
            await autoFillSlots(state.headResp);
            return;
          }
          uploading(false);                                       // הבורר דורש החלטה — לא מסתירים אותו מאחורי שכבה
          const idx = await chooseHead(state.headResp);          // ראש אחד → מיד; יותר → "מי עולה על הכרית?"
          await applyHead(idx, /*firstTime*/ true);
          return;
        }
        // ═══ תבנית צוואר חייבת ראש חתוך ═══ (ראו REQUIRE_HEAD)
        if (REQUIRE_HEAD) {
          const tplNow = templates.find((t) => t.id === state.shape);
          if (tplNow && (tplNow.mode === 'neck' || tplNow.mode === 'face')) {
            console.warn('התשובה לא כללה ראש חתוך (heads) — לא ממשיכים עם הגזרה המלאה.', { head_status: j.head_status });
            uploading(false);
            showNoFace();
            return;
          }
        }
        src = j.resized_image_data
          ? (String(j.resized_image_data).startsWith('data:') ? j.resized_image_data
             : 'data:' + (j.resized_image_data_mime || 'image/png') + ';base64,' + j.resized_image_data)
          : j.url;
        if (!src) throw svc('לא התקבלה תמונה');
      } catch (err) {
        console.warn('הסרת רקע נכשלה:', err);
        // ═══ תבנית שדורשת גזרת ראש — לא ממשיכים עם המקור (אלעד, 11.9) ═══
        // במוצר 1 התמונה *היא* הכרית, ולכן "ממשיכים עם המקורית" הוא פשרה סבירה.
        // כאן הראש מודבק על צוואר: תמונה עם רקע נראית כמו מלבן עם רקע — והלקוח
        // יכול להזמין אותה ככה. לכן עוצרים ומבקשים תמונה אחרת. מצב קודם (אם
        // הייתה תמונה טובה) נשאר כמו שהוא, כולל העגלה.
        {
          const tplNow = templates.find((t) => t.id === state.shape);
          if (!ALLOW_NO_HEAD && tplNow && (tplNow.mode === 'neck' || tplNow.mode === 'face')) {
            uploading(false);
            // שרת/רשת → "השירות לא זמין" (לא מאשימים את התמונה); אחרת → נסו תמונה אחרת
            showRetry(err && err.service ? COPY.serviceDown : COPY.bgFailed,
                      DEBUG ? '<br><span style="color:#5F5F5F">[' + err.message + ']</span>' : '');
            return;
          }
        }
        // מצבי photo/fill (התמונה היא הצורה): ממשיכים עם המקורית, ואומרים זאת במפורש —
        // נפילה שקטה כאן נראית בדיוק כמו הצלחה, וזה בדיוק איך שמפספסים באג.
        $('uploadStatus').innerHTML =
          '<b>לא הצלחנו להסיר את הרקע הפעם.</b><br>' +
          '<span style="color:#5F5F5F">ממשיכים עם התמונה המקורית — אפשר להמשיך כך, או לנסות תמונה אחרת.' +
          (DEBUG ? ' [' + err.message + ' · Network → generatemodel]' : '') + '</span>';
        src = await readFile(f);
        bgFailed = true;
      }

      state.imgNoBg = await downscale(await loadImg(src));
      state.imgWithBg = bgFailed ? state.imgNoBg
                                 : await downscale(await loadImg(await readFile(f)));
      state.headResp = null;
      state.origFile = prepped ? prepped.file : f;   // המקור של הלקוח — נשלח לעגלה כ-Upload Image
      state.headEst = bgFailed ? null : estimateHead(state.imgNoBg);
      uploading(false);
      afterImageReady(bgFailed ? 'bgFailed' : 'legacy');
    } catch (err) {
      uploading(false);
      const heic = /hei[cf]/i.test(f.type) || /\.hei[cf]$/i.test(f.name || '');
      $('uploadStatus').innerHTML = heic
        ? '<b>הדפדפן לא מצליח לפתוח תמונת HEIC.</b><br><span style="color:#5F5F5F">שלחו את התמונה לעצמכם בוואטסאפ ובחרו אותה משם, או בחרו תמונת JPG/PNG.</span>'
        : '<b>לא הצלחנו לפתוח את התמונה.</b> <span style="color:#5F5F5F">נסו תמונת JPG או PNG אחרת.' + (DEBUG ? ' [' + err.message + ']' : '') + '</span>';
    }
  }

  /**
   * הצעד המשותף אחרי שיש תמונה בזיכרון (imgNoBg/imgWithBg/headEst מוכנים):
   * מציג את שאר השלבים, בונה את הכרית, מעדכן היסטוריה.
   * mode: 'legacy' (גזרה מלאה) | 'bgFailed' (המקורית) | 'head' (ראש מה-Lambda)
   */
  function afterImageReady(mode, quiet) {
    const bgFailed = mode === 'bgFailed';
    // ═══ יציאה מדמו ═══ תמונות הדוגמה בשאר הסלוטים אינן של הלקוח — מנקים אותן,
    // כדי שהוא יראה בבירור למי עוד חסרה תמונה.
    if (state.isDemo) for (let i = 0; i < state.slots.length; i++) if (i !== state.activeSlot) state.slots[i] = {};
    {
      state.useBg = false;
      state.userImg = state.imgNoBg;
      syncBgButtons();
      recenterPhoto();
      rebuildSafeGrid();
      ensureTextValid();

      $('emptyState').style.display = 'none';
      // תמונה אמיתית מחליפה את הדמו — יוצאים ממצב דוגמה ופותחים את העגלה.
      state.isDemo = false;
      document.body.classList.remove('is-demo');
      syncBgToggleVisibility();
      // מכאן ואילך שאר השלבים מוצגים. עד עכשיו הם היו מוסתרים במובייל —
      // אין טעם להציג בחירת צורה, כיתוב וצבע לפני שיש תמונה לעבוד עליה.
      document.body.classList.add('has-image');
      showStep(2);   // שלב התמונה — שם כלי המיקום
      syncActiveSlot();
      updateCartGate();
      $('photoTools').hidden = false;
      renderSlots();
      syncModesVisibility();                        // בורר גרירה רק אם יש כיתוב והשלב לא נועל
      syncModeAvailability();
      if (!bgFailed) {
        // מדידת שקיפות היא הבדיקה היחידה שבאמת אומרת אם הרקע הוסר.
        const n = 200;
        const pc = document.createElement('canvas'); pc.width = pc.height = n;
        const px2 = pc.getContext('2d', { willReadFrequently: true });
        px2.clearRect(0, 0, n, n);
        px2.drawImage(state.userImg, 0, 0, n, n);
        const dd = px2.getImageData(0, 0, n, n).data;
        let clear = 0;
        for (let i = 3; i < dd.length; i += 4) if (dd[i] < 16) clear++;
        const pct = Math.round(clear / (n * n) * 100);
        const via = BACKEND === 'mock' ? 'mock מקומי — מחזיר תמיד את אותה דוגמה' : BACKEND === 'head' ? 'Lambda ראש מקומי' : 'Lambda אמיתי';
        const dbg = DEBUG ? ' <span style="color:#8A8A8A">[' + pct + '% שקיפות · ' + via + ']</span>' : '';
        let extra = '';
        if (mode === 'head' && state.headResp && state.headResp.j.heads.length > 1) {
          // אפשר להתחרט: חזרה ל"מי עולה על הכרית?" בלי העלאה חוזרת ובלי עלות.
          extra = ' <button type="button" class="linkbtn" id="headChange">' + COPY.pickChange + ' (' + state.headResp.j.heads.length + ' בתמונה)</button>';
        }
        $('uploadStatus').innerHTML = pct < 2
          ? '<b>נראה שהרקע לא הוסר.</b> אפשר להמשיך כך, או לנסות תמונה עם רקע פשוט יותר.' + dbg
          // (12.9) הראש מקובע — אין יותר גרירה. מפנים לסליידר הגודל.
          : 'התמונה מוכנה ✓ אפשר לכוון את גודל הראש ואת ההטיה למטה.' + extra + dbg;
        const chg = $('headChange');
        if (chg) chg.addEventListener('click', async () => { const i = await chooseHead(state.headResp, true); await applyHead(i, false); });
      }
      if (quiet) { syncActiveSlot(); return; }
      say('התמונה מוכנה');
      updateSummary();
      redraw();
      // הכרית מופיעה מיד, בלי לחיצה. זו נקודת הכניסה היחידה שעולה
      // 2.2 שניות; משם והלאה הכל חי.
      buildPillow();
      pushHistory();
    }
  }

  // ═══ "לא זוהו פנים" ═══
  /** מסך "לא הצלחנו — נסו תמונה אחרת". לא נוגע בתמונה שכבר מוצגת (אם יש). */
  function showRetry(msg, extra) {
    state.headResp = null;
    $('headPick').hidden = true;
    $('uploadStatus').innerHTML =
      '<b>' + msg + '</b>' + (extra || '') + '<br>' +
      '<label class="btn ghost" for="file" style="display:inline-flex;align-items:center;margin-top:8px">' + COPY.noFaceBtn + '</label>';
    say(msg);
  }

  function showNoFace() { showRetry(COPY.noFace); }

  // ═══ "מי עולה על הכרית?" ═══
  // מציג את התמונה המקורית עם עיגולים ממוספרים על הראשים שה-Lambda מצא.
  // ראש אחד → מחזיר 0 מיד, בלי שאלה. force=true פותח את הבחירה גם לראש יחיד (לא בשימוש כרגע).
  function chooseHead(resp, force) {
    const heads = resp.j.heads;
    if (heads.length <= 1 && !force) return Promise.resolve(0);
    return new Promise(async (resolve) => {
      const box = $('headPick'), cv = $('headPickCv'), btns = $('headPickBtns');
      $('headPickTitle').textContent = COPY.pickTitle;
      $('headPickHint').textContent = COPY.pickHint;
      $('uploadStatus').textContent = COPY.pickFound.replace('{n}', heads.length);
      let img;
      try { img = await loadImg(resp.origUrl); } catch (_) { resolve(0); return; }
      const [IW, IH] = resp.j.image_size;                 // הקואורדינטות של heads
      const k = Math.min(1, 720 / Math.max(img.naturalWidth, img.naturalHeight));
      cv.width = Math.round(img.naturalWidth * k); cv.height = Math.round(img.naturalHeight * k);
      const sx = cv.width / IW, sy = cv.height / IH;
      let picked = state.headIdx < heads.length ? state.headIdx : 0;
      const draw = () => {
        const c = cv.getContext('2d');
        c.clearRect(0, 0, cv.width, cv.height);
        c.drawImage(img, 0, 0, cv.width, cv.height);
        heads.forEach((h, i) => {
          const cx = (h.x + h.w / 2) * sx, cy = (h.y + h.h / 2) * sy, r = Math.max(h.w * sx, h.h * sy) * 0.75;
          const on = i === picked;
          c.lineWidth = on ? 5 : 3; c.strokeStyle = on ? '#8E5AAE' : '#FFFFFF';
          c.beginPath(); c.arc(cx, cy, r, 0, Math.PI * 2); c.stroke();
          if (!on) { c.lineWidth = 1; c.strokeStyle = 'rgba(0,0,0,.45)'; c.stroke(); }
          const br = Math.max(14, cv.width / 34);
          c.fillStyle = on ? '#8E5AAE' : '#fff'; c.beginPath(); c.arc(cx, cy - r - br * 0.2, br, 0, Math.PI * 2); c.fill();
          c.lineWidth = 2; c.strokeStyle = '#8E5AAE'; c.stroke();
          c.fillStyle = on ? '#fff' : '#6D3A8E'; c.font = 'bold ' + Math.round(br * 1.2) + 'px system-ui, sans-serif';
          c.textAlign = 'center'; c.textBaseline = 'middle'; c.fillText(String(i + 1), cx, cy - r - br * 0.2 + 1);
        });
      };
      const done = (i) => {
        picked = i; draw();
        cleanup();
        box.hidden = true;
        resolve(i);
      };
      const onCanvas = (e) => {
        const rect = cv.getBoundingClientRect();
        const x = (e.clientX - rect.left) * cv.width / rect.width, y = (e.clientY - rect.top) * cv.height / rect.height;
        let best = 0, bd = Infinity;
        heads.forEach((h, i) => { const d = Math.hypot(x - (h.x + h.w / 2) * sx, y - (h.y + h.h / 2) * sy); if (d < bd) { bd = d; best = i; } });
        done(best);
      };
      const cleanup = () => { cv.removeEventListener('click', onCanvas); };
      btns.innerHTML = '';
      heads.forEach((h, i) => {
        const b = document.createElement('button'); b.type = 'button'; b.textContent = i + 1;
        b.setAttribute('aria-label', 'פנים מספר ' + (i + 1)); b.setAttribute('aria-pressed', String(i === picked));
        b.addEventListener('click', () => done(i));
        btns.appendChild(b);
      });
      cv.addEventListener('click', onCanvas);
      draw();
      box.hidden = false;
      say(COPY.pickTitle + ' ' + COPY.pickFound.replace('{n}', heads.length));
      box.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    });
  }

  /** ממלא את כל הסלוטים מתמונה אחת שיש בה מספיק אנשים, לפי סדר שמאל-לימין. */
  async function autoFillSlots(resp) {
    const n = slotCount();
    const order = resp.j.heads.map((h, i) => ({ i, x: h.x + h.w / 2 })).sort((a, b) => a.x - b.x).slice(0, n);
    for (let s = 0; s < n; s++) {
      syncActiveSlot(); loadSlot(s);
      await applyHead(order[s].i, true, /*quiet*/ s < n - 1);
    }
    loadSlot(0); syncPhotoSlider(); renderSlots(); updateCartGate();
    $('uploadStatus').innerHTML = COPY.autoFilled.replace('{n}', n) +
      ' <button type="button" class="linkbtn" id="headChange">' + COPY.pickChange + '</button>';
    const chg = $('headChange');
    if (chg) chg.addEventListener('click', async () => { const i = await chooseHead(state.headResp, true); await applyHead(i, false); });
    say(COPY.autoFilled.replace('{n}', n));
  }

  /**
   * מיישם ראש שנבחר: התמונה בלי רקע = החיתוך מה-Lambda; "עם הרקע" = אותו
   * אזור מהתמונה המקורית; מיקום הפנים ידוע מהזיהוי — לא צריך לנחש.
   */
  async function applyHead(idx, firstTime, quiet) {
    const resp = state.headResp; if (!resp) return;
    const h = resp.j.heads[idx]; if (!h) return;
    state.headIdx = idx;
    state.origFile = resp.origFile || null;   // המקור של הלקוח — נשלח לעגלה כ-Upload Image
    const headImg = await downscale(await loadImg('data:image/png;base64,' + h.image_data));
    state.imgNoBg = headImg;
    // "עם הרקע": חיתוך של המקור באותו מלבן (crop נתון בקואורדינטות image_size)
    try {
      const orig = await loadImg(resp.origUrl);
      const [IW, IH] = resp.j.image_size;
      const kx = orig.naturalWidth / IW, ky = orig.naturalHeight / IH;
      const [x0, y0, x1, y1] = h.crop;
      const c = document.createElement('canvas');
      c.width = Math.max(1, Math.round((x1 - x0) * kx)); c.height = Math.max(1, Math.round((y1 - y0) * ky));
      c.getContext('2d').drawImage(orig, x0 * kx, y0 * ky, c.width, c.height, 0, 0, c.width, c.height);
      state.imgWithBg = await downscale(await loadImg(c.toDataURL('image/jpeg', 0.92)));
    } catch (_) { state.imgWithBg = headImg; }
    // מרכז הפנים (מהזיהוי) ביחס לחיתוך → זה מה שמתיישב על מרכז החור.
    const [x0, y0, x1, y1] = h.crop;
    const est = estimateHead(headImg);
    state.headEst = {
      hx: (h.x + h.w / 2 - x0) / (x1 - x0),
      hy: (h.y + h.h / 2 - y0) / (y1 - y0),
      hb: (h.y + h.h - y0) / (y1 - y0),             // תחתית תיבת הפנים ≈ הסנטר — למצב צוואר
      hw: est ? est.hw : Math.min(0.95, (h.w * 1.45) / (x1 - x0)),
    };
    afterImageReady('head', quiet);
  }

  for (const inputId of ['file', 'fileCam']) $(inputId).addEventListener('change', (e) => {
    const f = e.target.files[0];
    e.target.value = '';   // כדי שבחירה חוזרת של אותו קובץ תעבוד
    handleFile(f);
  });

  const drop = $('drop');
  ['dragenter', 'dragover'].forEach((n) => drop.addEventListener(n, (e) => {
    e.preventDefault(); drop.classList.add('over');
  }));
  ['dragleave', 'drop'].forEach((n) => drop.addEventListener(n, (e) => {
    e.preventDefault(); drop.classList.remove('over');
  }));
  drop.addEventListener('drop', (e) => handleFile(e.dataTransfer.files[0]));

  // ─────────────────────────────────────────────
  //  תצוגה תלת־ממדית
  // ─────────────────────────────────────────────
  // ═══ למה זה לא חי ═══
  // המנוע חוסם את ה-main thread ~2.2 שניות לכל יצירה, ומריץ שני
  // מעברים כבדים (קדמי + גב). תצוגה חיה בכל הקלדה הייתה מקפיאה את
  // הדפדפן. לכן: הבמה הדו-ממדית מדויקת ומיידית, והתלת-ממד לפי בקשה.
  let loopStarted = false;

  // ═══ קו מתאר יציב — דריסה של סורק המנוע, במוצר 2 בלבד (אלעד, 12.9) ═══
  // הבאג מהאייפון: אחרי "יצירת הכרית" התקבל מלבן. המנגנון (נמדד בכרום):
  // traceContourFromGrid של המנוע (custom-script.js) עוקב אחרי פיקסלי הקצה
  // בשיטת Moore עם "קפיצות", אבל מקבל גם שכן שכבר ביקרו בו — ולכן יכול
  // להיתקע במחזור של 2–4 פיקסלים עד תקרת הצעדים (1.96M). כשהוא נתקע מוקדם,
  // ומכסה פחות מ-50% מפיקסלי הקצה, הוא מחזיר bounding box — מלבן — בשקט.
  // בסילואטים שלנו (איור + ראש, עם חורים וחלקים דקים) הכיסוי הוא 56%–83%,
  // כלומר על סף הנפילה; שינוי של פיקסלים בודדים (למשל ציור קצוות שונה
  // בספארי) הפיל 2 מ-18 תבניות למלבן במדידה.
  //
  // הפתרון: לא נוגעים ב-custom-script.js (משותף למוצר 1). בעמוד הזה בלבד
  // מחליפים את הפונקציה הגלובלית בסורק גבול חיצוני קלאסי (Moore + עצירת
  // Jacob) על הרכיב המחובר הגדול ביותר — דטרמיניסטי, מסיים תמיד, ומתעלם
  // מחורים פנימיים (כרית ממילא לא יכולה להכיל חור). בכל ספק — נופלים
  // חזרה לסורק המקורי, כך שההתנהגות הגרועה ביותר היא בדיוק זו של היום.
  // בונוס: הסורק המקורי רץ פעמיים בכל בנייה עד תקרת הצעדים; זה נחסך.
  const engineTrace = (typeof window.traceContourFromGrid === 'function') ? window.traceContourFromGrid : null;
  let traceStats = { ours: 0, fallback: 0, lastMs: 0, lastPts: 0 };
  function pzTraceContour(grid, W, H) {
    const N = W * H;
    // ── רכיבים מחוברים (8-שכנים) — מוצאים את הגדול ──
    const lab = new Int32Array(N);
    let nl = 0, best = 0, bestSize = 0, second = 0;
    const stack = new Int32Array(N);
    for (let i = 0; i < N; i++) {
      if (!grid[i] || lab[i]) continue;
      nl++; let sp = 0, size = 0; stack[sp++] = i; lab[i] = nl;
      while (sp) {
        const j = stack[--sp]; size++;
        const x = j % W, y = (j / W) | 0;
        for (let dy = -1; dy <= 1; dy++) for (let dx = -1; dx <= 1; dx++) {
          if (!dx && !dy) continue;
          const nx = x + dx, ny = y + dy;
          if (nx < 0 || ny < 0 || nx >= W || ny >= H) continue;
          const k = ny * W + nx;
          if (grid[k] && !lab[k]) { lab[k] = nl; stack[sp++] = k; }
        }
      }
      if (size > bestSize) { second = bestSize; bestSize = size; best = nl; }
      else if (size > second) second = size;
    }
    if (!best) return [];
    // שני גופים גדולים ונפרדים (ראש שלא נוגע בגוף) — המנוע יודע לגשר; אנחנו לא.
    if (second > bestSize * 0.05) return null;
    const fg = (x, y) => x >= 0 && y >= 0 && x < W && y < H && lab[y * W + x] === best;
    // ── נקודת התחלה: הפיקסל העליון-שמאלי של הרכיב ──
    let sx = -1, sy = -1;
    for (let i = 0; i < N && sx < 0; i++) if (lab[i] === best) { sx = i % W; sy = (i / W) | 0; }
    // סדר שעון, מתחיל ממערב: W, NW, N, NE, E, SE, S, SW
    const DX = [-1, -1, 0, 1, 1, 1, 0, -1], DY = [0, -1, -1, -1, 0, 1, 1, 1];
    const DIR_OF = [1, 2, 3, 0, -1, 4, 7, 6, 5];               // (dx,dy) → אינדקס ב-DX/DY
    const out = [{ x: sx, y: sy }];
    let cx = sx, cy = sy, bdir = 0;       // bdir: הכיוון מהפיקסל הנוכחי אל ה-backtrack (מערב בהתחלה)
    const cap = 4 * bestSize + 16;
    let steps = 0, firstNx = -1, firstNy = -1;
    while (steps++ < cap) {
      let found = -1;
      for (let k = 1; k <= 8; k++) {
        const d = (bdir + k) % 8;
        if (fg(cx + DX[d], cy + DY[d])) { found = d; break; }
      }
      if (found < 0) break;                                   // פיקסל בודד
      const nx = cx + DX[found], ny = cy + DY[found];
      // עצירת Jacob: חזרנו להתחלה ועומדים להיכנס לאותו פיקסל שני כמו בהתחלה
      if (cx === sx && cy === sy && out.length > 1 && nx === firstNx && ny === firstNy) break;
      if (out.length === 1) { firstNx = nx; firstNy = ny; }
      // ה-backtrack החדש: השכן שלפני זה שנמצא, ביחס לפיקסל החדש
      const pd = (found + 7) % 8;                             // הכיוון האחרון שהיה רקע
      const bx = cx + DX[pd], by = cy + DY[pd];
      cx = nx; cy = ny;
      out.push({ x: cx, y: cy });
      bdir = DIR_OF[(by - cy + 1) * 3 + (bx - cx + 1)];
      if (cx === sx && cy === sy) {
        // חזרה להתחלה; נמשיך צעד אחד כדי לבדוק את תנאי Jacob בסיבוב הבא
        out.pop();
      }
    }
    if (steps >= cap) return null;                            // לא סגרנו לולאה — לא סומכים על זה
    return out;
  }
  if (engineTrace) {
    window.traceContourFromGrid = function (grid, W, H) {
      const t0 = performance.now();
      let r = null;
      try { r = pzTraceContour(grid, W, H); } catch (e) { r = null; }
      if (r && r.length >= 3) { traceStats.ours++; traceStats.lastMs = performance.now() - t0; traceStats.lastPts = r.length; return r; }
      traceStats.fallback++;
      console.warn('קו המתאר: נופלים לסורק המנוע', { W, H, pts: r ? r.length : null });
      return engineTrace.apply(this, arguments);
    };
  }

  /**
   * בנייה מלאה של הכרית. יקרה — נקראת רק כשהסילואט באמת השתנה:
   * בחירת תבנית, העלאת תמונה, או הזזת תמונה במצב "לפי התמונה".
   */
  function busy(on, label) {
    window.__pzBusy = !!on;
    const el = $('busy');
    if (!el) return;
    el.hidden = !on;
    if (on && label) el.lastChild.nodeValue = label;
    if (!on) {
      building = false;
      $('stage').classList.remove('building');
      // ה-3D מוכן — התצוגה השטוחה יורדת, אלא אם אנחנו במצב שטוח (מובייל 1–3)
      if (!flatMode()) { const f = $('flat'); if (f) f.hidden = true; }
    }
  }

  // ═══ תצוגה שטוחה בזמן שה-3D נבנה ═══
  // הבנייה הראשונה לוקחת כמה שניות. במקום ספינר על במה ריקה, מציגים
  // מיד את ההרכבה הדו-ממדית (שכבר מחושבת) — הלקוח רואה תוצאה ב-0.1
  // שנייה, והתלת-ממד מחליף אותה כשהוא מוכן.
  function showFlatPreview(src) {
    const f = $('flat');
    if (!f || !src) return;
    // ═══ תיקון "דמות על דמות" ═══
    // בלי זה, ההרכבה החדשה מצוירת *מעל* התלת-ממד הישן שממשיך להתרנדר
    // מתחת עד שהמנוע מחליף גיאומטריה (~2s). מסתירים את ה-GL בזמן הבנייה.
    building = true;
    $('stage').classList.add('building');
    const Z = 1000;
    if (f.width !== Z) { f.width = f.height = Z; }
    const x = f.getContext('2d');
    x.clearRect(0, 0, Z, Z);
    // בערך אותו גודל שבו הכרית מופיעה בתלת-ממד — כדי שההחלפה לא תקפוץ
    const k = 0.8, o = (Z - Z * k) / 2;
    x.drawImage(src, o, o, Z * k, Z * k);
    f.hidden = false;
  }

  let needsBuild = false;    // מובייל: השתנה משהו בזמן שהתלת-ממד לא היה מוצג
  let building = false;      // בנייה בעיצומה — ה-GL מוסתר מתחת לתצוגה השטוחה
  function buildPillow(opts) {
    const o = opts || {};
    if (typeof window.generate3D !== 'function') {
      $('stageStatus').innerHTML = '<b>המנוע עדיין נטען.</b>';
      return;
    }
    if (!state.userImg) return;
    // ═══ מצב שטוח: לא בונים עכשיו ═══
    // הלקוח עוד מסדר את הראש/הכיתוב על התמונה השטוחה. הבנייה תקרה
    // פעם אחת, בלחיצה על "יצירת הכרית".
    if (flatMode()) { needsBuild = true; return; }
    needsBuild = false;

    const out = genComposite();
    const octx = out.getContext('2d', { willReadFrequently: true });

    // שער בטיחות: המנוע נתקע לחלוטין על קונטור מנוון.
    const px = octx.getImageData(0, 0, GEN, GEN).data;
    let opaque = 0, sampled = 0;
    for (let i = 3; i < px.length; i += 4 * 37) { sampled++; if (px[i] > 12) opaque++; }
    if (opaque / sampled < 0.02) {
      $('stageStatus').innerHTML = '<b>העיצוב כמעט ריק.</b> מרכזו את התמונה ונסו שוב.';
      return;
    }

    const tpl = templates.find((t) => t.id === state.shape) || {};
    // מרגע זה הגיאומטריה מייצגת את תיבת ההרכבה הזו — כל השוואה עתידית מולה.
    builtCompK = compFit(tpl).k;
    syncActiveSlot();
    builtHeadPos = state.slots.map((sl) => [sl.tx || 0, sl.ty || 0]);
    buildCount++;                       // מונה לבדיקות: כמה בניות גיאומטריה בפועל
    const magnet = tpl.magnetPower != null ? tpl.magnetPower : 0.4;
    const smooth = tpl.smoothPct != null ? tpl.smoothPct : 10;
    const tight = tpl.tightness != null ? tpl.tightness : 2;

    // מחוון עבודה על הבמה במקום כפתור. window.__pzBusy הוא גם
    // הסימן שהבדיקות האוטומטיות ממתינות עליו.
    busy(true, o.quiet ? 'מעדכן את הצורה…' : 'מרנדר תצוגת תלת-ממד…');
    if (!o.quiet) showFlatPreview(out);
    $('stageStatus').textContent = o.quiet ? 'מעדכן את הצורה…' : 'בונה את הכרית…';
    say('בונה את הכרית');

    const t0 = performance.now();
    requestAnimationFrame(() => requestAnimationFrame(() => {
      try {
        // ═══ חובה לפני generate3D ═══
        // כאן נתפסות הטקסטורות שיאפשרו את העדכון החי אחר כך.
        window.PZLiveTexture.beginCapture();
        // הגב של המנוע מגיע באיחור לא ידוע; אחריו — הגב שלנו (ראו סיום הבנייה).
        // לפני שהבנייה הסתיימה אין מה לדחוף — הדחיפה שבסיום תכסה.
        window.PZLiveTexture.onEngineBack(() => { if (pillowBuilt) pushToPillow(); });
        window.generate3D(out.toDataURL('image/png'), true, 1, 6, [0, 0, 1], 128, smooth, true,
          state.pillowColor, '#F6F2F9', 2, 0, 0.5, 0.5 / 6000, 0.05, 3, tight, magnet, 4.0, 3.8);
        if (!loopStarted && typeof animate === 'function') { loopStarted = true; requestAnimationFrame(animate); }
        // מכבים מיד את הסיבוב הפנימי כדי שגם אנימציית הכניסה לא תסתובב.
        if (!spinning && engineStopAutoRotate) engineStopAutoRotate();
      } catch (err) {
        $('stageStatus').innerHTML = '<b>שגיאה במנוע: ' + err.message + '</b>';
        busy(false);
        return;
      }

      // isGeneratingModel מסמן רק את סוף המעבר הקדמי. המעבר האחורי
      // (טקסטורת הגב) עדיין חוסם אחריו. מחכים לחלון שקט.
      let front = 0, last = performance.now(), quiet = 0;
      const poll = setInterval(() => {
        const now = performance.now();
        const gap = now - last; last = now;
        if (!front && window.isGeneratingModel === false) front = now;
        if (front) { if (gap > 200) quiet = 0; else quiet++; }
        if ((front && quiet >= 5) || now - t0 > 45000) {
          clearInterval(poll);
          busy(false);
          pillowBuilt = true;
          // אנימציית הכניסה הסתיימה. משלב 4 הכרית מסתובבת לבד (אלעד, 12.9);
          // לפני כן — עומדת (בדסקטופ היא משטח העריכה בשלבים 2–3).
          setSpin(curStep >= SPIN_STEP);
          const live = window.PZLiveTexture.isReady();
          // ═══ הגב מיד בסיום הבנייה (אלעד, 12.9) ═══
          // המנוע בנה את הגב כעותק של החזית — הכיתוב הפוך מאחור. דוחפים את
          // הגב שלנו (כיתוב משוקף) עכשיו. אם המנוע יעלה את הגב שלו *אחרי*
          // הרגע הזה (requestIdleCallback), onEngineBack ידחוף שוב.
          if (live) pushToPillow();
          $('stageStatus').textContent = live
            ? 'מוכן. שינוי גודל הראש, הכיתוב והצבע מתעדכנים מיד.'
            : 'מוכן.';
          if (!live) {
            // התפיסה נכשלה. לא מסתירים את זה — בלעדיה כל גרירה
            // תעלה 2.2 שניות במקום 1ms, וזה משנה את חוויית המוצר.
            console.warn('PZLiveTexture: התפיסה נכשלה, נופלים לבנייה מלאה בכל שינוי.',
                         window.PZLiveTexture.stats());
          }
          say('הכרית מוכנה');
        }
      }, 100);
    }));
  }


  // ─────────────────────────────────────────────
  //  סיכום ועגלה
  // ─────────────────────────────────────────────
  // ═══ המידה → תוויות ה-CM על הכרית (אלעד, 10.9) ═══
  // במוצר 1 את זה עושה pillow-engine.js: מאזין ללחיצה על מידה, מעדכן את
  // המשתנה הגלובלי maxSizeCm של המנוע (custom-script.js) וקורא
  // regenerateDimensionLabels(). כאן pillow-engine.js לא נטען (הוא קשור
  // ל-DOM של עמוד המוצר), ולכן עושים בדיוק את שתי הפעולות האלה בעצמנו.
  // בלי זה הבורר שינה רק את הסיכום והכרית נשארה על 40.
  // מוצר 1 לא מעורב — אנחנו רק כותבים למשתנה שהמנוע כבר חושף.
  function applySizeToEngine() {
    const m = String(state.size).match(/(\d+(?:\.\d+)?)/);
    const cm = m ? parseFloat(m[1]) : 0;
    if (!cm || typeof maxSizeCm === 'undefined') return;
    if (maxSizeCm === cm) return;
    maxSizeCm = cm;                                   // eslint-disable-line no-global-assign
    // התוויות נוצרות מחדש רק כשיש גיאומטריה. במצב שטוח (מובייל לפני "יצירת
    // הכרית") הבנייה הבאה כבר תקרא את הערך החדש בעצמה.
    if (pillowBuilt && typeof regenerateDimensionLabels === 'function') regenerateDimensionLabels();
  }

  function updateSummary() {
    const box = $('summary');
    box.innerHTML = '';
    const add = (html) => { const s = document.createElement('span'); s.className = 'pill'; s.innerHTML = html; box.appendChild(s); };
    const tpl = templates.find((t) => t.id === state.shape);
    if (tpl) add('צורה: ' + tpl.name);
    add('מידה: ' + state.size.split(' - ')[0]);
    add('צבע: ' + colorName(state.pillowColor) + ' <span class="dot" style="background:' + state.pillowColor + '"></span>');
    // בלי מרכאות — נראו כמו פסיקים באייפון (אלעד, 13.9)
    if (state.text.text.trim()) add('כיתוב: ' + state.text.text.trim().slice(0, 18) + ' <b>' + textPriceLabel() + '</b>');
    if (typeof syncTextAsk === 'function') syncTextAsk();   // המחיר על הכפתור עוקב אחרי המידה
  }

  // ═════════════════════════════════════════════
  //  עגלה אמיתית — כמו מוצר 1 (אלעד, 13.9; שלב C)
  // ═════════════════════════════════════════════
  // בשופיפיי הסקשן מזריק PZ_CFG.product = { id, variants:[{id,size,text}] } מהמוצר
  // שנבחר בהגדרות הסקשן, ו-PZ_CFG.webhooks. בלי CFG (מקומי) — ווריאנטים מדומים,
  // ו-server.js מדמה את /cart/add.js ו-/cart.js. אותו קוד בדיוק בשני המקומות.
  //
  // מה נשלח (אותם שמות כמו מוצר 1 — האוטומציה ב-Make/המפעל מכירה אותם):
  //   id                                  — הווריאנט: Size × כיתוב (עם/ללא)
  //   properties[Processed Image]         — הקובץ למפעל: ההרכבה ב-PRINT px (איור print + ראש + כיתוב)
  //   properties[Processed Image - Back]  — רק כשיש כיתוב: אותה הרכבה, האותיות משוקפות (היריעה מתהפכת בתפירה)
  //   properties[Upload Image]            — התמונה שהלקוח העלה (ו-Upload Image 2 לתבנית זוג)
  //   properties[Custom Color] / [דמות] / [כיתוב] / [גופן הכיתוב] / [צבע הכיתוב]
  //
  // ═══ רזולוציית ההדפסה ═══ התצוגה החיה מצוירת ב-700 (מנוע) / 1000 (במה). הקובץ
  // למפעל מצויר פעם אחת, רק בלחיצה, ב-PRINT=2000: האיור מגיע מ-<id>-print.webp
  // (2000px, tools/upscale-art.py) והראש מה-Lambda עד 1200px. אותו פריים בדיוק —
  // drawFitted מצייר ביחידות מנורמלות, ולכן הראש והכיתוב נוחתים בדיוק במקום של התצוגה.
  const PRINT = 2000;
  const DEV_PRODUCT = { id: 0, variants: [] };   // מקומי: הווריאנט = מחרוזת המידה + הכיתוב (ה-mock מדפיס)
  const PRODUCT = (CFG && CFG.product && Array.isArray(CFG.product.variants)) ? CFG.product : (CFG ? null : DEV_PRODUCT);
  const WEBHOOKS = (CFG && CFG.webhooks) || null;
  const TEXT_OPT = { with: 'עם כיתוב', without: 'ללא כיתוב' };
  // תווית שנשלחת ב-webhook כדי שב-Make יהיה ברור באיזה מודל השתמשו. ניתנת לעריכה בעורך התבנית.
  const WEBHOOK_MODEL = (CFG && CFG.webhookModel) || 'מוצר 2 — כרית דמויות';

  function findVariant() {
    const want = state.text.text.trim() ? TEXT_OPT.with : TEXT_OPT.without;
    if (!PRODUCT) return null;
    if (!PRODUCT.variants.length) return { id: 'dev:' + state.size + '/' + want, price: null };   // מקומי
    // ההתאמה לפי מספר הס״מ — התוויות שונות מעט ("60 ס״מ - XL" כאן, "Extra Large" במוצר)
    const cm = sizeCm();
    const cmOf = (v) => { const m = String(v.size || '').match(/(\d+(?:\.\d+)?)/); return m ? parseFloat(m[1]) : NaN; };
    return PRODUCT.variants.find((v) => cmOf(v) === cm && v.text === want) ||
           PRODUCT.variants.find((v) => cmOf(v) === cm) || null;
  }

  async function ensurePrintArt(tpl) {
    if (!tpl || !tpl.art || tpl.printImg !== undefined) return;
    tpl.printImg = null;
    try { tpl.printImg = await loadImg(ART_URL(tpl.art.replace(/-art\.webp$/, '-print.webp'))); }
    catch (_) { console.warn('איור ההדפסה לא נטען — משתמשים באיור התצוגה (1000px):', tpl.id); }
  }

  /** ההרכבה ברזולוציית הדפסה. mirrorGlyphs — הגב. */
  function renderPrint(mirrorGlyphs) {
    const tpl = templates.find((t) => t.id === state.shape);
    const c = document.createElement('canvas');
    c.width = c.height = PRINT;
    const ctx = c.getContext('2d');
    const saved = tpl ? tpl.artImg : null;
    if (tpl && tpl.printImg) tpl.artImg = tpl.printImg;
    try {
      baseCache = null;                    // בסיס הבד נבנה לפי Z — לא לערבב עם התצוגה
      drawArt(ctx, PRINT);
      window.PZText.draw(ctx, PRINT, state.text, mirrorGlyphs ? { mirrorGlyphs: true } : undefined);
    } finally {
      if (tpl) tpl.artImg = saved;
      baseCache = null;
    }
    return c;
  }
  const toFile = (canvas, name) => new Promise((resolve, reject) =>
    canvas.toBlob((b) => b ? resolve(new File([b], name, { type: 'image/png' })) : reject(new Error('toBlob נכשל')), 'image/png'));

  /** POST ל-/cart/add.js ב-XHR — כדי לקבל אחוזי העלאה אמיתיים (הקבצים כבדים). */
  function cartAdd(fd, onProgress) {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('POST', '/cart/add.js', true);
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.upload.onprogress = (ev) => { if (ev.lengthComputable && onProgress) onProgress(ev.loaded / ev.total); };
      xhr.onload = () => {
        if (xhr.status >= 200 && xhr.status < 300) { try { resolve(JSON.parse(xhr.responseText)); } catch (_) { resolve({}); } }
        else reject(new Error('ההוספה לעגלה נכשלה (' + xhr.status + ')'));
      };
      xhr.onerror = () => reject(new Error('שגיאת רשת בהוספה לעגלה'));
      xhr.send(fd);
    });
  }

  // ═══ למה query string ולא JSON בגוף (אלעד, 13.9) ═══
  // POST חוצה-דומיין עם Content-Type: application/json אינו בקשה "פשוטה" לפי CORS
  // (רק x-www-form-urlencoded / multipart / text-plain הם), ולכן הדפדפן שולח קודם
  // preflight ריק מסוג OPTIONS. Make סופר את ה-OPTIONS כהפעלה ומציג bundle ריק,
  // וה-POST עם הנתונים נחסם אחר כך ולא מגיע כלל. זה מה שקרה גם במוצר 1.
  // query string בלי כותרות מותאמות = בקשה פשוטה (אין preflight), ו-Make מפרסר אותו לשדות.
  // sendBeacon נבחר כי הוא שורד ניווט: ב"קנייה עכשיו" אנחנו עוברים ל-/checkout מיד,
  // ו-fetch רגיל היה עלול להיקטע באוויר. keepalive ב-fetch הוא הגיבוי לדפדפן בלי sendBeacon.
  // ═══ מובייל או דסקטופ (אלעד, 13.9) ═══
  // device נקבע לפי isMobileLayout() — בדיוק אותה פונקציה שהאפליקציה כבר משתמשת בה
  // כדי להחליט איך להציג את האשף. כלומר הערך הוא מה שהלקוח **באמת ראה**, ולא ניחוש
  // לפי user agent. screen ו-touch מאפשרים להבדיל אייפון אמיתי מחלון דסקטופ צר.
  function deviceInfo() {
    return {
      device: isMobileLayout() ? 'mobile' : 'desktop',
      screen: window.innerWidth + 'x' + window.innerHeight,
      touch: (navigator.maxTouchPoints || 0) > 0 ? 'yes' : 'no',
    };
  }
  function webhookParams(action, variantId) {
    const tpl = templates.find((t) => t.id === state.shape);
    const dev = deviceInfo();
    return new URLSearchParams({
      action: action,
      model: WEBHOOK_MODEL,
      product_name: (PRODUCT && PRODUCT.title) || WEBHOOK_MODEL,
      product_id: String(PRODUCT ? PRODUCT.id : 0),
      variant_id: String(variantId),
      quantity: '1',
      size: String(state.size || '').split(' - ')[0],
      character: (tpl && tpl.name) || '',
      color: state.pillowColor || '',
      has_text: state.text.text.trim() ? 'yes' : 'no',
      device: dev.device,
      screen: dev.screen,
      touch: dev.touch,
      // אותה כתובת שה-Lambda מדווח ב-"שימוש במודל" — המפתח שמחבר את שתי השורות בגיליון
      image_url: state.imageUrl || '',
    });
  }
  function runWebhook(url, action, variantId) {
    if (!url) return;
    try {
      const full = url + (url.indexOf('?') > -1 ? '&' : '?') + webhookParams(action, variantId).toString();
      if (navigator.sendBeacon) { try { if (navigator.sendBeacon(full)) return; } catch (e) { /* נופלים ל-fetch */ } }
      fetch(full, { method: 'POST', mode: 'no-cors', keepalive: true })
        .catch((e) => console.warn('webhook נכשל:', e));
    } catch (e) { console.warn('webhook:', e); }
  }
  window.__pzWebhookUrl = (action, variantId) => {
    const u = (WEBHOOKS && WEBHOOKS[action === 'buy_now' ? 'buy' : 'add']) || 'https://example.invalid/hook';
    return u + '?' + webhookParams(action, variantId).toString();
  };   // לבדיקות

  function updateCartCount() {
    fetch('/cart.js').then((r) => r.json()).then((cart) => {
      document.querySelectorAll('.cart-count, .cart-item-count, [data-cart-count]').forEach((el) => { el.textContent = cart.item_count; });
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      const c = $('cartPopupCount'); if (c) c.textContent = cart.item_count;
    }).catch(() => {});
  }

  /** אוסף את כל מה שנשלח. מחזיר { fd, variant, previewUrl } או זורק שגיאה עם הודעה ללקוח. */
  async function buildCartForm(onStep) {
    const tpl = templates.find((t) => t.id === state.shape);
    const hasText = !!state.text.text.trim();
    if (!PRODUCT) throw new Error('המוצר לא מוגדר בהגדרות הסקשן — לא ניתן להוסיף לעגלה.');
    const variant = findVariant();
    if (!variant) throw new Error('לא נמצא ווריאנט למידה ' + state.size + '.');
    // ═══ שומר: כיתוב מחוץ לגבול לא נשלח למפעל ═══ (כמו במוצר 1)
    if (hasText && textViolations() > 0) throw new Error('הכיתוב חורג מגבול הכרית. הזיזו או קצרו אותו לפני ההוספה לעגלה.');

    onStep('מכין את הקובץ להדפסה…');
    await ensurePrintArt(tpl);
    const front = renderPrint(false);
    const frontFile = await toFile(front, 'pillow-front.png');
    let backFile = null;
    if (hasText) backFile = await toFile(renderPrint(true), 'pillow-back.png');

    const fd = new FormData();
    fd.append('id', String(variant.id));
    fd.append('quantity', '1');
    fd.append('properties[Custom Color]', state.pillowColor);
    if (tpl) fd.append('properties[דמות]', tpl.name);
    fd.append('properties[Processed Image]', frontFile, frontFile.name);
    if (backFile) fd.append('properties[Processed Image - Back]', backFile, backFile.name);
    if (hasText) {
      const font = window.PZText.FONTS.find((f) => f.id === state.text.font);
      fd.append('properties[כיתוב]', state.text.text.trim());
      fd.append('properties[גופן הכיתוב]', font ? font.label : state.text.font);
      fd.append('properties[צבע הכיתוב]', state.text.color);
    }
    // התמונה המקורית של הלקוח — כפי שהועלתה (אחרי הכנה), לכל סלוט מלא
    let k = 0;
    for (let i = 0; i < slotCount(tpl); i++) {
      const sl = state.slots[i];
      if (sl && sl.origFile && slotFilled(sl)) { k++; fd.append('properties[Upload Image' + (k > 1 ? ' ' + k : '') + ']', sl.origFile, sl.origFile.name || 'upload.jpg'); }
    }
    // תצוגה לחלון "נוסף לעגלה" — קטנה
    const pv = document.createElement('canvas'); pv.width = pv.height = 500;
    pv.getContext('2d').drawImage(front, 0, 0, 500, 500);
    return { fd, variant, previewUrl: pv.toDataURL('image/png'), frontFile, backFile };
  }

  let cartBusy = false;
  async function submitCart(mode) {
    if (cartBusy) return false;
    const btn = $(mode === 'buy' ? 'buyNow' : 'addCart');
    const other = $(mode === 'buy' ? 'addCart' : 'buyNow');
    const label = btn.textContent;
    cartBusy = true; btn.disabled = true; other.disabled = true;
    $('cartStatus').textContent = '';
    const status = (t) => { btn.textContent = t; $('cartStatus').textContent = t; };
    try {
      const { fd, variant, previewUrl } = await buildCartForm(status);
      runWebhook(WEBHOOKS && (mode === 'buy' ? WEBHOOKS.buy : WEBHOOKS.add), mode === 'buy' ? 'buy_now' : 'add_to_cart', variant.id);
      status(mode === 'buy' ? 'מעבירים לתשלום…' : 'מוסיף לעגלה…');
      const data = await cartAdd(fd, (f) => status((mode === 'buy' ? 'מעבירים לתשלום… ' : 'מוסיף לעגלה… ') + Math.round(f * 100) + '%'));
      window.__pzLastCart = { data, variant: variant.id, mode };   // לבדיקות
      if (mode === 'buy') {
        status('מעבירים לתשלום…');
        if (CFG) { window.location.href = '/checkout'; return true; }
        $('cartStatus').textContent = 'נוסף לעגלה ✓ — מקומית אין checkout (בשופיפיי: מעבר ל-/checkout).';
      } else {
        btn.textContent = '✓ נוסף!';
        $('cartStatus').textContent = 'הכרית נוספה לעגלה ✓';
        updateCartCount();
        showCartPopup(data, previewUrl, variant);
      }
      say('המוצר נוסף לעגלה');
      return true;
    } catch (err) {
      console.warn('הוספה לעגלה:', err);
      $('cartStatus').textContent = err.message || 'משהו השתבש. נסו שוב.';
      btn.textContent = 'שגיאה, נסו שוב';
      return false;
    } finally {
      cartBusy = false;
      setTimeout(() => { btn.textContent = label; btn.disabled = false; other.disabled = false; }, 1800);
    }
  }
  $('addCart').addEventListener('click', () => submitCart('add'));
  $('buyNow').addEventListener('click', () => submitCart('buy'));

  // ═══ חלון "נוסף לעגלה" — כמו במוצר 1 ═══ הכרית שנוצרה, המידה, המחיר, ספירת העגלה.
  function showCartPopup(data, previewUrl, variant) {
    const ov = $('cartPopupOverlay'); if (!ov) return;
    const img = $('cartPopupImage'); if (img) img.src = previewUrl || '';
    const tpl = templates.find((t) => t.id === state.shape);
    const det = $('cartPopupDetails');
    if (det) det.textContent = [tpl ? tpl.name : '', state.size.split(' - ')[0], 'צבע: ' + colorName(state.pillowColor),
                                state.text.text.trim() ? 'כיתוב: ' + state.text.text.trim().slice(0, 18) : ''].filter(Boolean).join(' · ');
    const price = $('cartPopupPrice');
    const cents = data && data.price != null ? data.price : (variant && variant.price != null ? Math.round(variant.price * 100) : null);
    if (price) price.textContent = cents != null ? new Intl.NumberFormat('he-IL', { style: 'currency', currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'ILS' }).format(cents / 100) : '';
    ov.classList.add('active');
    ov.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    const close = $('cartPopupClose'); if (close) close.focus();
  }
  function closeCartPopup() {
    const ov = $('cartPopupOverlay'); if (!ov) return;
    ov.classList.remove('active');
    ov.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  { const ov = $('cartPopupOverlay');
    if (ov) {
      ov.addEventListener('click', (e) => { if (e.target === ov) closeCartPopup(); });
      const c = $('cartPopupClose'); if (c) c.addEventListener('click', closeCartPopup);
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && ov.classList.contains('active')) closeCartPopup(); });
    } }
  // hooks לבדיקות (test/cart-e2e.js): הקבצים שנשלחים, בלי לשלוח
  window.__pzCartForm = async () => { const r = await buildCartForm(() => {}); return { variant: r.variant, front: r.frontFile.size, back: r.backFile ? r.backFile.size : null,
    keys: [...r.fd.keys()], preview: r.previewUrl }; };
  window.__pzRenderPrint = (mirror) => renderPrint(!!mirror).toDataURL();
  window.__pzPrintArt = async () => { const t = templates.find((x) => x.id === state.shape); await ensurePrintArt(t); return t && t.printImg ? [t.printImg.naturalWidth, t.printImg.naturalHeight] : null; };
  window.__pzHeadDrop = () => state.hdy || 0;

  // hook לבדיקות בלבד — מחזיר כמה פיקסלים של הכיתוב חורגים.
  // נחשף כדי שהבדיקה תמדוד את אותו דבר שהקוד מודד, ולא קירוב.
  window.__pzTextOutside = () => textViolations();
  window.__pzTextPos = () => ({ x: state.text.x, y: state.text.y });
  // hook לבדיקות הגב (test/back-face-test.js): שני הקנבסים כפי שנדחפים למנוע.
  window.__pzPair = () => { const p = genPair(); return { front: p.front.toDataURL(), back: p.back.toDataURL() }; };
  window.__pzTextState = () => Object.assign({}, state.text);
  window.__pzArt = () => { const c = document.createElement('canvas'); c.width = c.height = GEN; drawArt(c.getContext('2d', { willReadFrequently: true }), GEN); return c.toDataURL(); };
  window.__pzLiveStats = () => window.PZLiveTexture.stats();
  // hook לבדיקות הראש (test/head-test.js): מצב הראש בלבד, לקריאה.
  // hooks לבדיקות בלבד (test/head-test.js)
  window.__pzDbgSelectSlot = (i) => selectSlot(i);
  window.__pzDbgSlotSrc = (i) => { const sl = state.slots[i]; return sl && sl.userImg ? (sl.userImg.src || '').slice(-64) : null; };
  window.__pzDbgClearSlots = () => {
    state.slots = state.slots.map(() => ({}));
    loadSlot(0); renderSlots(); updateCartGate(); redraw();
  };
  // getter לקריאה בלבד לבדיקות: רק מספרים (בלי אובייקטי Image) כדי שיעבור דרך CDP.
  // מפה של מקומות מותרים לכיתוב, לבדיקות/דיבאג (לא משנה מצב).
  window.__pzTextProbe = (x, y) => textViolations({ x: x, y: y });
  window.__pzTextFits = (x, y) => bestFitAt({ x: x, y: y });          // null = אין מקום גם במינימום
  window.__pzTextNear = (x, y) => nearestFit({ x: x, y: y });        // מובייל: הנקודה החוקית הקרובה לאצבע
  window.__pzTrace = () => Object.assign({}, traceStats);
  window.__pzHeadChin = () => {                                        // הסנטר ביחידות הרכבה — לבדיקת "הראש על הצוואר בכל גודל"
    const img = state.userImg, est = state.headEst; if (!img || !est) return null;
    const maxDim = Math.max(img.width, img.height), Hh = img.height / maxDim * state.tscale * S, W = img.width / maxDim * state.tscale * S;
    const hb = est.hb != null ? est.hb : Math.min(1, est.hy + 0.55 * est.hw * (img.width / img.height));
    return { x: 0.5 + (state.tx + (est.hx - .5) * W) / S, y: 0.5 + (state.ty + (hb - .5) * Hh) / S };
  };             // קו המתאר: כמה פעמים שלנו / נפילה למנוע
  window.__pzSeam = (v) => { SEAM = v; rebuildSafeGrid(); return SEAM; };   // דיבאג/מדידה בלבד
  window.__pzTextSize = () => ({ ratio: state.text.sizeRatio, wanted: state.text.sizeWanted, wrapW: state.text.wrapW,
    lines: window.PZText.measureLayout(window.PZSafeArea.G, state.text).lines });
  window.__pzTpl = (id) => { const t = templates.find((x) => x.id === id); return t ? { id: t.id, mode: t.mode, fit: t.fit, necks: t.necks } : null; };
  // יחס הרוחב של התמונה (רוחב/צד ארוך) — לבדיקות שרוצות לחשב את מרכז *הראש*
  // ולא את מרכז התמונה (הם שונים כשהראש לא ממורכז בתצלום).
  window.__pzImgAspect = () => state.userImg ? state.userImg.width / Math.max(state.userImg.width, state.userImg.height) : null;
  window.__pzState = () => ({ headEst: state.headEst, headIdx: state.headIdx, headResp: state.headResp, shape: state.shape, tx: state.tx, ty: state.ty, tscale: state.tscale, trot: state.trot || 0,
    slotCount: slotCount(), activeSlot: state.activeSlot, filled: state.slots.map((s) => !!s.userImg),
    comp: compFit(templates.find((t) => t.id === state.shape)), builds: buildCount, pillowColor: state.pillowColor });

  // ─────────────────────────────────────────────
  //  אתחול
  // ─────────────────────────────────────────────
  // ═════════════════════════════════════════════
  //  אשף המובייל
  // ═════════════════════════════════════════════
  // אותה תבנית כמו באתר החי. ה-CSS מסתיר את השלבים שאינם פעילים
  // מתחת ל-940px; כאן רק מנהלים איזה שלב פעיל. בדסקטופ הכל גלוי
  // וה-JS הזה לא משפיע על כלום.
  // סדר השלבים (אלעד, 10.9): דמות → תמונה → כיתוב → [יצירת הכרית] → צבע → מידה.
  // "יצירת הכרית" הוא כפתור ההמשך של שלב הכיתוב — משם והלאה הכרית מוצגת.
  const STEP_NAMES = [COPY.step1Title, 'התמונה שלך', 'כיתוב', 'צבע', 'מידה'];
  const CREATE_STEP = 3;   // הכפתור "המשך" של השלב הזה הוא "יצירת הכרית" 
  const SPIN_STEP = 4;     // מכאן הכרית מוכנה: מסתובבת לבד, ואפשר לסובב באצבע
  // צבעי הכרית — במקום אחד, כדי שגם הסיכום ידע להגיד "לבן" ולא רק נקודה.
  // ═══ אותם 10 צבעים כמו במוצר 1 (אלעד, 12.9) ═══ הקודים מהתבנית החיה
  // (quick_color_1..10). בשופיפיי הסקשן חושף אותם כהגדרות ומזריק PZ_CFG.colors.
  const COLOR_NAMES = {
    '#FFFFFF': 'לבן', '#000000': 'שחור', '#808080': 'אפור', '#EF4444': 'אדום', '#F97316': 'כתום',
    '#EC4899': 'ורוד', '#8B5CF6': 'סגול', '#3B82F6': 'כחול', '#06B6D4': 'טורקיז', '#22C55E': 'ירוק',
  };
  const DEFAULT_PILLOW_COLORS = Object.keys(COLOR_NAMES);
  const normHex = (h) => {
    const m = String(h || '').trim().match(/^#?([0-9a-f]{6})$/i);
    return m ? '#' + m[1].toUpperCase() : null;
  };
  const colorName = (hex) => COLOR_NAMES[normHex(hex)] || normHex(hex) || String(hex);
  const PILLOW_COLORS = ((CFG && Array.isArray(CFG.colors) && CFG.colors.map(normHex).filter(Boolean).length)
    ? CFG.colors.map(normHex).filter(Boolean) : DEFAULT_PILLOW_COLORS)
    .map((hex) => ({ name: colorName(hex), hex }));
  const steps = [...document.querySelectorAll('.step[data-step]')];
  let curStep = 1;

  function isMobileLayout() {
    return window.matchMedia('(max-width: 940px)').matches ||
           document.body.classList.contains('mobile-preview');
  }

  // ═══ האשף רץ בכל רוחב מסך ═══
  // בעבר השלבים הוצגו אחד-אחד רק במובייל, ובדסקטופ הכל נערם בעמודה אחת
  // (2,300px). עכשיו אותו אשף בשני המקומות. ההבדל היחיד: בדסקטופ הבמה
  // (התצוגה החיה) נשארת גלויה לצד השלבים; במובייל היא חלק מהזרימה.
  let stepFromHistory = false;
  function showStep(n) {
    const prev = curStep;
    curStep = Math.min(steps.length, Math.max(1, n));
    // כפתור "חזרה" של הטלפון חוזר שלב, לא יוצא מהדף. (רק במובייל — בדסקטופ
    // אין למה לגעת בהיסטוריית הדפדפן.)
    if (isMobileLayout() && !stepFromHistory && curStep !== prev && document.body.classList.contains('has-image')) {
      try { history.pushState({ pzStep: curStep }, ''); } catch (_) {}
    }
    for (const el of steps) {
      el.classList.toggle('is-active', Number(el.dataset.step) === curStep);
    }
    // מחלקת שלב על ה-body — ה-CSS מסתיר את הבמה במובייל בשלב 1 (רק הקטלוג)
    for (let i = 1; i <= steps.length; i++) document.body.classList.toggle('step-' + i, i === curStep);
    const wasFlat = prev <= CREATE_STEP;
    syncStageMode();
    // ═══ מצב הגרירה עוקב אחרי השלב ═══ (שלב 2 = תמונה, שלב 3 = כיתוב בלבד)
    { setMode(stepDragMode()); syncModesVisibility(); }
    // ═══ "יצירת הכרית" ═══ מעבר משלב 3 ל-4 במובייל: עכשיו בונים את התלת-ממד.
    // בדסקטופ הכרית כבר חיה — הכפתור רק ממשיך. (needsBuild מכסה גם חזרה
    // אחורה, שינוי, ולחיצה חוזרת.)
    if (!flatMode() && wasFlat && curStep > CREATE_STEP && isMobileLayout() && (needsBuild || !pillowBuilt)) buildPillow();
    // ═══ סיבוב משלב 4 (אלעד, 12.9) ═══ הכרית מוכנה → מסתובבת לבד; הכפתור הצף
    // עוצר/מפעיל, ואצבע/עכבר מסובבים. חזרה לשלבי העריכה עוצרת ומחזירה לחזית,
    // כדי שהראש והכיתוב יהיו מול הלקוח.
    if (curStep >= SPIN_STEP) {
      if (pillowBuilt && !flatMode() && !building && !spinning) setSpin(true);
    } else if (prev >= SPIN_STEP) {
      if (spinning) setSpin(false);
      if (engineSetRotY) engineSetRotY(0);
      syncRotorFromEngine();
    }
    $('stepbarLabel').textContent =
      'שלב ' + curStep + ' מתוך ' + steps.length + ' · ' + STEP_NAMES[curStep - 1];
    $('stepBack').disabled = curStep === 1;
    $('stepNext').disabled = curStep === steps.length;
    $('stepNext').hidden = curStep === steps.length;   // בסיכום אין "המשך" — רק חזרה
    // ═══ "יצירת הכרית" רק במובייל (אלעד, 10.9) ═══
    // בדסקטופ הכרית חיה כל הזמן — אין מה "ליצור", הכפתור פשוט ממשיך.
    const isCreate = curStep === CREATE_STEP && isMobileLayout();
    $('stepNext').textContent = isCreate ? 'יצירת הכרית ✨' : 'המשך';
    $('stepNext').classList.toggle('create', isCreate);
    const on = document.body.classList.contains('has-image');
    $('stepbar').hidden = !on;
    $('stepnav').hidden = !on;
    // גלילה לראש רק במובייל — בדסקטופ השלבים מתחלפים במקום והבמה נשארת
    if (on && isMobileLayout()) window.scrollTo({ top: 0, behavior: 'smooth' });
    say('שלב ' + curStep + ': ' + STEP_NAMES[curStep - 1]);
  }

  // ═══ זרימת האשף במובייל ═══
  // כמו במוצר החי: בחירת תבנית פותחת מיד את שלב העלאת התמונה. בדסקטופ
  // הכול גלוי ממילא, ולכן זה לא משנה שם.
  // ═══ בחירת דמות לא מקדמת שלב (אלעד, 10.9) ═══
  // לקוחות לוחצים על דמות רק כדי לראות אותה בגדול. המעבר לשלב הבא הוא
  // רק דרך "המשך". הפונקציה נשארת כנקודת קריאה אחת — אם נרצה להחזיר
  // את ההתנהגות, זה שינוי של שורה.
  function advanceAfterShape() { /* לא מתקדמים */ }

  window.addEventListener('popstate', (e) => {
    if (!e.state || !e.state.pzStep || !isMobileLayout()) return;
    stepFromHistory = true; showStep(e.state.pzStep); stepFromHistory = false;
  });
  $('stepBack').addEventListener('click', () => showStep(curStep - 1));
  $('stepNext').addEventListener('click', () => {
    // "המשך" משלב הכיתוב בלי שנבחר "כן" — לא ייתכן כיתוב (ולכן לא חיוב) בלי בחירה מפורשת
    if (curStep === 3 && state.textAsk !== 'yes' && state.text.text.trim()) setTextAsk(null);
    showStep(curStep + 1);
  });
  window.matchMedia('(max-width: 940px)').addEventListener('change', () => { showStep(curStep); applyCatalogFilter(); });

  // ── תצוגת מובייל (כלי פיתוח) ──
  // בשופיפיי הכפתור הזה לא קיים — הסקשן מגיש רק את המוצר. הבדיקה
  // הזו היא מה שמאפשר לאותו קובץ לרוץ בשני המקומות.
  if ($('mobileToggle')) $('mobileToggle').addEventListener('click', () => {
    const on = !document.body.classList.contains('mobile-preview');
    document.body.classList.toggle('mobile-preview', on);
    $('mobileToggle').setAttribute('aria-pressed', String(on));
    // הבמה משנה גודל — הקנבס צריך להתאים את ה-aspect
    setTimeout(() => { if (typeof drawScene === 'function') drawScene(); }, 60);
    showStep(curStep);
    say(on ? 'תצוגת מובייל' : 'תצוגת דסקטופ');
  });

  (async function init() {
    // ═══ תמיד להראות איזה backend פעיל ═══
    // ה-mock מחזיר תמיד את אותה תמונת דוגמה. בלי סימון ברור, כל
    // העלאה נראית כאילו "התמונה שלי לא נקלטה" — וזה בדיוק מה שקרה.
    const tag = $('backendTag');
    if (!tag) { /* שופיפיי — אין תג פיתוח */ }
    else if (USE_MOCK) {
      tag.style.background = '#FFF4D6'; tag.style.color = '#6B4E00';
      tag.innerHTML = '⚠ מצב mock (ברירת מחדל) — <b>מחזיר תמיד את אותה תמונת דוגמה</b>, ' +
        'לא את התמונה שהעליתם. <a href="?backend=head" style="color:#6B4E00">Lambda ראש מקומי (עולה קרדיט)</a> · ' +
        '<a href="?backend=real" style="color:#6B4E00">Lambda של מוצר 1 (עולה קרדיט)</a>';
    } else if (BACKEND === 'head') {
      tag.style.background = '#EAF6EE'; tag.style.color = '#1F5233';
      tag.innerHTML = 'Lambda ראש מקומי · הסרת רקע + חיתוך ראש אמיתיים · עולה קרדיט Replicate בכל העלאה. ' +
        '<a href="?" style="color:#1F5233">חזרה ל-mock</a>';
    } else {
      tag.style.background = '#EAF6EE'; tag.style.color = '#1F5233';
      tag.innerHTML = 'Lambda אמיתי · הסרת רקע אמיתית · עולה קרדיט Replicate בכל העלאה. ' +
        '<a href="?" style="color:#1F5233">חזרה ל-mock</a>';
    }

    buildFonts();
    syncSizeSlider();

    // צבע הכיתוב — אותם 10 צבעים מהירים ואותו מראה כמו צבע הכרית (אלעד, 12.9)
    buildSwatches($('textColors'), PILLOW_COLORS, state.text.color, (c) => {
      setTextColor(c.hex, { history: true, announce: true });
      if (textPickr) { try { textPickr.setColor(c.hex, true); } catch (_) {} }
    }, 'quick-color');
    syncTextColorUI();

    buildSwatches($('pillowColors'), PILLOW_COLORS, state.pillowColor, (c) => {
      setPillowColor(c.hex, { history: true, announce: true });
      if (pickr) { try { pickr.setColor(c.hex, true); } catch (_) {} }
    }, 'quick-color');
    if (CFG && CFG.colorHint) { $('pickrHint').textContent = CFG.colorHint; if ($('textPickrHint')) $('textPickrHint').textContent = CFG.colorHint; }
    syncColorUI();
    initPickr(0);

    const sizes = [['30', 'קטנה'], ['40', 'בינונית'], ['50', 'גדולה'], ['60', 'ענקית']];
    const sb = $('sizes');
    for (const [cm, he] of sizes) {
      const value = cm + ' ס״מ - ' + ({ 30: 'Small', 40: 'Medium', 50: 'Large', 60: 'XL' })[cm];
      const b = document.createElement('button');
      b.type = 'button'; b.className = 'chip';
      b.dataset.value = value;
      b.setAttribute('aria-pressed', String(value === state.size));
      b.innerHTML = '<b>' + cm + ' ס״מ</b><span>' + he + '</span>';
      b.onclick = () => {
        state.size = value;
        [...sb.children].forEach((c) => c.setAttribute('aria-pressed', String(c === b)));
        applySizeToEngine();
        syncDropSlider();   // התווית בס״מ תלויה במידה
        updateSummary(); say('מידה ' + he);
      };
      sb.appendChild(b);
    }

    await loadTemplates();
    await ensureTemplateLoaded(templates.find((t) => t.id === state.shape));
    updateSummary();
    showStep(1);
    // הבמה מוצגת מיד; שאר השלבים ממתינים לתמונה
    $('stepbar').hidden = true;
    $('stepnav').hidden = true;

    // ═══ תמונת דוגמה ═══
    // נטענת ברקע. ברגע שהיא מוכנה, אם הלקוח עוד לא העלה תמונה משלו,
    // נכנסים למצב דוגמה עם התבנית הראשונה — כדי שהעמוד לא ייפתח ריק
    // אלא יראה מיד איך הכרית נראית. ⚠ תמונת דמו מקומית בלבד —
    // להחליף בתמונה נייטרלית לפני עלייה לייב.
    // ═══ תמונת הדמו ═══
    // חיתוך ראש (לא גוף עם רקע) — כך שהדוגמה נראית בדיוק כמו התוצאה האמיתית,
    // והראש יושב על הצוואר במקום להימתח. הקובץ הופק מהצינור האמיתי.
    loadImg((CFG && CFG.demoUrl) || '/dev/shared/sample-demo-head.png').catch(() => loadImg('/dev/shared/sample-demo.jpg')).then((img) => {
      state.sampleImg = img;
      // ראש גזור: הפנים ממלאות את הפריים, הסנטר קרוב לתחתית.
      state.sampleEst = /head\.png$/.test(img.src) ? { hx: .5, hy: .46, hb: .95, hw: .88 } : null;
      resizeSlots();
      if (!state.userImg) enterDemo();
      renderSlots();
    }).catch((e) => console.warn('תמונת הדוגמה לא נטענה', e));

    // הגופנים חייבים להיות טעונים לפני שמציירים אותם על קנבס —
    // אחרת השורה הראשונה מצוירת בגופן הגיבוי ולא מתעדכנת.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => redraw());
      Promise.all(window.PZText.FONTS.map((f) =>
        document.fonts.load(f.weight + ' 48px "' + f.id + '"').catch(() => {})
      )).then(() => redraw());
    }
    // ═══ טקסטים של שלב 1 מהעורך ═══
    // כותרת/הסבר ריקים בעורך = האלמנט מוסתר, כדי שלא יישאר רווח ריק.
    for (const [id, txt] of [['step1Title', COPY.step1Title], ['step1Sub', COPY.step1Sub], ['demoBadge', COPY.demoBadge]]) {
      const el = $(id);
      if (!el) continue;
      el.textContent = txt || '';
      if (id !== 'step1Title') el.hidden = !String(txt || '').trim();
    }
    syncTextAsk();   // שאלת הכיתוב במצב התחלתי (המחיר מהווריאנטים — אחרי ש-PRODUCT הוגדר)
    redraw();
  })();
})();
